webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var DateFunctions = function () {
    function DateFunctions() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateFunctions);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DateFunctions, null, [{
        key: 'currentDateYYYYMMDD',
        value: function currentDateYYYYMMDD() {
            return DateFunctions.datetoYYYYMMDD(new Date());
        }
    }, {
        key: 'currentDatePlus10YYYYMMDD',
        value: function currentDatePlus10YYYYMMDD() {
            var date = new Date();
            date.setYear(date.getFullYear() + 10);
            return DateFunctions.datetoYYYYMMDD(date);
        }
    }, {
        key: 'datetoYYYYMMDD',
        value: function datetoYYYYMMDD(date) {
            var dag = date.getDate();
            var maand = date.getMonth() + 1;
            var jaar = date.getFullYear();
            return jaar + '-' + maand + '-' + dag + ' ';
        }
    }, {
        key: 'datetoYYYYMMDDZero',
        value: function datetoYYYYMMDDZero(date) {
            var dag = ('0' + date.getDate()).slice(-2);
            var maand = ('0' + (date.getMonth() + 1)).slice(-2);
            var jaar = date.getFullYear();
            return jaar + '-' + maand + '-' + dag;
        }
    }, {
        key: 'datetoDDMMYYYY',
        value: function datetoDDMMYYYY(datestring) {
            var splitter = datestring.split('-');
            return splitter[2] + '/' + splitter[1] + '/' + splitter[0];
        }
    }, {
        key: 'datetimetoHHMM',
        value: function datetimetoHHMM(datetimestring) {
            var daguur = datetimestring.split(' ');
            var splitter = daguur[1].split(':');
            return splitter[0] + ':' + splitter[1];
        }
    }, {
        key: 'datetimetoDDMMYYYY',
        value: function datetimetoDDMMYYYY(datetimestring) {
            var daguur = datetimestring.split(' ');
            var splitter = daguur[0].split('-');
            return splitter[2] + '/' + splitter[1] + '/' + splitter[0];
        }
    }, {
        key: 'timetoHHMM',
        value: function timetoHHMM(timestring) {
            var splitter = timestring.split(':');
            return splitter[0] + ':' + splitter[1];
        }
    }, {
        key: 'getMinuten',
        value: function getMinuten(timestring) {
            var splitter = timestring.split(':');
            return parseInt(splitter[0] * 60, 10) + parseInt(splitter[1], 10);
        }
    }, {
        key: 'getSeconden',
        value: function getSeconden(timestring) {
            var splitter = timestring.split(':');
            return parseInt(splitter[0] * 60 * 60, 10) + parseInt(splitter[1] * 60, 10);
        }
    }, {
        key: 'datetoDMYVoluit',
        value: function datetoDMYVoluit(date) {
            var maanden = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

            var dag = date.getDate();
            var maand = maanden[date.getMonth()];
            var jaar = date.getFullYear();
            return dag + ' ' + maand + ' ' + jaar;
        }
    }, {
        key: 'datetoMYVoluit',
        value: function datetoMYVoluit(date) {
            var maanden = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

            var maand = maanden[date.getMonth()];
            var jaar = date.getFullYear();
            return maand + ' ' + jaar;
        }
    }, {
        key: 'datetoYVoluit',
        value: function datetoYVoluit(date) {
            var jaar = date.getFullYear();
            return '' + jaar;
        }
    }, {
        key: 'stringdagVoluit',
        value: function stringdagVoluit(datestring) {
            var date = new Date(datestring);
            var dagen = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

            var dag = dagen[date.getDay()];
            return dag;
        }
    }, {
        key: 'maandVoluit',
        value: function maandVoluit(nummer) {
            var maanden = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
            return maanden[nummer - 1];
        }
    }]);

    return DateFunctions;
}();

/* harmony default export */ __webpack_exports__["a"] = (DateFunctions);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "https://belichtingstool.energieberekeningen.com"
});

instance.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('token');

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getListAfdelingteelt',
        value: function getListAfdelingteelt(withselect, bedrijf, afdeling, historiek) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/list?bedrijf=' + bedrijf + '&afdeling=' + afdeling + '&historiek=' + historiek + '&withselect=' + withselect);
        }
    }, {
        key: 'getDetailAfdelingteelt',
        value: function getDetailAfdelingteelt(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/detail/' + id);
        }
    }, {
        key: 'getKlassiekebelichting',
        value: function getKlassiekebelichting(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/klassiek/' + id);
        }
    }, {
        key: 'createKlassiekebelichting',
        value: function createKlassiekebelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/klassiek', payload);
        }
    }, {
        key: 'updateKlassiekebelichting',
        value: function updateKlassiekebelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/updtklassiek', payload);
        }
    }, {
        key: 'getDliprofiel',
        value: function getDliprofiel(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/dliprofiel/' + id);
        }
    }, {
        key: 'createVastDliprofiel',
        value: function createVastDliprofiel(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/vastdliprofiel', payload);
        }
    }, {
        key: 'createAdaptiefDliprofiel',
        value: function createAdaptiefDliprofiel(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/adaptiefdliprofiel', payload);
        }
    }, {
        key: 'importBelichtingsschema',
        value: function importBelichtingsschema(formData) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/uploadklassiek', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: 'importDLIProfiel',
        value: function importDLIProfiel(formData) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/uploaddliprofiel', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: 'updateDliprofiel',
        value: function updateDliprofiel(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/updtdliprofiel', payload);
        }
    }, {
        key: 'getLichtintegratie',
        value: function getLichtintegratie(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/lichtintegratie/' + id);
        }
    }, {
        key: 'getSamenvatting',
        value: function getSamenvatting(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/samenvatting/' + id);
        }
    }, {
        key: 'getWerkelijkebelichting',
        value: function getWerkelijkebelichting(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/werkelijk/' + id);
        }
    }, {
        key: 'createWerkelijkebelichting',
        value: function createWerkelijkebelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/werkelijk', payload);
        }
    }, {
        key: 'updateWerkelijkebelichting',
        value: function updateWerkelijkebelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/updtwerkelijk', payload);
        }
    }, {
        key: 'getVoorstelBelichting',
        value: function getVoorstelBelichting(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdelingteelt/voorstel/' + id);
        }
    }, {
        key: 'addAfdelingteelt',
        value: function addAfdelingteelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt', payload);
        }
    }, {
        key: 'updateAfdelingteelt',
        value: function updateAfdelingteelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/update/' + payload.id, payload);
        }
    }, {
        key: 'deleteAfdelingteelt',
        value: function deleteAfdelingteelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/delete/' + payload);
        }
    }, {
        key: 'destroyAfdelingteelt',
        value: function destroyAfdelingteelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdelingteelt/destroycomplete/' + payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getListUser',
        value: function getListUser(withselect, typeuser, bedrijf, zoekstring) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/user/list?typeuser=' + typeuser + '&bedrijf=' + bedrijf + '&zoekstring=' + zoekstring + '&withselect=' + withselect);
        }
    }, {
        key: 'getDetailUser',
        value: function getDetailUser(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/user/detail/' + id);
        }
    }, {
        key: 'getDetailMijnAccount',
        value: function getDetailMijnAccount() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/user/detailmijnaccount');
        }
    }, {
        key: 'isValidEmail',
        value: function isValidEmail(id, email) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/auth/validemail?id=' + id + '&email=' + email);
        }
    }, {
        key: 'addUser',
        value: function addUser(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/user', payload);
        }
    }, {
        key: 'mailNewPassword',
        value: function mailNewPassword(email) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/user/sendnewpassword?email=' + email);
        }
    }, {
        key: 'updateUser',
        value: function updateUser(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/user/update/' + payload.id, payload);
        }
    }, {
        key: 'updateMijnAccount',
        value: function updateMijnAccount(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/user/updatemijnaccount/' + payload.id, payload);
        }
    }, {
        key: 'deleteUser',
        value: function deleteUser(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/user/delete/' + payload);
        }
    }, {
        key: 'updatePassword',
        value: function updatePassword(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/user/updatepassword/' + payload.id, payload);
        }
    }, {
        key: 'sendMail',
        value: function sendMail(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/user/sendmail/' + payload.id, payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FadeLoader_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5fe8791f_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_FadeLoader_vue__ = __webpack_require__(391);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FadeLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5fe8791f_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_FadeLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getListAfdeling',
        value: function getListAfdeling(withselect, bedrijf, zoekstring) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdeling/list?bedrijf=' + bedrijf + '&zoekstring=' + zoekstring + '&withselect=' + withselect);
        }
    }, {
        key: 'getDetailAfdeling',
        value: function getDetailAfdeling(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdeling/detail/' + id);
        }
    }, {
        key: 'getBelichtingsuren',
        value: function getBelichtingsuren(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdeling/belichtingsuren/' + id);
        }
    }, {
        key: 'addAfdeling',
        value: function addAfdeling(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdeling', payload);
        }
    }, {
        key: 'updateAfdeling',
        value: function updateAfdeling(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdeling/update/' + payload.id, payload);
        }
    }, {
        key: 'deleteAfdeling',
        value: function deleteAfdeling(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/afdeling/delete/' + payload);
        }
    }, {
        key: 'kopieerAfdeling',
        value: function kopieerAfdeling(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/afdeling/kopieer/' + payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getListBedrijf',
        value: function getListBedrijf(zoekstring) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/bedrijf/list?zoekstring=' + zoekstring);
        }
    }, {
        key: 'getDetailBedrijf',
        value: function getDetailBedrijf(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/bedrijf/detail/' + id);
        }
    }, {
        key: 'addBedrijf',
        value: function addBedrijf(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/bedrijf', payload);
        }
    }, {
        key: 'updateBedrijf',
        value: function updateBedrijf(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/bedrijf/update/' + payload.id, payload);
        }
    }, {
        key: 'deleteBedrijf',
        value: function deleteBedrijf(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/bedrijf/delete/' + payload);
        }
    }, {
        key: 'destroyBedrijf',
        value: function destroyBedrijf(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/bedrijf/destroycomplete/' + payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getAllGlastype',
        value: function getAllGlastype() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/glastype/allbyomschrijving');
        }
    }, {
        key: 'getListGlastype',
        value: function getListGlastype() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/glastype/list');
        }
    }, {
        key: 'getDetailGlastype',
        value: function getDetailGlastype(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/glastype/' + id);
        }
    }, {
        key: 'addGlastype',
        value: function addGlastype(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/glastype', payload);
        }
    }, {
        key: 'updateGlastype',
        value: function updateGlastype(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/glastype/update/' + payload.id, payload);
        }
    }, {
        key: 'deleteGlastype',
        value: function deleteGlastype(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/glastype/delete/' + payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getAllSoortbelichting',
        value: function getAllSoortbelichting() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/soortbelichting/allbynaam');
        }
    }, {
        key: 'getListSoortbelichting',
        value: function getListSoortbelichting() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/soortbelichting/list');
        }
    }, {
        key: 'getDetailSoortbelichting',
        value: function getDetailSoortbelichting(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/soortbelichting/' + id);
        }
    }, {
        key: 'addSoortbelichting',
        value: function addSoortbelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/soortbelichting', payload);
        }
    }, {
        key: 'updateSoortbelichting',
        value: function updateSoortbelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/soortbelichting/update/' + payload.id, payload);
        }
    }, {
        key: 'deleteSoortbelichting',
        value: function deleteSoortbelichting(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/soortbelichting/delete/' + payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getAllTeelt',
        value: function getAllTeelt() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/teelt/allbynaam');
        }
    }, {
        key: 'getListTeelt',
        value: function getListTeelt() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/teelt/list');
        }
    }, {
        key: 'getDetailTeelt',
        value: function getDetailTeelt(id) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/teelt/' + id);
        }
    }, {
        key: 'addTeelt',
        value: function addTeelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/teelt', payload);
        }
    }, {
        key: 'updateTeelt',
        value: function updateTeelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/teelt/update/' + payload.id, payload);
        }
    }, {
        key: 'deleteTeelt',
        value: function deleteTeelt(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/teelt/delete/' + payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartMixed_vue__ = __webpack_require__(571);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartMixed_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_login__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_bedrijf__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_account__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_afdeling__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_afdelingteelt__ = __webpack_require__(294);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    strict: true,
    modules: {
        loginModule: __WEBPACK_IMPORTED_MODULE_3__modules_login__["a" /* default */],
        bedrijfModule: __WEBPACK_IMPORTED_MODULE_4__modules_bedrijf__["a" /* default */],
        accountModule: __WEBPACK_IMPORTED_MODULE_5__modules_account__["a" /* default */],
        afdelingModule: __WEBPACK_IMPORTED_MODULE_6__modules_afdeling__["a" /* default */],
        afdelingteeltModule: __WEBPACK_IMPORTED_MODULE_7__modules_afdelingteelt__["a" /* default */]
    },
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])()]
}));

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f517a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f517a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d304349_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d304349_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f35251f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(432);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f35251f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f11c5654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(450);
function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f11c5654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b5136f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(470);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b5136f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270093a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(484);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270093a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64fb907a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(498);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64fb907a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_mask__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(62);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_mask__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
    }
});

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8150c24e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(235);
function injectStyle (ssrContext) {
  __webpack_require__(231)
  __webpack_require__(233)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8150c24e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Full__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Dashboard__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Login__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Vergeten__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Page404__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_bedrijf_New__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_bedrijf_Index__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_bedrijf_Edit__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_account_New__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_account_Index__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_account_Edit__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_account_Activate__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_account_EditMijnAccount__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_afdeling_New__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_afdeling_Index__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_afdeling_Edit__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_afdelingteelt_New__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_afdelingteelt_Index__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_afdelingteelt_Edit__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_glastype_New__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_glastype_Index__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_glastype_Edit__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_soortbelichting_New__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_soortbelichting_Index__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_soortbelichting_Edit__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_teelt_New__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_teelt_Index__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_teelt_Edit__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_licht_EditDliprofiel__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_licht_EditKlassiek__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_licht_ShowIntegratie__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_licht_ShowSamenvatting__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_licht_EditWerkelijk__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_weer_Voorspelling__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_weerstation_Homepage__ = __webpack_require__(615);



















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: [{
        path: '/',
        redirect: '/home',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_3__containers_Full__["a" /* default */],
        children: [{
            path: 'home',
            name: 'Info',
            component: __WEBPACK_IMPORTED_MODULE_4__views_Dashboard__["a" /* default */]
        }, {
            path: 'mijnaccount',
            name: 'Mijn account',
            component: __WEBPACK_IMPORTED_MODULE_15__pages_account_EditMijnAccount__["a" /* default */]
        }, {
            path: 'beheer',
            name: 'Beheer',
            redirect: '/beheer/bedrijf',
            component: {
                render: function render(c) {
                    return c('router-view');
                }
            },
            children: [{
                path: 'bedrijf',
                name: 'Bedrijven',
                redirect: '/beheer/bedrijf',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-1',
                    component: __WEBPACK_IMPORTED_MODULE_8__pages_bedrijf_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-1',
                    component: __WEBPACK_IMPORTED_MODULE_9__pages_bedrijf_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-1',
                    component: __WEBPACK_IMPORTED_MODULE_10__pages_bedrijf_Edit__["a" /* default */]
                }]
            }, {
                path: 'account',
                name: 'Accounts',
                redirect: '/beheer/account',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-2',
                    alias: 'NewAccount',
                    component: __WEBPACK_IMPORTED_MODULE_11__pages_account_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-2',
                    component: __WEBPACK_IMPORTED_MODULE_12__pages_account_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-2',
                    component: __WEBPACK_IMPORTED_MODULE_13__pages_account_Edit__["a" /* default */]
                }, {
                    path: 'activate/:id',
                    name: 'Activeer-2',
                    component: __WEBPACK_IMPORTED_MODULE_14__pages_account_Activate__["a" /* default */]
                }]
            }, {
                path: 'afdeling',
                name: 'Afdelingen',
                redirect: '/beheer/afdeling',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-3',
                    component: __WEBPACK_IMPORTED_MODULE_16__pages_afdeling_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-3',
                    component: __WEBPACK_IMPORTED_MODULE_17__pages_afdeling_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-3',
                    component: __WEBPACK_IMPORTED_MODULE_18__pages_afdeling_Edit__["a" /* default */]
                }]
            }, {
                path: 'afdelingteelt',
                name: 'Teelten',
                redirect: '/beheer/afdelingteelt',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-6',
                    component: __WEBPACK_IMPORTED_MODULE_19__pages_afdelingteelt_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-6',
                    component: __WEBPACK_IMPORTED_MODULE_20__pages_afdelingteelt_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-6',
                    component: __WEBPACK_IMPORTED_MODULE_21__pages_afdelingteelt_Edit__["a" /* default */]
                }, {
                    path: 'dliprofiel/:id',
                    name: 'DLI profiel',
                    component: __WEBPACK_IMPORTED_MODULE_31__pages_licht_EditDliprofiel__["a" /* default */]
                }, {
                    path: 'klassiek/:id',
                    name: 'Klassiek belichtingsschema',
                    component: __WEBPACK_IMPORTED_MODULE_32__pages_licht_EditKlassiek__["a" /* default */]
                }, {
                    path: 'lichtintegratie/:id',
                    name: 'Lichtintegratie',
                    component: __WEBPACK_IMPORTED_MODULE_33__pages_licht_ShowIntegratie__["a" /* default */]
                }, {
                    path: 'samenvatting/:id',
                    name: 'Lichtintegratie vs. klassiek belichtingsschema',
                    component: __WEBPACK_IMPORTED_MODULE_34__pages_licht_ShowSamenvatting__["a" /* default */]
                }, {
                    path: 'werkelijk/:id',
                    name: 'Werkelijke belichting',
                    component: __WEBPACK_IMPORTED_MODULE_35__pages_licht_EditWerkelijk__["a" /* default */]
                }]
            }, {
                path: 'glastype',
                name: 'Glastypes',
                redirect: '/beheer/glastype',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-4',
                    component: __WEBPACK_IMPORTED_MODULE_22__pages_glastype_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-4',
                    component: __WEBPACK_IMPORTED_MODULE_23__pages_glastype_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-4',
                    component: __WEBPACK_IMPORTED_MODULE_24__pages_glastype_Edit__["a" /* default */]
                }]
            }, {
                path: 'soortbelichting',
                name: 'Soorten belichting',
                redirect: '/beheer/soortbelichting',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-5',
                    component: __WEBPACK_IMPORTED_MODULE_25__pages_soortbelichting_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-5',
                    component: __WEBPACK_IMPORTED_MODULE_26__pages_soortbelichting_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-5',
                    component: __WEBPACK_IMPORTED_MODULE_27__pages_soortbelichting_Edit__["a" /* default */]
                }]
            }, {
                path: 'teelt',
                name: 'Teeltsoorten',
                redirect: '/beheer/teelt',
                component: {
                    render: function render(c) {
                        return c('router-view');
                    }
                },
                children: [{
                    path: 'new',
                    name: 'Nieuw-7',
                    component: __WEBPACK_IMPORTED_MODULE_28__pages_teelt_New__["a" /* default */]
                }, {
                    path: '',
                    name: 'Index-7',
                    component: __WEBPACK_IMPORTED_MODULE_29__pages_teelt_Index__["a" /* default */]
                }, {
                    path: 'edit/:id',
                    name: 'Wijzig-7',
                    component: __WEBPACK_IMPORTED_MODULE_30__pages_teelt_Edit__["a" /* default */]
                }]
            }]
        }, {
            path: 'weer',
            name: 'Weer',
            redirect: '/weer/voorspelling',
            component: {
                render: function render(c) {
                    return c('router-view');
                }
            },
            children: [{
                path: 'voorspelling',
                name: 'Voorspelling',
                component: __WEBPACK_IMPORTED_MODULE_36__pages_weer_Voorspelling__["a" /* default */]
            }, {
                path: 'weerstation',
                name: 'Weerstation',
                component: __WEBPACK_IMPORTED_MODULE_37__pages_weerstation_Homepage__["a" /* default */]
            }]
        }]
    }, {
        path: '/pages',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '404',
            name: 'Page404',
            component: __WEBPACK_IMPORTED_MODULE_7__pages_Page404__["a" /* default */]
        }, {
            path: 'login',
            name: 'Login',
            component: __WEBPACK_IMPORTED_MODULE_5__pages_Login__["a" /* default */]
        },, {
            path: 'vergeten',
            name: 'Wachtwoord vergeten',
            component: __WEBPACK_IMPORTED_MODULE_6__pages_Vergeten__["a" /* default */]
        }]
    }, {
        path: '*',
        redirect: '/pages/404'
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.path !== '/pages/login' && to.path !== '/pages/vergeten' && (!__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.isLoggedIn || __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.expire < new Date().getTime())) {
        __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('logout');
        next({ path: '/pages/login' });
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOGIN */
/* unused harmony export LOGIN_SUCCESS */
/* unused harmony export LOGIN_FAILED */
/* unused harmony export LOGOUT */
/* unused harmony export RESET_LOGIN */
/* unused harmony export USER */
/* unused harmony export USER_SUCCESS */
/* unused harmony export USER_NAME_CHANGE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(11);




var _mutations;



var LOGIN = 'LOGIN';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGIN_FAILED = 'LOGIN_FAILED';
var LOGOUT = 'LOGOUT';
var RESET_LOGIN = 'RESET_LOGIN';

var USER = 'USER';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_NAME_CHANGE = 'USER_NAME_CHANGE';

var initialState = function initialState() {
    return {
        isLoggedIn: !!localStorage.getItem('token'),
        expire: new Date().getTime() + 1000 * 60 * 60 * 24,
        user: {}
    };
};

var module = {
    state: initialState(),
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_LOGIN, function (s) {
        var initial = initialState();
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(initial).forEach(function (key) {
            s[key] = initial[key];
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN, function (state) {
        state.showLoader = true;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN_SUCCESS, function (state) {
        state.isLoggedIn = true;
        state.showLoader = false;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN_FAILED, function (state) {
        state.isLoggedIn = false;
        state.showLoader = false;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, LOGOUT, function (state) {
        state.isLoggedIn = false;
        state.showLoader = false;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, USER, function (state) {
        state.showLoader = true;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, USER_SUCCESS, function (state, payload) {
        state.showLoader = false;
        state.user = payload;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, USER_NAME_CHANGE, function (state, payload) {
        state.user.voornaam = payload.voornaam;
        state.user.naam = payload.naam;
    }), _mutations),
    actions: {
        changeName: function changeName(_ref, payload) {
            var commit = _ref.commit;

            commit(USER_NAME_CHANGE, payload);
        },
        login: function login(_ref2, payload) {
            var commit = _ref2.commit;

            commit(LOGIN);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].post('/auth/login?email=' + payload.account + '&password=' + payload.password).then(function (response) {
                    if (response.data.logon === '1') {
                        localStorage.setItem('token', response.data.token);
                        __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].defaults.headers.common.Authorization = 'Bearer ' + response.data.token;
                        commit(LOGIN_SUCCESS);
                        commit(USER_SUCCESS, response.data.user);
                        resolve(response);
                    } else {
                        commit(LOGIN_FAILED);
                        reject();
                    }
                }, function (error) {
                    commit(LOGIN_FAILED);
                    reject(error);
                });
            });
        },
        logout: function logout(_ref3) {
            var commit = _ref3.commit,
                dispatch = _ref3.dispatch;

            localStorage.removeItem('token');
            localStorage.removeItem('vuex');
            dispatch('resetAccountFilter');
            dispatch('resetBedrijfFilter');
            dispatch('resetAfdelingFilter');
            dispatch('resetAfdelingteeltFilter');
            commit(RESET_LOGIN);
            commit(LOGOUT);
        },
        getUser: function getUser(_ref4) {
            var commit = _ref4.commit;

            commit(USER);
            __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].get('/auth/user').then(function (response) {
                commit(USER_SUCCESS, response.data);
            });
        }
    },
    getters: {
        isLoggedIn: function isLoggedIn(state) {
            return state.isLoggedIn;
        },
        expire: function expire(state) {
            return state.expire;
        },
        user: function user(state) {
            return state.user;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



var _mutations;

var SAVE_BEDRIJF_FILTER = 'SAVE_BEDRIJF_FILTER';
var RESET_BEDRIJF_FILTER = 'RESET_BEDRIJF_FILTER';

var initialState = function initialState() {
    return {
        bedrijfFilter: {
            zoekstring: ''
        }
    };
};

var module = {
    state: initialState(),
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SAVE_BEDRIJF_FILTER, function (state, payload) {
        state.bedrijfFilter = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_BEDRIJF_FILTER, function (s) {
        var initial = initialState();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(initial).forEach(function (key) {
            s[key] = initial[key];
        });
    }), _mutations),
    actions: {
        saveBedrijfFilter: function saveBedrijfFilter(_ref, payload) {
            var commit = _ref.commit;

            commit(SAVE_BEDRIJF_FILTER, payload);
        },
        resetBedrijfFilter: function resetBedrijfFilter(_ref2, payload) {
            var commit = _ref2.commit;

            commit(RESET_BEDRIJF_FILTER, payload);
        }
    },
    getters: {
        bedrijfFilter: function bedrijfFilter(state) {
            return state.bedrijfFilter;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



var _mutations;

var SAVE_ACCOUNT_FILTER = 'SAVE_ACCOUNT_FILTER';
var RESET_ACCOUNT_FILTER = 'RESET_ACCOUNT_FILTER';

var initialState = function initialState() {
    return {
        accountFilter: {
            typeuser: 0,
            bedrijf: 0,
            zoekstring: ''
        }
    };
};

var module = {
    state: initialState(),
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SAVE_ACCOUNT_FILTER, function (state, payload) {
        state.accountFilter = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_ACCOUNT_FILTER, function (s) {
        var initial = initialState();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(initial).forEach(function (key) {
            s[key] = initial[key];
        });
    }), _mutations),
    actions: {
        saveAccountFilter: function saveAccountFilter(_ref, payload) {
            var commit = _ref.commit;

            commit(SAVE_ACCOUNT_FILTER, payload);
        },
        resetAccountFilter: function resetAccountFilter(_ref2, payload) {
            var commit = _ref2.commit;

            commit(RESET_ACCOUNT_FILTER, payload);
        }
    },
    getters: {
        accountFilter: function accountFilter(state) {
            return state.accountFilter;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



var _mutations;

var SAVE_AFDELING_FILTER = 'SAVE_AFDELING_FILTER';
var SET_BEDRIJF_AFDELING_FILTER = 'SET_BEDRIJF_AFDELING_FILTER';
var RESET_AFDELING_FILTER = 'RESET_AFDELING_FILTER';

var initialState = function initialState() {
    return {
        afdelingFilter: {
            bedrijf: 0,
            zoekstring: ''
        }
    };
};

var module = {
    state: initialState(),
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_BEDRIJF_AFDELING_FILTER, function (state, payload) {
        state.afdelingFilter.bedrijf = payload;
        state.afdelingFilter.zoekstring = '';
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SAVE_AFDELING_FILTER, function (state, payload) {
        state.afdelingFilter = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_AFDELING_FILTER, function (s) {
        var initial = initialState();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(initial).forEach(function (key) {
            s[key] = initial[key];
        });
    }), _mutations),
    actions: {
        setBedrijfAfdelingFilter: function setBedrijfAfdelingFilter(_ref, payload) {
            var commit = _ref.commit;

            commit(SET_BEDRIJF_AFDELING_FILTER, payload);
        },
        saveAfdelingFilter: function saveAfdelingFilter(_ref2, payload) {
            var commit = _ref2.commit;

            commit(SAVE_AFDELING_FILTER, payload);
        },
        resetAfdelingFilter: function resetAfdelingFilter(_ref3, payload) {
            var commit = _ref3.commit;

            commit(RESET_AFDELING_FILTER, payload);
        }
    },
    getters: {
        afdelingFilter: function afdelingFilter(state) {
            return state.afdelingFilter;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



var _mutations;

var SAVE_AFDELINGTEELT_FILTER = 'SAVE_AFDELINGTEELT_FILTER';
var SET_AFDELING_AFDELINGTEELT_FILTER = 'SET_AFDELING_AFDELINGTEELT_FILTER';
var RESET_AFDELINGTEELT_FILTER = 'RESET_AFDELINGTEELT_FILTER';

var initialState = function initialState() {
    return {
        afdelingteeltFilter: {
            bedrijf: 0,
            afdeling: 0,
            historiek: false
        }
    };
};

var module = {
    state: initialState(),
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_AFDELING_AFDELINGTEELT_FILTER, function (state, payload) {
        state.afdelingteeltFilter.bedrijf = payload.bedrijfid;
        state.afdelingteeltFilter.afdeling = payload.afdelingid;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SAVE_AFDELINGTEELT_FILTER, function (state, payload) {
        state.afdelingteeltFilter = payload;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_AFDELINGTEELT_FILTER, function (s) {
        var initial = initialState();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(initial).forEach(function (key) {
            s[key] = initial[key];
        });
    }), _mutations),
    actions: {
        setAfdelingAfdelingteeltFilter: function setAfdelingAfdelingteeltFilter(_ref, payload) {
            var commit = _ref.commit;

            commit(SET_AFDELING_AFDELINGTEELT_FILTER, payload);
        },
        saveAfdelingteeltFilter: function saveAfdelingteeltFilter(_ref2, payload) {
            var commit = _ref2.commit;

            commit(SAVE_AFDELINGTEELT_FILTER, payload);
        },
        resetAfdelingteeltFilter: function resetAfdelingteeltFilter(_ref3, payload) {
            var commit = _ref3.commit;

            commit(RESET_AFDELINGTEELT_FILTER, payload);
        }
    },
    getters: {
        afdelingteeltFilter: function afdelingteeltFilter(state) {
            return state.afdelingteeltFilter;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255a9de4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(354);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255a9de4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav_components___ = __webpack_require__(298);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'full',
    components: {
        AppHeader: __WEBPACK_IMPORTED_MODULE_1__nav_components___["d" /* Header */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_1__nav_components___["e" /* Sidebar */],
        AppAside: __WEBPACK_IMPORTED_MODULE_1__nav_components___["a" /* Aside */],
        AppFooter: __WEBPACK_IMPORTED_MODULE_1__nav_components___["c" /* Footer */],
        Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__nav_components___["b" /* Breadcrumb */]
    },
    data: function data() {
        return {
            nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
        };
    },

    computed: {
        name: function name() {
            return this.$route.name;
        },
        list: function list() {
            return this.$route.matched;
        }
    }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    items: [{
        name: 'Home',
        url: '/home',
        icon: 'icon-home',
        level: 0
    }, {
        name: 'Beheer',
        icon: 'icon-puzzle',
        level: 5,
        children: [{
            name: 'Bedrijven',
            url: '/beheer/bedrijf',
            icon: 'icon-flag',
            level: 5
        }, {
            name: 'Accounts',
            url: '/beheer/account',
            icon: 'icon-user',
            level: 7
        }, {
            name: 'Afdelingen',
            url: '/beheer/afdeling',
            icon: 'icon-lock',
            level: 5
        }, {
            name: 'Teelten',
            url: '/beheer/afdelingteelt',
            icon: 'icon-puzzle',
            level: 5
        }, {
            name: 'Glastypes',
            url: '/beheer/glastype',
            icon: 'icon-picture',
            level: 7
        }, {
            name: 'Belichtingssoorten',
            url: '/beheer/soortbelichting',
            icon: 'icon-bulb',
            level: 7
        }, {
            name: 'Teeltsoorten',
            url: '/beheer/teelt',
            icon: 'icon-globe',
            level: 7
        }]
    }, {
        name: 'Weer',
        url: '/weer',
        icon: 'icon-umbrella',
        level: 3,
        children: [{
            name: 'Voorspelling',
            url: '/weer/voorspelling',
            icon: 'icon-control-forward',
            level: 3
        }, {
            name: 'Weerstation',
            url: '/weer/weerstation',
            icon: 'icon-cloud-download',
            level: 3
        }]
    }]
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe9a8a5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(301);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe9a8a5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'aside'
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_336573f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(304);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_336573f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        list: {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        }
    },
    methods: {
        isLast: function isLast(index) {
            return index === this.list.length - 1;
        },
        showName: function showName(item) {
            if (item.meta && item.meta.label) {
                item = item.meta && item.meta.label;
            }
            if (item.name) {
                item = item.name.split('-')[0];
            }
            return item;
        }
    }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd6095ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(307);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd6095ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        variant: {
            type: String
        }
    },
    computed: {
        classList: function classList() {
            return ['callout', this.calloutVariant];
        },
        calloutVariant: function calloutVariant() {
            return this.variant ? 'callout-' + this.variant : '';
        }
    }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_696b37e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(310);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_696b37e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'footer',
    computed: {
        versie: function versie() {
            return 'versie 26.10 (201/534)';
        }
    }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_vm._v("Belichtingstool "+_vm._s(_vm.versie)+" - "),_c('a',{attrs:{"href":"http://www.thomasmore.be"}},[_vm._v("Kenniscentrum Energie (KCE) - Thomas More Kempen")]),_vm._v(" © 2019-2020")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27066ffc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(316);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27066ffc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown__ = __webpack_require__(313);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'header',
    components: {
        HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown__["a" /* default */]
    },
    methods: {
        sidebarToggle: function sidebarToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-hidden');
        },
        sidebarMinimize: function sidebarMinimize(e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-minimized');
        },
        mobileSidebarToggle: function mobileSidebarToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-mobile-show');
        },
        asideToggle: function asideToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('aside-menu-hidden');
        }
    }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0b4349a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0b4349a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'header-dropdown',
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length === 0) {
            this.$store.dispatch('getUser');
        }
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        logout: function logout() {
            this.$store.dispatch('logout');
            this.$router.replace('/pages/login');
        },
        naaraccount: function naaraccount() {
            this.$router.replace('/mijnaccount');
        }
    }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/0.png","alt":"account"}})]),_vm._v(" "),_c('b-dropdown-item',{staticStyle:{"background-color":"#79d7ff","pointer-events":"none"},on:{"click":_vm.naaraccount}},[_c('i',{staticClass:"fa fa-user",staticStyle:{"color":"inherit"}}),_vm._v("  "+_vm._s(_vm.user.voornaam)+" "+_vm._s(_vm.user.naam)+" ("+_vm._s(_vm.user.rol)+")")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.naaraccount}},[_c('i',{staticClass:"fa fa-key"}),_vm._v(" Mijn account")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Afmelden")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-nav',{staticClass:"d-md-down-none",attrs:{"is-nav-bar":""}}),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":""}},[_c('HeaderDropdown')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ac9a37_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ac9a37_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarFooter__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarForm__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarHeader__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarMinimizer__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(347);












/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar',
    props: {
        navItems: {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        }
    },
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length === 0) {
            this.$store.dispatch('getUser');
        }
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    components: {
        SidebarFooter: __WEBPACK_IMPORTED_MODULE_1__SidebarFooter__["a" /* default */],
        SidebarForm: __WEBPACK_IMPORTED_MODULE_2__SidebarForm__["a" /* default */],
        SidebarHeader: __WEBPACK_IMPORTED_MODULE_3__SidebarHeader__["a" /* default */],
        SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_4__SidebarMinimizer__["a" /* default */],
        SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
        SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
        SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
        SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */]
    },
    methods: {
        handleClick: function handleClick(e) {
            e.preventDefault();
            e.target.parentElement.classList.toggle('open');
        }
    }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae8f199c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(322);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae8f199c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-footer'
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dfbcca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(325);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dfbcca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-form'
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2a51b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(328);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2a51b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-header'
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0652c14d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(331);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0652c14d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-minimizer',
    methods: {
        sidebarMinimize: function sidebarMinimize() {
            document.body.classList.toggle('sidebar-minimized');
        },
        brandMinimize: function brandMinimize() {
            document.body.classList.toggle('brand-minimized');
        }
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a81de466_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(335);
function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a81de466_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClick: function handleClick(e) {
            e.preventDefault();
            e.target.parentElement.classList.toggle('open');
        }
    }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle bold",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c27cf36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(339);
function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c27cf36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-nav-link',
    props: {
        name: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        badge: {
            type: Object,
            default: function _default() {}
        },
        variant: {
            type: String,
            default: ''
        }
    },
    computed: {
        classList: function classList() {
            return ['nav-link', this.linkVariant];
        },
        linkVariant: function linkVariant() {
            return this.variant ? 'nav-link-' + this.variant : '';
        },
        isExternalLink: function isExternalLink() {
            if (this.url.substring(0, 4) === 'http') {
                return true;
            }
            return false;
        }
    }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n        "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_vm._v("\n          "),_c('i',{class:_vm.icon}),_c('span',{staticClass:"grey"},[_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf623cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(346);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf623cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            type: String,
            default: ''
        },
        classes: {
            type: String,
            default: ''
        },
        wrapper: {
            type: Object,
            default: function _default() {}
        }
    },
    computed: {
        classList: function classList() {
            return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
        },
        itemClasses: function itemClasses() {
            return this.classes ? this.classes.split(' ') : '';
        }
    }
});

/***/ }),
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n            "+_vm._s(_vm.name)+"\n        ")])]:[_vm._v("\n        "+_vm._s(_vm.name)+"\n    ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2965cf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2965cf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-nav-item',
    props: {
        classes: {
            type: String,
            default: ''
        }
    },
    computed: {
        classList: function classList() {
            return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
        },
        itemClasses: function itemClasses() {
            return this.classes ? this.classes.split(' ') : '';
        }
    }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.level <= _vm.user.m)?[(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.level <= _vm.user.m)?[(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]:_vm._e()]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]:_vm._e()]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61eaf129_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61eaf129_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        value: {
            default: true
        },
        uncheckedValue: {
            default: false
        },
        checked: {
            default: false
        },
        type: {
            type: String,
            default: 'default'
        },
        variant: {
            type: String,
            default: ''
        },
        pill: {
            type: Boolean,
            default: false
        },
        on: {
            type: String,
            default: null
        },
        off: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: null
        }
    },
    computed: {
        classList: function classList() {
            return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
        },
        switchType: function switchType() {
            return this.type ? 'switch-' + this.type : 'switch-default';
        },
        switchVariant: function switchVariant() {
            return this.variant ? 'switch-' + this.variant : 'switch-secondary';
        },
        switchPill: function switchPill() {
            return !this.pill ? null : 'switch-pill';
        },
        switchSize: function switchSize() {
            return this.size ? 'switch-' + this.size : '';
        },
        isChecked: function isChecked() {
            return this.checked === this.value;
        },
        isOn: function isOn() {
            return !this.on ? null : true;
        }
    },
    methods: {
        handleChange: function handleChange(_ref) {
            var checked = _ref.target.checked;

            this.$emit('change', checked ? this.value : this.uncheckedValue);
        }
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":"on","data-off":"off"}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a90f482a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(358);
function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a90f482a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dashboard',
    data: function data() {
        return {
            images: {
                eu: "https://belichtingstool.energieberekeningen.com/images" + "/" + "eu.jpg",
                provincie: "https://belichtingstool.energieberekeningen.com/images" + "/" + "provincie.png",
                agentschap: "https://belichtingstool.energieberekeningen.com/images" + "/" + "agentschap.jpg",
                glitch: "https://belichtingstool.energieberekeningen.com/images" + "/" + "glitch.png",
                tm: "https://belichtingstool.energieberekeningen.com/images" + "/" + "tm.png"
            }
        };
    }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card",attrs:{"variant":"accent-danger"}},[_c('div',{staticClass:"card-body smaller"},[_c('p',[_vm._v("Disclaimer:")]),_vm._v(" "),_c('p',[_vm._v("Het advies volgend uit deze tool komt tot stand op basis van de door de teler verstrekte gegevens en een aantal inschattingen.")]),_vm._v(" "),_c('p',[_vm._v("De dienstverleners kunnen niet verantwoordelijk worden gesteld voor de resultaten van de berekening of bedrijfsresultaten na implementatie van het advies.")]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"panel panel-flat"},[_c('div',{staticClass:"panel-body divMulti"},[_c('div',{staticClass:"row"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle"},[_c('img',{attrs:{"src":_vm.images.eu,"height":"55"}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('img',{attrs:{"src":_vm.images.provincie,"height":"65"}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('img',{attrs:{"src":_vm.images.agentschap,"height":"65"}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('img',{attrs:{"src":_vm.images.glitch,"height":"60"}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('img',{attrs:{"src":_vm.images.tm,"height":"50"}})])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card",attrs:{"variant":"accent-danger"}},[_c('div',{staticClass:"card-header"},[_c('div',[_vm._v("Welkom!")])]),_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Deze applicatie is ontwikkeld ter ondersteuning van de teler bij het nemen van beslissingen omtrent\n            de sturing van zijn assimilatiebelichting. De focus hiervan ligt op het energetische verhaal bij\n            de sturing van de assimilatiebelichting. Met deze tool kan een vergelijking gemaakt worden tussen\n            de werkelijke sturing die gebruikt wordt door de teler en het gebruik van lichtintegratie, en dit\n            op vlak van energieverbruik en ontvangen lichthoeveelheid. Belangrijk hierbij op te merken is dat\n            alle lichteenheden uitgedrukt worden in mol/m² en niet in J/cm². De reden hiervoor is dat deze\n            eenheid bespreekt hoeveel licht op de plant valt en wat de plant kan gebruiken om aan fotosynthese\n            te doen (PAR-licht).")]),_vm._v(" "),_c('p',[_vm._v("Meer informatie omtrent lichtintegratie en meer algemeen over belichting in de serre kan teruggevonden\n            worden in de artikels die terug te vinden zijn via volgende websites:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://kce.thomasmore.be/lightman.html","target":"_blank"}},[_vm._v("https://kce.thomasmore.be/lightman.html")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://kce.thomasmore.be/glitch.html","target":"_blank"}},[_vm._v("https://kce.thomasmore.be/glitch.html")]),_vm._v("\n                bij de subactiviteit 'Energie-efficiënte belichtingstechnieken'")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card",attrs:{"variant":"accent-danger"}},[_c('div',{staticClass:"card-header"},[_c('div',[_vm._v("Uitleg bij het gebruik van de belichtingstool")])]),_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("In de linkerkolom op deze website vind je twee grote rubrieken, namelijk 'Beheer' en 'Weer'.\n            De rubriek 'Weer' is onderverdeeld twee tabbladen: 'Voorspelling' en 'Weerstation'.\n            Bij 'Voorspelling' kan je zien hoeveel licht verwacht kan worden in een bepaalde provincie en\n            dit voor de volgende vijf dagen. Deze getallen zijn gebaseerd op data die ter beschikking gesteld\n            worden door Elia. Bij het tabblad 'Weerstation' kan je historische weergegevens terugvinden die\n            opgemeten werden met een weerstation dat geïnstalleerd is op het dak van Thomas More Kempen in Geel.")]),_vm._v(" "),_c('p',[_vm._v("De rubriek 'Beheer' bevat drie tabbladen. Het tabblad 'Bedrijven' geeft een overzicht van de bedrijven\n            waar de gebruiker toegang toe heeft en geeft de mogelijkheid om de gegevens er van aan te passen. Het\n            tabblad 'Afdelingen' geeft een overzicht van de verschillende afdelingen die per bedrijf aanwezig zijn.\n            Belangrijk hierbij is dat de gegevens omtrent de geïnstalleerde belichting hier aangepast dienen te worden.\n            Het laatste, en belangrijkste tabblad is 'Afdelingen'. Hier wordt een overzicht gegeven van de belichting\n            bij de verschillende teelten. Instellingen omtrent de lichtintegratie kunnen hier per teelt worden\n            aangepast. Achter elke teelt staan een aantal symbolen. Hieronder kan je de uitleg er van vinden.")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-nonfluid"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"center"},[_c('i',{staticClass:"fa fa-pencil-square-o blauw"})]),_vm._v(" "),_c('td',[_vm._v("Mogelijkheid tot wijzigen van de eigenschappen van het toegepaste lichtintegratie-schema")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"center"},[_c('i',{staticClass:"fa fa-thermometer-0 blauw"})]),_vm._v(" "),_c('td',[_vm._v("Instellen van de gewenste DLI")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"center"},[_c('i',{staticClass:"fa fa-lightbulb-o blauw"})]),_vm._v(" "),_c('td',[_vm._v("Ingeven van het werkelijk gebruikte belichtingsschema")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"center"},[_c('i',{staticClass:"fa fa-sun-o blauw"})]),_vm._v(" "),_c('td',[_vm._v("Detailanalyse van de assimilatiebelichting als ze gestuurd zou worden volgens lichtintegratie")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"center"},[_c('i',{staticClass:"fa fa-line-chart blauw"})]),_vm._v(" "),_c('td',[_vm._v("Samenvatting en vergelijking van de belichting aangestuurd met het werkelijke belichtingsschema en lichtintegratie")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"center"},[_c('i',{staticClass:"fa fa-clock-o blauw"})]),_vm._v(" "),_c('td',[_vm._v("Tabblad waarin een voorstel wordt gedaan om de belichting aan te sturen bij gebruik van lichtintegratie")])])])]),_vm._v(" "),_c('p',[_vm._v("\n            Bij vragen bij het gebruik van deze belichtingstool of wanneer je wenst dat we jouw gegevens verwijderen, gelieve ons dan te contacteren op volgend e-mailadres:\n            "),_c('a',{attrs:{"href":"mailto:kce@thomasmore.be"}},[_vm._v("kce@thomasmore.be")]),_vm._v(" of\n            "),_c('a',{attrs:{"href":"mailto:jeroen.vanroy@thomasmore.be"}},[_vm._v("jeroen.vanroy@thomasmore.be")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Alle rechten voorbehouden. Niets uit deze uitgave mag worden vermenigvuldigd en/of openbaar gemaakt door middel van druk, fotokopie of op welke andere wijze\n            dan ook zonder voorafgaande toestemming van het bedrijf en de dienstverlener."),_c('br'),_vm._v(" ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4e70d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4e70d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            user: {
                account: '',
                password: ''
            },
            fout: false,
            accepted: false
        };
    },

    methods: {
        accept: function accept() {
            this.accepted = true;
        },
        login: function login() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.$store.dispatch('login', _this.user).then(function () {
                        _this.$router.replace('/home');
                    }, function () {
                        _this.fout = true;
                    }).catch(function () {});
                } else {}
            });
        }
    },
    computed: {
        versie: function versie() {
            return 'versie 26.10 (201/534)';
        }
    },
    components: { CookieLaw: __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default.a }
});

/***/ }),
/* 362 */,
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.accepted)?_c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Aanmelden")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-input-group',{attrs:{"left":"<i class='fa fa-user'></i>"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('account') },attrs:{"type":"email","placeholder":"Account","name":"account"},model:{value:(_vm.user.account),callback:function ($$v) {_vm.$set(_vm.user, "account", $$v)},expression:"user.account"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('account')),expression:"errors.has('account')"}],staticClass:"small text-danger"},[_vm._v("Vul je account (e-mailadres) in")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-input-group',{attrs:{"left":"<i class='fa fa-unlock-alt'></i>"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('password') },attrs:{"type":"password","placeholder":"Wachtwoord","name":"password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"small text-danger"},[_vm._v("Vul je wachtwoord in")])],1),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":_vm.login}},[_vm._v("Aanmelden")])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('router-link',{attrs:{"to":'/pages/vergeten'}},[_vm._v("Wachtwoord vergeten?")])],1)]),_vm._v(" "),_c('div',{staticClass:"small text-danger"},[_c('br'),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fout),expression:"fout"}]},[_vm._v("Het door jou ingevoerde e-mailadres of wachtwoord is ongeldig")])])])]),_vm._v(" "),_c('div',{staticClass:"card text-white bg-primary py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('h2',[_vm._v("Belichtingstool")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.versie))])])])])])])])])]):_vm._e(),_vm._v(" "),_c('footer',[_c('cookie-law',{attrs:{"theme":"base"},on:{"accept":_vm.accept},scopedSlots:_vm._u([{key:"default",fn:function(props){return _c('div',{},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_c('h4',[_vm._v("Deze website maakt gebruik van cookies")]),_vm._v(" "),_c('p',[_vm._v("We gebruiken cookies op onze website om je de best mogelijke ervaring te bieden en je voorkeuren te onthouden. Door op "),_c('i',[_vm._v("Accepteer")]),_vm._v(", te klikken geef je toestemming voor cookies.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary px-4",on:{"click":props.accept}},[_c('span',[_vm._v("Accepteer")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("Belichtingstool "+_vm._s(_vm.versie)+" - "),_c('a',{attrs:{"href":"http://www.thomasmore.be"}},[_vm._v("Kenniscentrum Energie (KCE) - Thomas More Kempen")]),_vm._v(" © 2019-2020")])])])}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted"},[_c('br'),_vm._v("Meld je aan met je e-mailadres")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vergeten_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f0fe31f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vergeten_vue__ = __webpack_require__(366);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vergeten_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f0fe31f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vergeten_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            user: {
                account: ''
            },
            goed: false
        };
    },

    methods: {
        versturen: function versturen() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].mailNewPassword(_this.user.account).then(function () {
                        _this.goed = true;
                    }, function (error) {});
                } else {}
            });
        }
    },
    computed: {
        versie: function versie() {
            return 'versie 26.10 (201/534)';
        }
    }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Wachtwoord vergeten?")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-input-group',{attrs:{"left":"<i class='fa fa-user'></i>"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('account') },attrs:{"type":"email","placeholder":"Account","name":"account"},model:{value:(_vm.user.account),callback:function ($$v) {_vm.$set(_vm.user, "account", $$v)},expression:"user.account"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('account')),expression:"errors.has('account')"}],staticClass:"small text-danger"},[_vm._v("Vul je account (e-mailadres) in")])],1),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":_vm.versturen}},[_vm._v("Versturen")])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('router-link',{attrs:{"to":'/pages/login'}},[_vm._v("Terug naar aanmelden")])],1)]),_vm._v(" "),_c('div',{staticClass:"small"},[_c('br'),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.goed),expression:"goed"}]},[_vm._v("We hebben een e-mail met een nieuw wachtwoord verstuurd naar het opgegeven e-mailadres.")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted"},[_c('br'),_vm._v("Vul hier je e-mailadres in en klik op "),_c('i',[_vm._v("Versturen")]),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4d5f36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(369);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4d5f36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Page404',
    methods: {
        nrhome: function nrhome() {
            this.$router.replace('/home');
        }
    }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_vm._m(0,false,false),_vm._v(" "),_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group justify-content-center"},[_vm._m(1,false,false),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":_vm.nrhome}},[_vm._v("Naar home")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oeps!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("We kunnen de pagina die je zoekt niet vinden.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-home"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e8d132_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(374);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e8d132_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_bedrijf__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(87);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            weerstations: [],
            voorspellingsplaatsen: [],
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_bedrijf__["a" /* default */].getDetailBedrijf(0).then(function (response) {
            _this.weerstations = response.data.weerstations;
            _this.voorspellingsplaatsen = response.data.voorspellingsplaatsen;
        });
    },

    methods: {
        addItem: function addItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_bedrijf__["a" /* default */].addBedrijf(model).then(function () {
                _this2.$router.replace('/beheer/bedrijf');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'weerstations', 'voorspellingsplaatsen', 'isEditing'],
    methods: {
        saveItem: function saveItem() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.$emit('save-item', _this.model);
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        }
    }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Bedrijf")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.naam),expression:"model.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam') },attrs:{"type":"text","id":"naam","name":"naam"},domProps:{"value":(_vm.model.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam')),expression:"errors.has('naam')"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"straatNr"}},[_vm._v("Straat en nummer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.straatNr),expression:"model.straatNr"}],staticClass:"form-control",attrs:{"type":"text","id":"straatNr","name":"straatNr"},domProps:{"value":(_vm.model.straatNr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "straatNr", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"postcode"}},[_vm._v("Postcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.postcode),expression:"model.postcode"}],staticClass:"form-control",attrs:{"type":"text","id":"postcode","name":"postcode"},domProps:{"value":(_vm.model.postcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "postcode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"plaats"}},[_vm._v("Plaats")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.plaats),expression:"model.plaats"}],staticClass:"form-control",attrs:{"type":"text","id":"plaats","name":"plaats"},domProps:{"value":(_vm.model.plaats)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "plaats", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"tel"}},[_vm._v("Telefoonnummer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tel),expression:"model.tel"}],staticClass:"form-control",attrs:{"type":"text","id":"tel","name":"tel"},domProps:{"value":(_vm.model.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tel", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"weerstation"}},[_vm._v("Weerstation "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.weerstation_id),expression:"model.weerstation_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('weerstation') },attrs:{"type":"text","id":"weerstation","name":"weerstation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "weerstation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.weerstations),function(weerstation){return [_c('option',{domProps:{"value":weerstation.id,"selected":weerstation.id == (_vm.model.weerstation && _vm.model.weerstation_id)}},[_vm._v(_vm._s(weerstation.plaats))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('weerstation')),expression:"errors.has('weerstation')"}],staticClass:"small text-danger"},[_vm._v("Kies een weerstation")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"voorspellingsplaats"}},[_vm._v("Weersvoorspelling plaats "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.voorspellingsplaats_id),expression:"model.voorspellingsplaats_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('voorspellingsplaats') },attrs:{"type":"text","id":"voorspellingsplaats","name":"voorspellingsplaats"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "voorspellingsplaats_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.voorspellingsplaatsen),function(voorspellingsplaats){return [_c('option',{domProps:{"value":voorspellingsplaats.id,"selected":voorspellingsplaats.id == (_vm.model.voorspellingsplaats && _vm.model.voorspellingsplaats_id)}},[_vm._v(_vm._s(voorspellingsplaats.plaats))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('voorspellingsplaats')),expression:"errors.has('voorspellingsplaats')"}],staticClass:"small text-danger"},[_vm._v("Kies een plaats")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v(" Annuleren")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.weerstations.length != 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"weerstations":_vm.weerstations,"voorspellingsplaatsen":_vm.voorspellingsplaatsen,"isEditing":false},on:{"save-item":_vm.addItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Toevoegen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Bedrijf werd niet toegevoegd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd63de38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(392);
function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd63de38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_bedrijf__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterForm__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_FadeLoader__ = __webpack_require__(22);








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            items: [],

            warningGeduld: false,
            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },

    computed: {
        currentFilter: function currentFilter() {
            var filter = this.$store.getters.bedrijfFilter;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, filter);
        },
        user: function user() {
            return this.$store.getters.user;
        }
    },
    created: function created() {
        this.getItems();
    },

    methods: {
        getItems: function getItems() {
            var _this = this;

            this.$store.dispatch('saveBedrijfFilter', this.currentFilter);
            __WEBPACK_IMPORTED_MODULE_1__api_bedrijf__["a" /* default */].getListBedrijf(this.currentFilter.zoekstring).then(function (response) {
                _this.items = response.data.items;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_bedrijf__["a" /* default */].deleteBedrijf(id).then(function () {
                _this2.getItems();
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        destroyItem: function destroyItem(id) {
            var _this3 = this;

            this.warningGeduld = true;
            __WEBPACK_IMPORTED_MODULE_1__api_bedrijf__["a" /* default */].destroyBedrijf(id).then(function () {
                _this3.warningGeduld = false;
                _this3.getItems(false);
            }, function (error) {
                _this3.warningGeduld = false;
                _this3.errormsg = error.message;
                _this3.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'filter-form': __WEBPACK_IMPORTED_MODULE_2__FilterForm__["a" /* default */],
        'item-list': __WEBPACK_IMPORTED_MODULE_3__List__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403a02ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403a02ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FilterForm',
    props: ['typeusers', 'currentFilter', 'get-items'],

    methods: {
        retrieveData: function retrieveData() {
            this.$emit('get-items');
        }
    }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam   ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.zoekstring),expression:"currentFilter.zoekstring"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","id":"naam","name":"naam"},domProps:{"value":(_vm.currentFilter.zoekstring)},on:{"keyup":_vm.retrieveData,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentFilter, "zoekstring", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0238308_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(388);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0238308_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false,
            warningModal2: false
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        naarAfdelingen: function naarAfdelingen(id) {
            this.$store.dispatch('setBedrijfAfdelingFilter', id);
            this.$router.push('/beheer/afdeling');
        },
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        },
        bevestigItem2: function bevestigItem2(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal2 = true;
        },
        deleteItem2: function deleteItem2() {
            this.warningModal2 = false;
            this.$emit('destroy-item', this.id);
        }
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_c('a',{attrs:{"href":"javascript:void(0)","title":"Naar afdelingen"},on:{"click":function($event){_vm.naarAfdelingen(item.id)}}},[_vm._v(_vm._s(item.naam))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.straatNr))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.postcode)+" "+_vm._s(item.plaats))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tel))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('router-link',{attrs:{"to":'/beheer/bedrijf/edit/' + item.id,"title":"Bedrijf wijzigen"}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v("\n                         \n                        "),_c('a',{directives:[{name:"show",rawName:"v-show",value:((_vm.user.m >= 7) && (item.deleteok)),expression:"(user.m >= 7) && (item.deleteok)"}],attrs:{"title":"Bedrijf verwijderen","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem(item.id, item.naam)}}},[_c('i',{staticClass:"fa fa-trash"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((! item.deleteok) && (_vm.user.m >= 7)),expression:"(! item.deleteok) && (user.m >= 7)"}]},[_vm._v("     ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:((! item.deleteok) && (_vm.user.m >= 7)),expression:"(! item.deleteok) && (user.m >= 7)"}],attrs:{"title":"Bedrijf verwijderen (incl. alle afdelingen en teelten)","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem2(item.id, item.naam)}}},[_c('i',{staticClass:"fa fa-bell-slash-o"})])],1)])}))]),_vm._v(" "),_c('nav',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.m >= 7),expression:"user.m >= 7"}],staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/bedrijf/new"}},[_vm._v("Bedrijf toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Bedrijf "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem2},model:{value:(_vm.warningModal2),callback:function ($$v) {_vm.warningModal2=$$v},expression:"warningModal2"}},[_vm._v("\n        Bedrijf "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" (incl. alle afdelingen en teelten) wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Naam")]),_vm._v(" "),_c('th',[_vm._v("Adres")]),_vm._v(" "),_c('th',[_vm._v("Plaats")]),_vm._v(" "),_c('th',[_vm._v("Telefoonnummer")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'FadeLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    height: {
      type: String,
      default: '15px'
    },
    width: {
      type: String,
      default: '5px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.height,
        width: this.width,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  },

  computed: {
    ngRadius: function ngRadius() {
      return '-' + this.radius;
    },
    quarter: function quarter() {
      return parseFloat(this.radius) / 2 + parseFloat(this.radius) / 5.5 + 'px';
    },
    ngQuarter: function ngQuarter() {
      return '-' + this.quarter;
    },
    animationStyle1: function animationStyle1() {
      return {
        top: this.radius,
        left: 0,
        animationDelay: '0.12s'
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        top: this.quarter,
        left: this.quarter,
        animationDelay: '0.24s',
        transform: 'rotate(-45deg)'
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        top: 0,
        left: this.radius,
        animationDelay: '0.36s',
        transform: 'rotate(90deg)'
      };
    },
    animationStyle4: function animationStyle4() {
      return {
        top: this.ngQuarter,
        left: this.quarter,
        animationDelay: '0.48s',
        transform: 'rotate(45deg)'
      };
    },
    animationStyle5: function animationStyle5() {
      return {
        top: this.ngRadius,
        left: 0,
        animationDelay: '0.60s'
      };
    },
    animationStyle6: function animationStyle6() {
      return {
        top: this.ngQuarter,
        left: this.ngQuarter,
        animationDelay: '0.72s',
        transform: 'rotate(-45deg)'
      };
    },
    animationStyle7: function animationStyle7() {
      return {
        top: 0,
        left: this.ngRadius,
        animationDelay: '0.84s',
        transform: 'rotate(90deg)'
      };
    },
    animationStyle8: function animationStyle8() {
      return {
        top: this.quarter,
        left: this.ngQuarter,
        animationDelay: '0.96s',
        transform: 'rotate(45deg)'
      };
    }
  }

});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner",style:({position: 'relative', fontSize: 0})},[_c('div',{staticClass:"v-fade v-fade1",style:([_vm.spinnerStyle,_vm.animationStyle1])}),_c('div',{staticClass:"v-fade v-fade2",style:([_vm.spinnerStyle,_vm.animationStyle2])}),_c('div',{staticClass:"v-fade v-fade3",style:([_vm.spinnerStyle,_vm.animationStyle3])}),_c('div',{staticClass:"v-fade v-fade4",style:([_vm.spinnerStyle,_vm.animationStyle4])}),_c('div',{staticClass:"v-fade v-fade5",style:([_vm.spinnerStyle,_vm.animationStyle5])}),_c('div',{staticClass:"v-fade v-fade6",style:([_vm.spinnerStyle,_vm.animationStyle6])}),_c('div',{staticClass:"v-fade v-fade7",style:([_vm.spinnerStyle,_vm.animationStyle7])}),_c('div',{staticClass:"v-fade v-fade8",style:([_vm.spinnerStyle,_vm.animationStyle8])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Bedrijven</strong>"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.m >= 7),expression:"user.m >= 7"}],staticClass:"wrapper"},[_c('filter-form',{attrs:{"currentFilter":_vm.currentFilter},on:{"get-items":_vm.getItems}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem,"destroy-item":_vm.destroyItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Dit bedrijf kan niet verwijderd worden! Aan dit bedrijf zijn nog andere gegevens gekoppeld. "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Bedrijf verwijderen","size":"sm"},model:{value:(_vm.warningGeduld),callback:function ($$v) {_vm.warningGeduld=$$v},expression:"warningGeduld"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Bedrijf (incl. alle afdelingen en teelten) wordt verwijderd. Deze bewerking kan even duren.")])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1933430_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(395);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1933430_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_bedrijf__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(87);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            weerstations: [],
            voorspellingsplaatsen: [],
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_bedrijf__["a" /* default */].getDetailBedrijf(this.$route.params.id).then(function (response) {
            _this.weerstations = response.data.weerstations;
            _this.voorspellingsplaatsen = response.data.voorspellingsplaatsen;
            _this.model = response.data.model;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_bedrijf__["a" /* default */].updateBedrijf(model).then(function () {
                _this2.$router.replace('/beheer/bedrijf');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"weerstations":_vm.weerstations,"voorspellingsplaatsen":_vm.voorspellingsplaatsen,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Bedrijf werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b53d6aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(401);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b53d6aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            typeusers: [],
            bedrijven: [],
            model: {
                tuinderbedrijf_n: []
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].getDetailUser(0).then(function (response) {
            _this.typeusers = response.data.typeusers;
            _this.bedrijven = response.data.bedrijven;
        });
    },
    mounted: function mounted() {
        this.model.begindatum = __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].currentDateYYYYMMDD();
        this.model.einddatum = __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].currentDatePlus10YYYYMMDD();
    },

    methods: {
        addItem: function addItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].addUser(model).then(function () {
                _this2.$router.replace('/beheer/account');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'typeusers', 'bedrijven', 'isEditing'],
    data: function data() {
        return {
            isError: false,
            isErrorEmail: false
        };
    },

    methods: {
        validEmail: function validEmail(mail) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                return true;
            }
            return false;
        },
        checkemail: function checkemail() {
            var _this = this;

            if (this.validEmail(this.model.email)) {
                __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].isValidEmail(this.model.id, this.model.email).then(function (response) {
                    _this.isErrorEmail = response.data === 'false';
                });
            }
        },
        saveItem: function saveItem() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this2.$emit('save-item', _this2.model);
                }
            });
        },
        addBedrijf: function addBedrijf() {
            this.model.tuinderbedrijf_n.push({ user_id: this.model.id,
                bedrijf_id: this.bedrijven[0].id });
        },
        verwijderBedrijf: function verwijderBedrijf(i) {
            this.model.tuinderbedrijf_n.splice(i, 1);
        },
        back: function back() {
            this.$router.go(-1);
        }
    },
    components: {}
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Account")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"voornaam"}},[_vm._v("Voornaam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.voornaam),expression:"model.voornaam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('voornaam') },attrs:{"type":"text","id":"voornaam","name":"voornaam"},domProps:{"value":(_vm.model.voornaam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "voornaam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('voornaam')),expression:"errors.has('voornaam')"}],staticClass:"small text-danger"},[_vm._v("Voornaam is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.naam),expression:"model.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam') },attrs:{"type":"text","id":"naam","name":"naam"},domProps:{"value":(_vm.model.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam')),expression:"errors.has('naam')"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"email"}},[_vm._v("E-mail "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('email') || _vm.isErrorEmail) },attrs:{"type":"text","id":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"keyup":_vm.checkemail,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"small text-danger"},[_vm._v("Ongeldig e-mailadres")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((_vm.isErrorEmail && !_vm.errors.has('email'))),expression:"(isErrorEmail && !errors.has('email'))"}],staticClass:"small text-danger"},[_vm._v("E-mailadres bestaat reeds")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"tel"}},[_vm._v("Telefoonnummer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tel),expression:"model.tel"}],staticClass:"form-control",attrs:{"type":"text","id":"tel","name":"tel"},domProps:{"value":(_vm.model.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tel", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"typeuser"}},[_vm._v("Type "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.typeuser_id),expression:"model.typeuser_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('typeuser') },attrs:{"type":"text","id":"typeuser","name":"typeuser"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "typeuser_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.typeusers),function(typeuser){return [_c('option',{domProps:{"value":typeuser.id,"selected":typeuser.id == (_vm.model.typeuser && _vm.model.typeuser_id)}},[_vm._v(_vm._s(typeuser.naam))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('typeuser')),expression:"errors.has('typeuser')"}],staticClass:"small text-danger"},[_vm._v("Kies een type")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Actief van "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.begindatum),expression:"model.begindatum"}],ref:"begindatum",staticClass:"unstyled",attrs:{"type":"date","name":"begindatum","id":"begindatum"},domProps:{"value":(_vm.model.begindatum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "begindatum", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.begindatum),expression:"!model.begindatum"}],staticClass:"small text-danger"},[_vm._v("Kies een begindatum")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("tot "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.einddatum),expression:"model.einddatum"}],ref:"einddatum",staticClass:"unstyled",attrs:{"type":"date","name":"einddatum","id":"einddatum"},domProps:{"value":(_vm.model.einddatum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "einddatum", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.einddatum),expression:"!model.einddatum"}],staticClass:"small text-danger"},[_vm._v("Kies een einddatum")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-align-justify"}),_c('strong',[_vm._v(" Bedrijven")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_vm._l((_vm.model.tuinderbedrijf_n),function(tuinderbedrijf,index){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-form-fieldset',[_c('b-input-group',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(tuinderbedrijf.bedrijf_id),expression:"tuinderbedrijf.bedrijf_id"}],staticClass:"form-control",attrs:{"type":"text","id":'bedrijfid' + index,"name":"bedrijfid"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tuinderbedrijf, "bedrijf_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.bedrijven),function(bedrijf){return [_c('option',{domProps:{"value":bedrijf.id,"selected":bedrijf.id == tuinderbedrijf.bedrijf_id}},[_vm._v(_vm._s(bedrijf.naam))])]})],2),_vm._v(" "),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.verwijderBedrijf(index)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)],1)],1)],1)])]}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.addBedrijf}},[_c('span',[_vm._v("Bedrijf toevoegen")])])],1)],2)])],1)]),_vm._v(" "),_c('div',{staticStyle:{"height":"17em"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeusers.length != 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"typeusers":_vm.typeusers,"bedrijven":_vm.bedrijven,"isEditing":false},on:{"save-item":_vm.addItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Toevoegen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Account werd niet toegevoegd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410f4bc6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410f4bc6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_account__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterForm__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(407);







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            typeusers: [],
            bedrijven: [],
            items: []
        };
    },

    computed: {
        currentFilter: function currentFilter() {
            var filter = this.$store.getters.accountFilter;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, filter);
        }
    },
    created: function created() {
        this.getItems(true);
    },

    methods: {
        getItems: function getItems(withselect) {
            var _this = this;

            this.$store.dispatch('saveAccountFilter', this.currentFilter);
            __WEBPACK_IMPORTED_MODULE_1__api_account__["a" /* default */].getListUser(withselect, this.currentFilter.typeuser, this.currentFilter.bedrijf, this.currentFilter.zoekstring).then(function (response) {
                if (withselect) {
                    _this.typeusers = response.data.typeusers;
                    _this.typeusers.unshift({ id: 0, naam: '-- Alle --' });
                    _this.bedrijven = response.data.bedrijven;
                    _this.bedrijven.unshift({ id: 0, naam: '-- Alle --' });
                }
                _this.items = response.data.items;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_account__["a" /* default */].deleteUser(id).then(function () {
                _this2.getItems(false);
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'filter-form': __WEBPACK_IMPORTED_MODULE_2__FilterForm__["a" /* default */],
        'item-list': __WEBPACK_IMPORTED_MODULE_3__List__["a" /* default */]
    }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f599521_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__ = __webpack_require__(406);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f599521_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FilterForm',
    props: ['typeusers', 'bedrijven', 'currentFilter', 'get-items'],
    methods: {
        retrieveData: function retrieveData() {
            this.$emit('get-items', false);
        }
    }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"typeuser"}},[_vm._v("Type   ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.typeuser),expression:"currentFilter.typeuser"}],staticClass:"form-control",attrs:{"type":"text","name":"typeuser","id":"typeuser"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "typeuser", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.retrieveData]}},[_vm._v(">\n                    "),_vm._l((_vm.typeusers),function(typeuser){return [_c('option',{domProps:{"value":typeuser.id,"selected":typeuser.id == _vm.currentFilter.typeuser}},[_vm._v(_vm._s(typeuser.naam))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._v("\n                   "),_c('label',{staticClass:"col-form-label",attrs:{"for":"bedrijf"}},[_vm._v("Bedrijf   ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.bedrijf),expression:"currentFilter.bedrijf"}],staticClass:"form-control",attrs:{"type":"text","name":"bedrijf","id":"bedrijf"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "bedrijf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.retrieveData]}},[_vm._v(">\n                    "),_vm._l((_vm.bedrijven),function(bedrijf){return [_c('option',{domProps:{"value":bedrijf.id,"selected":bedrijf.id == _vm.currentFilter.bedrijf}},[_vm._v(_vm._s(bedrijf.naam))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._v("\n                   "),_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam   ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.zoekstring),expression:"currentFilter.zoekstring"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","id":"naam","name":"naam"},domProps:{"value":(_vm.currentFilter.zoekstring)},on:{"keyup":_vm.retrieveData,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentFilter, "zoekstring", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61296a23_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(409);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61296a23_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false
        };
    },

    methods: {
        bedrijven: function bedrijven(item) {
            var resultaat = '';
            item.tuinderbedrijf_n.forEach(function (tuinderbedrijf) {
                resultaat += tuinderbedrijf.bedrijf.naam + ' | ';
            });
            return resultaat.substring(0, resultaat.length - 3);
        },
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        }
    }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',{attrs:{"align":"center"}},[_c('small',[(item.nopw == '1')?_c('i',{staticClass:"fa fa-lock",staticStyle:{"color":"red"}}):(item.actief == '1')?_c('i',{staticClass:"fa fa-unlock",staticStyle:{"color":"green"}}):_c('i',{staticClass:"fa fa-moon-o",staticStyle:{"color":"orange"},attrs:{"variant":"secondary"}})])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(item.einddatum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.voornaam)+" "+_vm._s(item.naam))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.typeuser.naam))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.bedrijven(item)))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('router-link',{attrs:{"to":'/beheer/account/activate/' + item.id,"title":"Account activeren"}},[_c('i',{staticClass:"fa fa-unlock"})]),_vm._v("\n                         \n                        "),_c('router-link',{attrs:{"to":'/beheer/account/edit/' + item.id,"title":"Account wijzigen"}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v("\n                         \n                        "),_c('a',{attrs:{"href":"javascript:void(0)","title":"Account verwijderen"},on:{"click":function($event){_vm.bevestigItem(item.id, item.voornaam + ' ' + item.naam)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])}))]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/account/new"}},[_vm._v("Account toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Account "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Actief tot")]),_vm._v(" "),_c('th',[_vm._v("Naam")]),_vm._v(" "),_c('th',[_vm._v("E-mail")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Bedrijven")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Accounts</strong>"}},[_c('filter-form',{attrs:{"typeusers":_vm.typeusers,"bedrijven":_vm.bedrijven,"currentFilter":_vm.currentFilter},on:{"get-items":_vm.getItems}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Account werd niet verwijderd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7071918f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(413);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7071918f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(88);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            typeusers: [],
            bedrijven: [],
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].getDetailUser(this.$route.params.id).then(function (response) {
            _this.typeusers = response.data.typeusers;
            _this.bedrijven = response.data.bedrijven;
            _this.model = response.data.model;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].updateUser(model).then(function () {
                _this2.$router.replace('/beheer/account');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"typeusers":_vm.typeusers,"bedrijven":_vm.bedrijven,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Account werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7f9d78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__ = __webpack_require__(421);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7f9d78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_pwfunctions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MailForm__ = __webpack_require__(417);






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            foutModal: false,
            okModal: false,
            okMailModal: false,
            errormsg: '',
            model: {
                typeuser: {}
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].getDetailUser(this.$route.params.id).then(function (response) {
            _this.model = response.data.model;
            _this.model.password = __WEBPACK_IMPORTED_MODULE_1__helpers_pwfunctions__["a" /* default */].makepw();
            _this.model.sendmail = true;
        });
    },

    methods: {
        activateAccount: function activateAccount(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].updatePassword(model).then(function () {
                if (_this2.model.sendmail) {
                    __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].sendMail(model).then(function () {
                        _this2.okMailModal = true;
                    }, function (error) {
                        _this2.errormsg = error.message;
                        _this2.foutModal = true;
                    });
                } else {
                    _this2.okModal = true;
                }
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.foutModal = true;
            });
        },
        closedialog: function closedialog() {
            this.foutModal = false;
        },
        closeOKdialog: function closeOKdialog() {
            this.okModal = false;
        },
        goback: function goback() {
            this.$router.replace('/beheer/account');
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_2__MailForm__["a" /* default */]
    }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var PwFunctions = function () {
    function PwFunctions() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PwFunctions);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PwFunctions, null, [{
        key: 'makepw',
        value: function makepw() {
            var text = '';
            var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            for (var i = 0; i < 8; i += 1) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
        }
    }]);

    return PwFunctions;
}();

/* harmony default export */ __webpack_exports__["a"] = (PwFunctions);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailForm_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d570c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailForm_vue__ = __webpack_require__(420);
function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d570c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model'],
    data: function data() {
        return {
            isError: false
        };
    },

    methods: {
        handleChange: function handleChange() {
            this.model.sendmail = !this.model.sendmail;
        },
        saveItem: function saveItem() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.$emit('activate', _this.model);
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        }
    },
    components: {}
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-unlock"}),_c('strong',[_vm._v(" Account")]),_vm._v(" "),_c('small',[_vm._v("activeren")])]),_vm._v(" "),_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('input',{staticStyle:{"display":"none"},attrs:{"autocomplete":"off","name":"hidden","type":"text"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Naam: ")]),_c('td',[_vm._v(_vm._s(_vm.model.voornaam + ' '+ _vm.model.naam))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("E-mail: ")]),_c('td',[_vm._v(_vm._s(_vm.model.email))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Type: ")]),_c('td',[_vm._v(_vm._s(_vm.model.typeuser.naam))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"wachtwoord"}},[_vm._v("Nieuw wachtwoord (automatisch ingesteld na activeren van de account)"),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('wachtwoord') },attrs:{"type":"text","id":"wachtwoord","name":"wachtwoord"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('wachtwoord')),expression:"errors.has('wachtwoord')"}],staticClass:"small text-danger"},[_vm._v("Wachtwoord is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"wachtwoord"}},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('label',{staticClass:"switch switch-text switch-primary"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.model.sendmail},on:{"change":_vm.handleChange}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"ON","data-off":"OFF"}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v("\n                              Mail versturen met wachtwoord\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Actief van "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.begindatum),expression:"model.begindatum"}],ref:"begindatum",staticClass:"unstyled",attrs:{"type":"date","name":"begindatum","id":"begindatum"},domProps:{"value":(_vm.model.begindatum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "begindatum", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.begindatum),expression:"!model.begindatum"}],staticClass:"small text-danger"},[_vm._v("Kies een begindatum")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("tot "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.einddatum),expression:"model.einddatum"}],ref:"einddatum",staticClass:"unstyled",attrs:{"type":"date","name":"einddatum","id":"einddatum"},domProps:{"value":(_vm.model.einddatum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "einddatum", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.einddatum),expression:"!model.einddatum"}],staticClass:"small text-danger"},[_vm._v("Kies een einddatum")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("\n                        Activeren\n                    ")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)]),_vm._v(" "),_c('div',{staticStyle:{"height":"17em"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ('password' in _vm.model)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model},on:{"activate":_vm.activateAccount}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Activeren","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.foutModal),callback:function ($$v) {_vm.foutModal=$$v},expression:"foutModal"}},[_vm._v("\n        FOUT: Account werd niet geactiveerd! "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Activeren","size":"sm"},on:{"ok":_vm.closeOKdialog,"hidden":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"bs",undefined,$event.key)&&_vm._k($event.keyCode,"modal",undefined,$event.key)){ return null; }_vm.goback($event)}},model:{value:(_vm.okModal),callback:function ($$v) {_vm.okModal=$$v},expression:"okModal"}},[_vm._v("\n        Account werd geactiveerd!\n    ")]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Activeren","size":"sm"},on:{"ok":_vm.closeOKdialog,"hidden":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"bs",undefined,$event.key)&&_vm._k($event.keyCode,"modal",undefined,$event.key)){ return null; }_vm.goback($event)}},model:{value:(_vm.okMailModal),callback:function ($$v) {_vm.okMailModal=$$v},expression:"okMailModal"}},[_vm._v("\n        Account werd geactiveerd! Het wachtwoord werd gemaild naar het e-mailadres van de gebruiker.\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMijnAccount_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fba5ece_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMijnAccount_vue__ = __webpack_require__(428);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMijnAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fba5ece_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMijnAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormMijnAccount__ = __webpack_require__(424);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].getDetailMijnAccount().then(function (response) {
            _this.model = response.data.model;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].updateMijnAccount(model).then(function () {
                _this2.$store.dispatch('changeName', model);
                _this2.$router.replace('/home');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__FormMijnAccount__["a" /* default */]
    }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMijnAccount_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa534d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMijnAccount_vue__ = __webpack_require__(427);
function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMijnAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa534d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMijnAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'typeusers', 'bedrijven', 'isEditing'],
    data: function data() {
        return {
            isError: false,
            isErrorEmail: false
        };
    },

    methods: {
        validEmail: function validEmail(mail) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                return true;
            }
            return false;
        },
        checkemail: function checkemail() {
            var _this = this;

            if (this.validEmail(this.model.email)) {
                __WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].isValidEmail(this.model.id, this.model.email).then(function (response) {
                    _this.isErrorEmail = response.data === 'false';
                });
            }
        },
        saveItem: function saveItem() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this2.$emit('save-item', _this2.model);
                }
            });
        }
    },
    components: {}
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Mijn accountgegevens")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('input',{staticStyle:{"display":"none"},attrs:{"autocomplete":"off","name":"hidden","type":"text"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"voornaam"}},[_vm._v("Voornaam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.voornaam),expression:"model.voornaam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('voornaam') },attrs:{"type":"text","id":"voornaam","name":"voornaam"},domProps:{"value":(_vm.model.voornaam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "voornaam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('voornaam')),expression:"errors.has('voornaam')"}],staticClass:"small text-danger"},[_vm._v("Voornaam is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.naam),expression:"model.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam') },attrs:{"type":"text","id":"naam","name":"naam"},domProps:{"value":(_vm.model.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam')),expression:"errors.has('naam')"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"email"}},[_vm._v("E-mail "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('email') || _vm.isErrorEmail) },attrs:{"type":"text","id":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"keyup":_vm.checkemail,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"small text-danger"},[_vm._v("Ongeldig e-mailadres")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((_vm.isErrorEmail && !_vm.errors.has('email'))),expression:"(isErrorEmail && !errors.has('email'))"}],staticClass:"small text-danger"},[_vm._v("E-mailadres bestaat reeds")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"tel"}},[_vm._v("Telefoonnummer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tel),expression:"model.tel"}],staticClass:"form-control",attrs:{"type":"text","id":"tel","name":"tel"},domProps:{"value":(_vm.model.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tel", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"password"}},[_vm._v("Wachtwoord "),_c('i',[_vm._v("(alleen invullen om te wijzigen)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:(''),expression:"''"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('password') },attrs:{"type":"text","id":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"small text-danger"},[_vm._v("Ongeldig e-mailadres")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])])],1)])])],1)]),_vm._v(" "),_c('div',{staticStyle:{"height":"17em"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Account werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16809d90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(433);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16809d90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdeling__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(89);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            bedrijven: [],
            glastypes: [],
            soortbelichtingen: [],
            model: {
                belichting_n: []
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_afdeling__["a" /* default */].getDetailAfdeling(0).then(function (response) {
            _this.bedrijven = response.data.bedrijven;
            _this.glastypes = response.data.glastypes;
            _this.soortbelichtingen = response.data.soortbelichtingen;
        });
    },

    methods: {
        addItem: function addItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdeling__["a" /* default */].addAfdeling(model).then(function () {
                _this2.$router.replace('/beheer/afdeling');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'bedrijven', 'glastypes', 'soortbelichtingen', 'isEditing'],
    methods: {
        komma0: function komma0(waarde) {
            if (isNaN(waarde)) {
                return '#';
            }
            return waarde.toFixed(0);
        },
        berekenFlux: function berekenFlux(i, j) {
            var belichting = this.model.belichting_n[i * 2 + j];
            if (belichting.efficientie && belichting.aantalLampen && belichting.opgenomenVermogenPerLamp && this.model.oppervlakte) {
                this.model.belichting_n[i * 2 + j].fotonflux = this.komma0(belichting.efficientie * belichting.aantalLampen * belichting.opgenomenVermogenPerLamp / this.model.oppervlakte);

                this.model.belichting_n.push({});
                this.model.belichting_n.pop();
            }
        },
        isError: function isError() {
            var fout = false;
            for (var i = 0; i < this.model.belichting_n.length; i += 1) {
                if (this.totbel(i) !== 100) {
                    fout = true;
                }
            }
            return fout;
        },
        saveItem: function saveItem() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this.isError()) {
                        _this.$emit('save-item', _this.model);
                    }
                }
            });
        },
        addBelichting: function addBelichting() {
            this.model.belichting_n.unshift({ id: -1,
                afdeling_id: this.model.id,
                soortbelichting_id: this.soortbelichtingen[0].id,
                deleteok: true,
                schakelniveau_n: [{ id: -1, belichting_id: -1, percentage: 100 }] });
        },
        verwijderBelichting: function verwijderBelichting(i) {
            this.model.belichting_n.splice(i, 1);
        },
        voegtoeSchakelniveau: function voegtoeSchakelniveau(j) {
            this.model.belichting_n[j].schakelniveau_n.push({ id: -1,
                belichting_id: this.model.belichting_n[j].id });
        },
        verwijderSchakelniveau: function verwijderSchakelniveau(j) {
            this.model.belichting_n[j].schakelniveau_n.pop();
        },
        totbel: function totbel(j) {
            var result = 0;
            var belichting = this.model.belichting_n[j];
            if (typeof belichting !== 'undefined') {
                for (var i = 0; i < belichting.schakelniveau_n.length; i += 1) {
                    if (!belichting.schakelniveau_n[i].percentage || belichting.schakelniveau_n[i].percentage !== '') {
                        result += parseInt(belichting.schakelniveau_n[i].percentage, 10) || 0;
                    }
                }
            }
            return result;
        },
        back: function back() {
            this.$router.go(-1);
        }
    },
    computed: {
        processedBelichting: function processedBelichting() {
            var belichtingen = this.model.belichting_n;
            if (typeof belichtingen !== 'undefined') {
                var chunkedArray = [];
                var chunk = 2;
                for (var i = 0, j = 0; i < belichtingen.length; i += chunk, j += 1) {
                    chunkedArray[j] = belichtingen.slice(i, i + chunk);
                }
                return chunkedArray;
            }
            return [];
        }
    }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Afdeling")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.naam),expression:"model.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam') },attrs:{"type":"text","id":"naam","name":"naam"},domProps:{"value":(_vm.model.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam')),expression:"errors.has('naam')"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"bedrijf"}},[_vm._v("Bedrijf "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bedrijf_id),expression:"model.bedrijf_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('bedrijf') },attrs:{"type":"text","id":"bedrijf","name":"bedrijf"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bedrijf_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.bedrijven),function(bedrijf){return [_c('option',{domProps:{"value":bedrijf.id,"selected":bedrijf.id == (_vm.model.bedrijf && _vm.model.bedrijf_id)}},[_vm._v(_vm._s(bedrijf.naam))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bedrijf')),expression:"errors.has('bedrijf')"}],staticClass:"small text-danger"},[_vm._v("Kies een bedrijf")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"glastype"}},[_vm._v("Glastype "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.glastype_id),expression:"model.glastype_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('glastype') },attrs:{"type":"text","id":"glastype","name":"glastype"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "glastype_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.glastypes),function(glastype){return [_c('option',{domProps:{"value":glastype.id,"selected":glastype.id == (_vm.model.glastype && _vm.model.glastype_id)}},[_vm._v(_vm._s(glastype.omschrijving))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('glastype')),expression:"errors.has('glastype')"}],staticClass:"small text-danger"},[_vm._v("Kies een glastype")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"oppervlakte"}},[_vm._v("Oppervlakte "),_c('sup',[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("(m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.oppervlakte),expression:"model.oppervlakte"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('oppervlakte') },attrs:{"type":"number","id":"oppervlakte","name":"oppervlakte"},domProps:{"value":(_vm.model.oppervlakte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "oppervlakte", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('oppervlakte')),expression:"errors.has('oppervlakte')"}],staticClass:"small text-danger"},[_vm._v("Oppervlakte is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"oppervlakte"}},[_vm._v("Breedtegraad "),_c('sup',[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("(graden en minuten)")])]),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.gr),expression:"model.gr"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('gr') },attrs:{"type":"number","id":"gr","name":"gr"},domProps:{"value":(_vm.model.gr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "gr", $event.target.value)}}})]),_c('td',[_vm._v(" graden ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cgr),expression:"model.cgr"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('cgr') },attrs:{"type":"number","id":"cgr","name":"cgr"},domProps:{"value":(_vm.model.cgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cgr", $event.target.value)}}})]),_c('td',[_vm._v(" minuten")])])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('gr') || _vm.errors.has('cgr')),expression:"errors.has('gr') || errors.has('cgr')"}],staticClass:"small text-danger"},[_vm._v("Graden en minuten zijn verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"orientatie"}},[_vm._v("Oriëntatie "),_c('span',{staticClass:"small"},[_vm._v("(graden)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.orientatie),expression:"model.orientatie"},{name:"validate",rawName:"v-validate",value:('min_value:0|max_value:180'),expression:"'min_value:0|max_value:180'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('orientatie') },attrs:{"type":"number","step":"1","min":"0","max":"999","id":"orientatie","name":"orientatie"},domProps:{"value":(_vm.model.orientatie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "orientatie", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('orientatie')),expression:"errors.has('orientatie')"}],staticClass:"small text-danger"},[_vm._v("Oriëntatie is een waarde tussen 0 en 180")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"transmissiecoefficient"}},[_vm._v("Transmissiecoëfficiënt "),_c('sup',[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("(percentage)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.transmissiecoefficient),expression:"model.transmissiecoefficient"},{name:"validate",rawName:"v-validate",value:('required|min_value:0|max_value:100'),expression:"'required|min_value:0|max_value:100'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('transmissiecoefficient') },attrs:{"type":"number","step":".01","min":"0","max":"999.99","id":"transmissiecoefficient","name":"transmissiecoefficient"},domProps:{"value":(_vm.model.transmissiecoefficient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "transmissiecoefficient", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('transmissiecoefficient')),expression:"errors.has('transmissiecoefficient')"}],staticClass:"small text-danger"},[_vm._v("Transmissiecoëfficiënt is een waarde tussen 0 en 100")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"poothoogte"}},[_vm._v("Poothoogte "),_c('span',{staticClass:"small"},[_vm._v("(m)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.poothoogte),expression:"model.poothoogte"}],staticClass:"form-control",attrs:{"type":"number","step":".01","min":"0","max":"99.99","id":"poothoogte","name":"poothoogte"},domProps:{"value":(_vm.model.poothoogte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "poothoogte", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"spantbreedte"}},[_vm._v("Spantbreedte "),_c('span',{staticClass:"small"},[_vm._v("(m)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.spantbreedte),expression:"model.spantbreedte"}],staticClass:"form-control",attrs:{"type":"number","step":".01","min":"0","max":"99.99","id":"spantbreedte","name":"spantbreedte"},domProps:{"value":(_vm.model.spantbreedte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "spantbreedte", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"vakmaat"}},[_vm._v("Vakmaat "),_c('span',{staticClass:"small"},[_vm._v("(m)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vakmaat),expression:"model.vakmaat"}],staticClass:"form-control",attrs:{"type":"number","step":".01","min":"0","max":"99.99","id":"vakmaat","name":"vakmaat"},domProps:{"value":(_vm.model.vakmaat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "vakmaat", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"outline-primary"},on:{"click":_vm.addBelichting}},[_vm._v("Belichting toevoegen")])],1)])])],1)]),_vm._v(" "),_vm._l((_vm.processedBelichting),function(belichtings,indexi){return _c('div',{staticClass:"row"},_vm._l((belichtings),function(belichting,indexj){return _c('div',{staticClass:"col-lg-6"},[_c('b-card',{key:belichting.id,attrs:{"data":belichting}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-align-justify"}),_c('strong',[_vm._v(" Belichting")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveBelichting($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'naamb' + (indexi * 2) + indexj}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.naam),expression:"belichting.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam' + (indexi * 2) + indexj) },attrs:{"type":"text","id":'naamb' + (indexi * 2) + indexj,"name":"naamb","data-vv-name":'naam' + (indexi * 2) + indexj},domProps:{"value":(belichting.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam' + (indexi * 2) + indexj)),expression:"errors.has('naam' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'soortbelichting' + (indexi * 2) + indexj}},[_vm._v("Soort belichting "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(belichting.soortbelichting_id),expression:"belichting.soortbelichting_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('soort' + (indexi * 2) + indexj) },attrs:{"type":"text","id":'soortbelichting' + (indexi * 2) + indexj,"name":"soortbelichting","data-vv-name":'soort' + (indexi * 2) + indexj},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(belichting, "soortbelichting_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.soortbelichtingen),function(soortbelichting){return [_c('option',{domProps:{"value":soortbelichting.id,"selected":soortbelichting.id == (_vm.model.soortbelichting && _vm.model.soortbelichting_id)}},[_vm._v(_vm._s(soortbelichting.naam))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('soort' + (indexi * 2) + indexj)),expression:"errors.has('soort' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Kies een soort belichting")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'efficientie' + (indexi * 2) + indexj}},[_vm._v("Efficientie "),_c('sup',[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("(µmol/J)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.efficientie),expression:"belichting.efficientie"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('effi' + (indexi * 2) + indexj) },attrs:{"type":"number","step":".001","min":"0","max":"99.999","id":'efficientie' + (indexi * 2) + indexj,"name":"efficientie","data-vv-name":'effi' + (indexi * 2) + indexj},domProps:{"value":(belichting.efficientie)},on:{"change":function($event){_vm.berekenFlux(indexi,indexj)},"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "efficientie", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('effi' + (indexi * 2) + indexj)),expression:"errors.has('effi' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Efficientie is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'aantalLampen' + (indexi * 2) + indexj}},[_vm._v("Aantal lampen "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.aantalLampen),expression:"belichting.aantalLampen"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('aant' + (indexi * 2) + indexj) },attrs:{"type":"number","min":"0","id":'aantalLampen' + (indexi * 2) + indexj,"name":"aantalLampen","data-vv-name":'aant' + (indexi * 2) + indexj},domProps:{"value":(belichting.aantalLampen)},on:{"change":function($event){_vm.berekenFlux(indexi,indexj)},"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "aantalLampen", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('aant' + (indexi * 2) + indexj)),expression:"errors.has('aant' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Aantal lampen is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'opgenomenVermogenPerLamp' + (indexi * 2) + indexj}},[_vm._v("Opgenomen vermogen/lamp "),_c('span',{staticClass:"small"},[_vm._v("(W) "),_c('sup',[_vm._v("*")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.opgenomenVermogenPerLamp),expression:"belichting.opgenomenVermogenPerLamp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('vermogen' + (indexi * 2) + indexj) },attrs:{"type":"number","id":'opgenomenVermogenPerLamp' + (indexi * 2) + indexj,"name":"opgenomenVermogenPerLamp","data-vv-name":'vermogen' + (indexi * 2) + indexj},domProps:{"value":(belichting.opgenomenVermogenPerLamp)},on:{"change":function($event){_vm.berekenFlux(indexi,indexj)},"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "opgenomenVermogenPerLamp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('vermogen' + (indexi * 2) + indexj)),expression:"errors.has('vermogen' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Opgenomen vermogen/lamp is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'fotonflux' + (indexi * 2) + indexj}},[_vm._v("Fotonflux "),_c('span',{staticClass:"small"},[_vm._v("(µmol/s)"),_c('sup',[_vm._v("*")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.fotonflux),expression:"belichting.fotonflux"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('fotonflux' + (indexi * 2) + indexj) },attrs:{"type":"number","id":'fotonflux' + (indexi * 2) + indexj,"name":"fotonflux","data-vv-name":'fotonflux' + (indexi * 2) + indexj},domProps:{"value":(belichting.fotonflux)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "fotonflux", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('fotonflux' + (indexi * 2) + indexj)),expression:"errors.has('fotonflux' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Fotonflux is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'reflectorRendement' + (indexi * 2) + indexj}},[_vm._v("Reflectorrendement "),_c('span',{staticClass:"small"},[_vm._v("(percentage)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.reflectorRendement),expression:"belichting.reflectorRendement"},{name:"validate",rawName:"v-validate",value:('max_value:100'),expression:"'max_value:100'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('reflectorRendement' + (indexi * 2) + indexj) },attrs:{"type":"number","step":".1","min":"0","max":"999.9","id":'reflectorRendement' + (indexi * 2) + indexj,"name":"reflectorRendement","data-vv-name":'reflectorRendement' + (indexi * 2) + indexj},domProps:{"value":(belichting.reflectorRendement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "reflectorRendement", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('reflectorRendement' + (indexi * 2) + indexj)),expression:"errors.has('reflectorRendement' + (indexi * 2) + indexj)"}],staticClass:"small text-danger"},[_vm._v("Reflectorrendement is maximum 100")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":'warmteconvectie' + (indexi * 2) + indexj}},[_vm._v("Warmteconvectie "),_c('span',{staticClass:"small"},[_vm._v("(joule)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichting.warmteconvectie),expression:"belichting.warmteconvectie"}],staticClass:"form-control",attrs:{"type":"number","step":".01","min":"0","max":"9999.99","id":'warmteconvectie' + (indexi * 2) + indexj,"name":"warmteconvectie"},domProps:{"value":(belichting.warmteconvectie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(belichting, "warmteconvectie", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Schakelniveaus")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',[_c('tr',[_vm._l((belichting.schakelniveau_n),function(schakelniveau,index2){return [_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(schakelniveau.percentage),expression:"schakelniveau.percentage"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('niveau' + ((indexi * 2) + indexj)) || (_vm.totbel((indexi * 2) + indexj) !== 100)) },staticStyle:{"width":"5em"},attrs:{"disabled":! belichting.deleteok,"type":"number","min":"0","max":"100","onkeypress":"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57","name":"niveau","data-vv-name":'niveau' + ((indexi * 2) + indexj)},domProps:{"value":(schakelniveau.percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(schakelniveau, "percentage", $event.target.value)}}})])]}),_vm._v(" "),_c('td',[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:((belichting.schakelniveau_n.length != 1) && belichting.deleteok),expression:"(belichting.schakelniveau_n.length != 1) && belichting.deleteok"}],attrs:{"variant":"primary"},on:{"click":function($event){_vm.verwijderSchakelniveau((indexi * 2) + indexj)}}},[_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:((belichting.schakelniveau_n.length != 5) && belichting.deleteok),expression:"(belichting.schakelniveau_n.length != 5) && belichting.deleteok"}],attrs:{"variant":"primary"},on:{"click":function($event){_vm.voegtoeSchakelniveau((indexi * 2) + indexj)}}},[_c('i',{staticClass:"fa fa-plus-circle"})])],1)],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('small',[_c('label',{staticClass:"col-form-label",class:{'text-danger': _vm.totbel((indexi * 2) + indexj) !== 100 }},[_vm._v("Totaal schakelniveaus")]),_vm._v(" "),_c('label',{class:{'text-danger': _vm.totbel((indexi * 2) + indexj) !== 100 }},[_vm._v(_vm._s(_vm.totbel((indexi * 2) + indexj))+" %")])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer","align":"right"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(belichting.deleteok),expression:"belichting.deleteok"}],attrs:{"variant":"primary"},on:{"click":function($event){_vm.verwijderBelichting((indexi * 2) + indexj)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])])],1)}))}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.saveItem}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"outline-primary"},on:{"click":_vm.addBelichting}},[_vm._v("Belichting toevoegen")])],1)],1)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bedrijven.length != 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"bedrijven":_vm.bedrijven,"glastypes":_vm.glastypes,"soortbelichtingen":_vm.soortbelichtingen,"isEditing":false},on:{"save-item":_vm.addItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Toevoegen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Afdeling werd niet toegevoegd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9b7847c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(442);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9b7847c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_afdeling__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterForm__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(439);







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            bedrijven: [],
            items: []
        };
    },

    computed: {
        currentFilter: function currentFilter() {
            var filter = this.$store.getters.afdelingFilter;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, filter);
        }
    },
    created: function created() {
        this.getItems(true);
    },

    methods: {
        getItems: function getItems(withselect) {
            var _this = this;

            this.$store.dispatch('saveAfdelingFilter', this.currentFilter);
            __WEBPACK_IMPORTED_MODULE_1__api_afdeling__["a" /* default */].getListAfdeling(withselect, this.currentFilter.bedrijf, this.currentFilter.zoekstring).then(function (response) {
                if (withselect) {
                    _this.bedrijven = response.data.bedrijven;
                    _this.bedrijven.unshift({ id: 0, naam: '-- Alle --' });
                }
                _this.items = response.data.items;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdeling__["a" /* default */].deleteAfdeling(id).then(function () {
                _this2.getItems(false);
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        kopieerItem: function kopieerItem(id) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdeling__["a" /* default */].kopieerAfdeling(id).then(function () {
                _this3.getItems(false);
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'filter-form': __WEBPACK_IMPORTED_MODULE_2__FilterForm__["a" /* default */],
        'item-list': __WEBPACK_IMPORTED_MODULE_3__List__["a" /* default */]
    }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c33309c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__ = __webpack_require__(438);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c33309c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FilterForm',
    props: ['bedrijven', 'currentFilter', 'get-items'],

    methods: {
        retrieveData: function retrieveData() {
            this.$emit('get-items', false);
        }
    }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"bedrijf"}},[_vm._v("Bedrijf   ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.bedrijf),expression:"currentFilter.bedrijf"}],staticClass:"form-control",attrs:{"type":"text","name":"bedrijf","id":"bedrijf"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "bedrijf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.retrieveData]}},[_vm._v(">\n                    "),_vm._l((_vm.bedrijven),function(bedrijf){return [_c('option',{domProps:{"value":bedrijf.id,"selected":bedrijf.id == _vm.currentFilter.bedrijf}},[_vm._v(_vm._s(bedrijf.naam))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._v("\n                   "),_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam   ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.zoekstring),expression:"currentFilter.zoekstring"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","id":"naam","name":"naam"},domProps:{"value":(_vm.currentFilter.zoekstring)},on:{"keyup":_vm.retrieveData,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentFilter, "zoekstring", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b600444_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(441);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b600444_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false
        };
    },

    methods: {
        belichtingen: function belichtingen(item) {
            var resultaat = '';
            item.belichting_n.forEach(function (belichting) {
                resultaat += belichting.fotonflux + ' | ';
            });
            return resultaat.substring(0, resultaat.length - 3);
        },
        naarTeelten: function naarTeelten(afdelingid, bedrijfid) {
            this.$store.dispatch('setAfdelingAfdelingteeltFilter', { afdelingid: afdelingid, bedrijfid: bedrijfid });
            this.$router.push('/beheer/afdelingteelt');
        },
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        },
        kopieer: function kopieer(id) {
            this.$emit('kopieer-item', id);
        }
    }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_c('a',{attrs:{"href":"javascript:void(0)","title":"Naar teelten"},on:{"click":function($event){_vm.naarTeelten(item.id, item.bedrijf.id)}}},[_vm._v(_vm._s(item.naam))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.bedrijf.naam))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.oppervlakte)+" m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.belichtingen(item)))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('a',{attrs:{"href":"javascript:void(0)","title":"Afdeling kopiëren"},on:{"click":function($event){_vm.kopieer(item.id)}}},[_c('i',{staticClass:"fa fa-copy"})]),_vm._v("\n                         \n                        "),_c('router-link',{attrs:{"to":'/beheer/afdeling/edit/' + item.id}},[_c('i',{staticClass:"fa fa-pencil-square-o",attrs:{"title":"Afdeling wijzigen"}})]),_vm._v("\n                         \n                        "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(item.deleteok),expression:"item.deleteok"}],attrs:{"title":"Afdeling verwijderen","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem(item.id, item.naam)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])}))]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/afdeling/new"}},[_vm._v("Afdeling toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Afdeling "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Naam")]),_vm._v(" "),_c('th',[_vm._v("Bedrijf")]),_vm._v(" "),_c('th',[_vm._v("Oppervlakte")]),_vm._v(" "),_c('th',[_vm._v("Geïnstalleerd vermogen (µmol/m"),_c('sup',[_vm._v("2")]),_vm._v("s)")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Afdelingen</strong>"}},[_c('filter-form',{attrs:{"bedrijven":_vm.bedrijven,"currentFilter":_vm.currentFilter},on:{"get-items":_vm.getItems}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem,"kopieer-item":_vm.kopieerItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Deze afdeling kan niet verwijderd worden! Aan deze afdeling zijn nog andere gegevens gekoppeld. "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ccfb56c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(445);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ccfb56c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdeling__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(89);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            bedrijven: [],
            glastypes: [],
            soortbelichtingen: [],
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_afdeling__["a" /* default */].getDetailAfdeling(this.$route.params.id).then(function (response) {
            _this.bedrijven = response.data.bedrijven;
            _this.glastypes = response.data.glastypes;
            _this.soortbelichtingen = response.data.soortbelichtingen;
            _this.model = response.data.model;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdeling__["a" /* default */].updateAfdeling(model).then(function () {
                _this2.$router.replace('/beheer/afdeling');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"bedrijven":_vm.bedrijven,"glastypes":_vm.glastypes,"soortbelichtingen":_vm.soortbelichtingen,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Afdeling werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06059d7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(451);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06059d7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(90);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            afdelingen: [],
            teelten: [],
            model: {
                aantalDagenVerleden: 0,
                aantalDagenToekomst: 0,
                percentageVerleden: 0,
                percentageToekomst: 0,
                aantalBelichtingen: 0,
                dmins: [],
                dplus: [],
                belichtingsuren_n: []
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].getDetailAfdelingteelt(0).then(function (response) {
            _this.afdelingen = response.data.afdelingen;
            _this.teelten = response.data.teelten;
        });
    },

    methods: {
        addItem: function addItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].addAfdelingteelt(model).then(function () {
                _this2.$router.replace('/beheer/afdelingteelt');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdeling__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'afdelingen', 'teelten', 'isEditing'],
    data: function data() {
        return {
            aantalDagen: [0, 1, 2, 3, 4, 5, 6]
        };
    },

    methods: {
        mindate: function mindate() {
            var datum = arguments[0];
            for (var i = 0; i < arguments.length; i++) {
                if (arguments[i] != undefined) {
                    if (arguments[i] < datum) {
                        datum = arguments[i];
                    }
                }
            }
            return datum;
        },
        maxdate: function maxdate() {
            var datum = arguments[0];
            for (var i = 0; i < arguments.length; i++) {
                if (arguments[i] != undefined) {
                    if (arguments[i] > datum) {
                        datum = arguments[i];
                    }
                }
            }
            return datum;
        },
        haveAanplantdatum: function haveAanplantdatum() {
            document.getElementById("startdatumBelichting").setAttribute("min", this.model.aanplantdatum);
            document.getElementById("einddatumBelichting").setAttribute("min", this.maxdate(this.model.aanplantdatum, this.model.startdatumBelichting));
            document.getElementById("einddatum").setAttribute("min", this.maxdate(this.model.aanplantdatum, this.model.startdatumBelichting, this.model.einddatumBelichting));
        },
        haveEinddatum: function haveEinddatum() {
            document.getElementById("aanplantdatum").setAttribute("max", this.mindate(this.model.einddatum, this.model.einddatumBelichting, this.model.startdatumBelichting));
            document.getElementById("startdatumBelichting").setAttribute("max", this.mindate(this.model.einddatum, this.model.einddatumBelichting));
            document.getElementById("einddatumBelichting").setAttribute("max", this.model.einddatum);
        },
        haveStartdatumBelichting: function haveStartdatumBelichting() {
            document.getElementById("aanplantdatum").setAttribute("max", this.model.startdatumBelichting);
            document.getElementById("einddatumBelichting").setAttribute("min", this.model.startdatumBelichting);
            document.getElementById("einddatum").setAttribute("min", this.maxdate(this.model.startdatumBelichting, this.model.einddatumBelichting));
        },
        haveEinddatumBelichting: function haveEinddatumBelichting() {
            document.getElementById("aanplantdatum").setAttribute("max", this.mindate(this.model.einddatumBelichting, this.model.startdatumBelichting));
            document.getElementById("startdatumBelichting").setAttribute("max", this.model.einddatumBelichting);
            document.getElementById("einddatum").setAttribute("min", this.model.einddatumBelichting);
        },
        fillBelichtingsuren: function fillBelichtingsuren() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdeling__["a" /* default */].getBelichtingsuren(this.model.afdeling_id).then(function (response) {
                _this.model.aantalBelichtingen = response.data.aantalBelichtingen;
                _this.model.belichtingsuren_n = response.data.belichtingsuren_n;
            });
        },
        saveItem: function saveItem() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this2.isError) {
                        _this2.$emit('save-item', _this2.model);
                    }
                }
            });
        },
        changeDmins: function changeDmins() {
            var max = this.model.aantalDagenVerleden;
            if (max === 0) {
                this.model.percentageVerleden = 0;
            }
            if (max > this.model.dmins.length) {
                for (var i = this.model.dmins.length + 1; i <= max; i += 1) {
                    this.model.dmins.push({ afdelingteelt_id: this.model.id,
                        dagverschil: -i,
                        waarde: '' });
                }
            } else if (max < this.model.dmins.length) {
                this.model.dmins.splice(max, this.model.dmins.length - max);
            }
        },
        changeDplus: function changeDplus() {
            var max = this.model.aantalDagenToekomst;
            if (max === 0) {
                this.model.percentageToekomst = 0;
            }
            if (max > this.model.dplus.length) {
                for (var i = this.model.dplus.length + 1; i <= max; i += 1) {
                    this.model.dplus.push({ afdelingteelt_id: this.model.id,
                        dagverschil: i,
                        waarde: '' });
                }
            } else if (max < this.model.dplus.length) {
                this.model.dplus.splice(max, this.model.dplus.length - max);
            }
        },
        back: function back() {
            this.$router.go(-1);
        }
    },
    computed: {
        isError: function isError() {
            return !this.model.aanplantdatum || !this.model.einddatum || !this.model.startdatumBelichting || this.percVerledenFout || this.percToekomstFout || this.totPercVerledenFout || this.totPercToekomstFout;
        },
        totmins: function totmins() {
            var result = 0;
            for (var i = 0; i < this.model.dmins.length; i += 1) {
                if (this.model.dmins[i].waarde !== '') {
                    result += parseInt(this.model.dmins[i].waarde, 10);
                }
            }
            return result;
        },
        percVerledenFout: function percVerledenFout() {
            return parseInt(this.model.aantalDagenVerleden, 10) !== 0 && parseInt(this.model.percentageVerleden, 10) === 0;
        },
        percToekomstFout: function percToekomstFout() {
            return parseInt(this.model.aantalDagenToekomst, 10) !== 0 && parseInt(this.model.percentageToekomst, 10) === 0;
        },
        totPercVerledenFout: function totPercVerledenFout() {
            return parseInt(this.model.aantalDagenVerleden, 10) !== 0 && this.totmins !== 100;
        },
        totPercToekomstFout: function totPercToekomstFout() {
            return parseInt(this.model.aantalDagenToekomst, 10) !== 0 && this.totplus !== 100;
        },
        totplus: function totplus() {
            var result = 0;
            for (var i = 0; i < this.model.dplus.length; i += 1) {
                if (this.model.dplus[i].waarde !== '') {
                    result += parseInt(this.model.dplus[i].waarde, 10);
                }
            }
            return result;
        }
    },
    components: {}
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Teelt")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"afdeling"}},[_vm._v("Afdeling "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.afdeling_id),expression:"model.afdeling_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('afdeling') },attrs:{"type":"text","id":"afdeling","name":"afdeling"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "afdeling_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.fillBelichtingsuren]}},[_vm._l((_vm.afdelingen),function(afdeling){return [_c('option',{domProps:{"value":afdeling.id,"selected":afdeling.id == (_vm.model.afdeling && _vm.model.afdeling_id)}},[_vm._v(_vm._s(afdeling.naam)+" - "+_vm._s(afdeling.bedrijf.naam))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('afdeling')),expression:"errors.has('afdeling')"}],staticClass:"small text-danger"},[_vm._v("Kies een afdeling")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"teelt"}},[_vm._v("Teelt "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.teelt_id),expression:"model.teelt_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('teelt') },attrs:{"type":"text","id":"teelt","name":"teelt"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "teelt_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.teelten),function(teelt){return [_c('option',{domProps:{"value":teelt.id,"selected":teelt.id == (_vm.model.teelt && _vm.model.teelt_id)}},[_vm._v(_vm._s(teelt.naam))])]})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('teelt')),expression:"errors.has('teelt')"}],staticClass:"small text-danger"},[_vm._v("Kies een teelt")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"ras"}},[_vm._v("Ras "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ras),expression:"model.ras"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('ras') },attrs:{"type":"text","id":"ras","name":"ras"},domProps:{"value":(_vm.model.ras)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ras", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('ras')),expression:"errors.has('ras')"}],staticClass:"small text-danger"},[_vm._v("Ras is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Aanplantdatum "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aanplantdatum),expression:"model.aanplantdatum"}],ref:"aanplantdatum",staticClass:"unstyled",attrs:{"type":"date","name":"aanplantdatum","id":"aanplantdatum"},domProps:{"value":(_vm.model.aanplantdatum)},on:{"change":_vm.haveAanplantdatum,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aanplantdatum", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.aanplantdatum),expression:"!model.aanplantdatum"}],staticClass:"small text-danger"},[_vm._v("Aanplantdatum is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Einddatum "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.einddatum),expression:"model.einddatum"}],ref:"einddatum",staticClass:"unstyled",attrs:{"type":"date","name":"einddatum","id":"einddatum"},domProps:{"value":(_vm.model.einddatum)},on:{"change":_vm.haveEinddatum,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "einddatum", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.einddatum),expression:"!model.einddatum"}],staticClass:"small text-danger"},[_vm._v("Einddatum is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"aantalDagenTotVolgroeid"}},[_vm._v("Aantal dagen tot volgroeid "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aantalDagenTotVolgroeid),expression:"model.aantalDagenTotVolgroeid"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('aantalDagenTotVolgroeid') },attrs:{"type":"number","step":"1","min":"0","max":"999","id":"aantalDagenTotVolgroeid","name":"aantalDagenTotVolgroeid"},domProps:{"value":(_vm.model.aantalDagenTotVolgroeid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aantalDagenTotVolgroeid", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('aantalDagenTotVolgroeid')),expression:"errors.has('aantalDagenTotVolgroeid')"}],staticClass:"small text-danger"},[_vm._v("Aantal dagen is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"ingesteldeDli"}},[_vm._v("Ingestelde DLI "),_c('sup',[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ingesteldeDli),expression:"model.ingesteldeDli"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('ingesteldeDli') },attrs:{"type":"number","step":".1","min":"0","max":"99.9","id":"ingesteldeDli","name":"ingesteldeDli"},domProps:{"value":(_vm.model.ingesteldeDli)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ingesteldeDli", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('ingesteldeDli')),expression:"errors.has('ingesteldeDli')"}],staticClass:"small text-danger"},[_vm._v("Ingestelde DLI is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"aantalStengelsPerPlant"}},[_vm._v("Aantal stengels/plant")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aantalStengelsPerPlant),expression:"model.aantalStengelsPerPlant"}],staticClass:"form-control",attrs:{"type":"number","step":"1","min":"0","max":"999","id":"aantalStengelsPerPlant","name":"aantalStengelsPerPlant"},domProps:{"value":(_vm.model.aantalStengelsPerPlant)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aantalStengelsPerPlant", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"afstandInRij"}},[_vm._v("Afstand in rij "),_c('span',{staticClass:"small"},[_vm._v("(cm)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.afstandInRij),expression:"model.afstandInRij"}],staticClass:"form-control",attrs:{"type":"number","step":".1","min":"0","max":"999.9","id":"afstandInRij","name":"afstandInRij"},domProps:{"value":(_vm.model.afstandInRij)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "afstandInRij", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"rijafstand"}},[_vm._v("Rijafstand "),_c('span',{staticClass:"small"},[_vm._v("(cm)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.rijafstand),expression:"model.rijafstand"}],staticClass:"form-control",attrs:{"type":"number","step":".1","min":"0","max":"999.9","id":"rijafstand","name":"rijafstand"},domProps:{"value":(_vm.model.rijafstand)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rijafstand", $event.target.value)}}})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-align-justify"}),_c('strong',[_vm._v(" Invloedspercentages")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"aantalDagenVerleden"}},[_vm._v("Aantal dagen verleden "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aantalDagenVerleden),expression:"model.aantalDagenVerleden"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('aantalDagenVerleden') },attrs:{"type":"text","id":"aantalDagenVerleden","name":"aantalDagenVerleden"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "aantalDagenVerleden", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.changeDmins]}},[_vm._l((_vm.aantalDagen),function(aantal){return [_c('option',{domProps:{"value":aantal,"selected":aantal == _vm.model.aantalDagenVerleden}},[_vm._v(_vm._s(aantal))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"percentageVerleden"}},[_vm._v("Percentage verleden "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.percentageVerleden),expression:"model.percentageVerleden"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('percentageVerleden') || _vm.percVerledenFout) },attrs:{"type":"number","step":"1","min":"0","max":"999","id":"percentageVerleden","name":"percentageVerleden"},domProps:{"value":(_vm.model.percentageVerleden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "percentageVerleden", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.percVerledenFout),expression:"percVerledenFout"}],staticClass:"small text-danger"},[_vm._v("Percentage is 0")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.aantalDagenVerleden != 0),expression:"model.aantalDagenVerleden != 0"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',[_c('tr',[_vm._l((_vm.model.dmins),function(dmin,index){return [_c('td',[_c('label',{staticClass:"col-form-label"},[_vm._v("D"+_vm._s(dmin.dagverschil)+" "),_c('sup',[_vm._v("*")])])])]})],2),_vm._v(" "),_c('tr',[_vm._l((_vm.model.dmins),function(dmin,index){return [_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dmin.waarde),expression:"dmin.waarde"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('waardep' + index) || (_vm.totmins !== 100)) },staticStyle:{"width":"5em"},attrs:{"type":"number","step":"1","min":"0","max":"999","name":"waarde","data-vv-name":'waarde' + index},domProps:{"value":(dmin.waarde)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dmin, "waarde", $event.target.value)}}})])]})],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.aantalDagenVerleden != 0),expression:"model.aantalDagenVerleden != 0"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('small',[_c('label',{staticClass:"col-form-label",class:{'text-danger': _vm.totmins !== 100 }},[_vm._v("Totaal percentages verleden")]),_vm._v(" "),_c('label',{class:{'text-danger': _vm.totmins !== 100 }},[_vm._v(_vm._s(_vm.totmins)+" %")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"aantalDagenToekomst"}},[_vm._v("Aantal dagen toekomst "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aantalDagenToekomst),expression:"model.aantalDagenToekomst"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('aantalDagenToekomst') },attrs:{"type":"text","id":"aantalDagenToekomst","name":"aantalDagenToekomst"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "aantalDagenToekomst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.changeDplus]}},[_vm._l((_vm.aantalDagen),function(aantal){return [_c('option',{domProps:{"value":aantal,"selected":aantal == _vm.model.aantalDagenToekomst}},[_vm._v(_vm._s(aantal))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"percentageToekomst"}},[_vm._v("Percentage toekomst "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.percentageToekomst),expression:"model.percentageToekomst"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('percentageToekomst') || _vm.percToekomstFout) },attrs:{"type":"number","step":"1","min":"0","max":"999","id":"percentageToekomst","name":"percentageToekomst"},domProps:{"value":(_vm.model.percentageToekomst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "percentageToekomst", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.percToekomstFout),expression:"percToekomstFout"}],staticClass:"small text-danger"},[_vm._v("Percentage is 0")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.aantalDagenToekomst != 0),expression:"model.aantalDagenToekomst != 0"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',[_c('tr',[_vm._l((_vm.model.dplus),function(dplus,index){return [_c('td',{attrs:{"v":""}},[_c('label',{staticClass:"col-form-label"},[_vm._v("D+"+_vm._s(dplus.dagverschil)+" "),_c('sup',[_vm._v("*")])])])]})],2),_vm._v(" "),_c('tr',[_vm._l((_vm.model.dplus),function(dplus,index){return [_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dplus.waarde),expression:"dplus.waarde"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': (_vm.errors.has('waardep' + index) || (_vm.totplus !== 100)) },staticStyle:{"width":"5em"},attrs:{"type":"number","step":"1","min":"0","max":"999","name":"waardep","data-vv-name":'waardep' + index},domProps:{"value":(dplus.waarde)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dplus, "waarde", $event.target.value)}}})])]})],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.aantalDagenToekomst != 0),expression:"model.aantalDagenToekomst != 0"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('small',[_c('label',{staticClass:"col-form-label",class:{'text-danger': _vm.totplus !== 100 }},[_vm._v("Totaal percentages toekomst")]),_vm._v(" "),_c('label',{class:{'text-danger': _vm.totplus !== 100 }},[_vm._v(_vm._s(_vm.totplus)+" %")])])])])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-align-justify"}),_c('strong',[_vm._v(" Belichtingsuren")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Startdatum belichting "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.startdatumBelichting),expression:"model.startdatumBelichting"}],ref:"startdatumBelichting",staticClass:"unstyled",attrs:{"type":"date","name":"startdatumBelichting","id":"startdatumBelichting"},domProps:{"value":(_vm.model.startdatumBelichting)},on:{"change":_vm.haveStartdatumBelichting,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "startdatumBelichting", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.startdatumBelichting),expression:"!model.startdatumBelichting"}],staticClass:"small text-danger"},[_vm._v("Startdatum is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Einddatum belichting "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.einddatumBelichting),expression:"model.einddatumBelichting"}],ref:"einddatumBelichting",staticClass:"unstyled",attrs:{"type":"date","name":"einddatumBelichting","id":"einddatumBelichting"},domProps:{"value":(_vm.model.einddatumBelichting)},on:{"change":_vm.haveEinddatumBelichting,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "einddatumBelichting", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.model.einddatumBelichting),expression:"!model.einddatumBelichting"}],staticClass:"small text-danger"},[_vm._v("Einddatum is verplicht")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.aantalBelichtingen != 0),expression:"model.aantalBelichtingen != 0"}]},[_c('table',{staticClass:"table table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Naam belichting")]),_vm._v(" "),_c('th',[_vm._v("Soort")]),_vm._v(" "),_c('th',[_vm._v("Startuur belichting "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('th',[_vm._v("Lengte lichtperiode "),_c('sup',[_vm._v("*")])])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.belichtingsuren_n),function(belichtingsuur,index){return [_c('tr',[_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"form-control-static"},[_vm._v(_vm._s(belichtingsuur.belichting.naam))])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"form-control-static"},[_vm._v(_vm._s(belichtingsuur.belichting.soortbelichting.naam))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichtingsuur.startuurBelichting),expression:"belichtingsuur.startuurBelichting"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"unstyled",class:{'form-control': true, 'is-invalid': _vm.errors.has('startuurBelichting' + index) },attrs:{"type":"time","id":'startuurBelichting' + index,"name":"startuurBelichting","data-vv-name":'startuurBelichting' + index},domProps:{"value":(belichtingsuur.startuurBelichting)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(belichtingsuur, "startuurBelichting", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('startuurBelichting')),expression:"errors.has('startuurBelichting')"}],staticClass:"small text-danger"},[_vm._v("Kies een startuur belichting")])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(belichtingsuur.lengteLichtperiode),expression:"belichtingsuur.lengteLichtperiode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('lengteLichtperiode' + index) },attrs:{"type":"number","step":".1","min":"0","max":"99.9","id":'lengteLichtperiode' + index,"name":"lengteLichtperiode","data-vv-name":'lengteLichtperiode' + index},domProps:{"value":(belichtingsuur.lengteLichtperiode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(belichtingsuur, "lengteLichtperiode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('lengteLichtperiode')),expression:"errors.has('lengteLichtperiode')"}],staticClass:"small text-danger"},[_vm._v("Lengte lichtperiode is verplicht")])])])]})],2)])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)]),_vm._v(" "),_c('div',{staticStyle:{"height":"11em"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.afdelingen.length != 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"afdelingen":_vm.afdelingen,"teelten":_vm.teelten,"isEditing":false},on:{"save-item":_vm.addItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Toevoegen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Teelt werd niet toegevoegd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_652e0ba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_652e0ba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterForm__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_FadeLoader__ = __webpack_require__(22);








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            bedrijven: [],
            afdelingen: [],
            items: [],

            warningGeduld: false,
            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },

    computed: {
        currentFilter: function currentFilter() {
            var filter = this.$store.getters.afdelingteeltFilter;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, filter);
        }
    },
    created: function created() {
        this.getItems(true);
    },

    methods: {
        getItems: function getItems(withselect) {
            var _this = this;

            this.$store.dispatch('saveAfdelingteeltFilter', this.currentFilter);
            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getListAfdelingteelt(withselect, this.currentFilter.bedrijf, this.currentFilter.afdeling, this.currentFilter.historiek).then(function (response) {
                if (withselect) {
                    _this.bedrijven = response.data.bedrijven;
                    _this.bedrijven.unshift({ id: 0, naam: '-- Alle --' });
                    _this.afdelingen = response.data.afdelingen;
                    _this.afdelingen.unshift({ id: 0, naam: '-- Alle --', bedrijf: { naam: '' } });
                }
                _this.items = response.data.items;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].deleteAfdelingteelt(id).then(function () {
                _this2.getItems(false);
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        destroyItem: function destroyItem(id) {
            var _this3 = this;

            this.warningGeduld = true;
            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].destroyAfdelingteelt(id).then(function () {
                _this3.warningGeduld = false;
                _this3.getItems(false);
            }, function (error) {
                _this3.warningGeduld = false;
                _this3.errormsg = error.message;
                _this3.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'filter-form': __WEBPACK_IMPORTED_MODULE_2__FilterForm__["a" /* default */],
        'item-list': __WEBPACK_IMPORTED_MODULE_3__List__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18dee24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__ = __webpack_require__(458);
function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18dee24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FilterForm',
    props: ['bedrijven', 'afdelingen', 'currentFilter', 'get-items'],
    methods: {
        retrieveDataEnAfdelingen: function retrieveDataEnAfdelingen() {
            this.currentFilter.afdeling = 0;
            this.$emit('get-items', true);
        },
        retrieveData: function retrieveData() {
            this.$emit('get-items', false);
        },
        retrieveCheckbox: function retrieveCheckbox() {
            this.$emit('get-items', false);
        }
    }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"bedrijf"}},[_vm._v("Bedrijf   ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.bedrijf),expression:"currentFilter.bedrijf"}],staticClass:"form-control",attrs:{"type":"text","name":"bedrijf","id":"bedrijf"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "bedrijf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.retrieveDataEnAfdelingen]}},[_vm._l((_vm.bedrijven),function(bedrijf){return [_c('option',{domProps:{"value":bedrijf.id,"selected":bedrijf.id == _vm.currentFilter.bedrijf}},[_vm._v(_vm._s(bedrijf.naam))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"afdeling"}},[_vm._v("   Afdeling   ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.afdeling),expression:"currentFilter.afdeling"}],staticClass:"form-control",attrs:{"type":"text","name":"afdeling","id":"afdeling"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "afdeling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.retrieveData]}},[_vm._l((_vm.afdelingen),function(afdeling){return [_c('option',{domProps:{"value":afdeling.id,"selected":afdeling.id == _vm.currentFilter.afdeling}},[_vm._v(_vm._s(afdeling.naam)+" - "+_vm._s(afdeling.bedrijf.naam))])]})],2)]),_vm._v("\n               \n            "),_c('label',{staticClass:"control control--checkbox"},[_vm._v("Historiek\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.historiek),expression:"currentFilter.historiek"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.currentFilter.historiek)?_vm._i(_vm.currentFilter.historiek,null)>-1:(_vm.currentFilter.historiek)},on:{"change":[function($event){var $$a=_vm.currentFilter.historiek,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentFilter.historiek=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentFilter.historiek=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.currentFilter, "historiek", $$c)}},_vm.retrieveCheckbox]}}),_vm._v(" "),_c('div',{staticClass:"control__indicator"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_892a08a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(462);
function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_892a08a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false,
            warningModal2: false
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        },
        bevestigItem2: function bevestigItem2(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal2 = true;
        },
        deleteItem2: function deleteItem2() {
            this.warningModal2 = false;
            this.$emit('destroy-item', this.id);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        }
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item){return [_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('i',[_vm._v(_vm._s(item.bedrijf.naam)+" - "+_vm._s(item.naam))])])]),_vm._v(" "),_vm._l((item.teelt_n),function(teelt){return [_c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(teelt.aanplantdatum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(teelt.einddatum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(teelt.teelt.naam)+" - "+_vm._s(teelt.ras))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('router-link',{attrs:{"to":'/beheer/afdelingteelt/edit/' + teelt.id,"title":"Teelt wijzigen"}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v("\n                                 \n                                "),_c('router-link',{attrs:{"to":'/beheer/afdelingteelt/dliprofiel/' + teelt.id,"title":"DLI profiel"}},[_c('i',{staticClass:"fa fa-thermometer-0",class:{ 'transp': !teelt.profielbestaat }})]),_vm._v("\n                                 \n                                "),_c('router-link',{attrs:{"to":'/beheer/afdelingteelt/klassiek/' + teelt.id,"title":"Klassiek belichtingsschema"}},[_c('i',{staticClass:"fa fa-lightbulb-o",class:{ 'transp': !teelt.schemabestaat }})]),_vm._v("\n                                 \n                                "),_c('router-link',{attrs:{"to":'/beheer/afdelingteelt/lichtintegratie/' + teelt.id,"title":"Lichtintegratie"}},[_c('i',{staticClass:"fa fa-sun-o",class:{ 'transp': !teelt.schemabestaat }})]),_vm._v("\n                                 \n                                "),_c('router-link',{attrs:{"to":'/beheer/afdelingteelt/samenvatting/' + teelt.id,"title":"Samenvatting"}},[_c('i',{staticClass:"fa fa-line-chart",class:{ 'transp': !teelt.schemabestaat }})]),_vm._v("\n                                 \n                                "),_c('router-link',{attrs:{"to":'/beheer/afdelingteelt/werkelijk/' + teelt.id,"title":"Werkelijke belichting"}},[_c('i',{staticClass:"fa fa-clock-o",class:{ 'transp': !teelt.schemabestaat }})]),_vm._v("\n                                 \n                                "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(teelt.deleteok),expression:"teelt.deleteok"}],attrs:{"title":"Teelt verwijderen","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem(teelt.id, teelt.teelt.naam + ' - ' + teelt.ras)}}},[_c('i',{staticClass:"fa fa-trash"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((! teelt.deleteok) && (_vm.user.m >= 7)),expression:"(! teelt.deleteok) && (user.m >= 7)"}]},[_vm._v("     ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:((! teelt.deleteok) && (_vm.user.m >= 7)),expression:"(! teelt.deleteok) && (user.m >= 7)"}],attrs:{"title":"Teelt verwijderen (incl. belichting)","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem2(teelt.id, teelt.teelt.naam + ' - ' + teelt.ras)}}},[_c('i',{staticClass:"fa fa-bell-slash-o"})])],1)])]})]})],2)]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/afdelingteelt/new"}},[_vm._v("Teelt toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Teelt "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem2},model:{value:(_vm.warningModal2),callback:function ($$v) {_vm.warningModal2=$$v},expression:"warningModal2"}},[_vm._v("\n        Teelt "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" (incl. belichtingsgegevens) wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Bedrijf - afdeling")]),_vm._v(" "),_c('th',[_vm._v("Aanplantdatum")]),_vm._v(" "),_c('th',[_vm._v("Einddatum")]),_vm._v(" "),_c('th',[_vm._v("Gewas")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Teelten</strong>"}},[_c('filter-form',{attrs:{"bedrijven":_vm.bedrijven,"afdelingen":_vm.afdelingen,"currentFilter":_vm.currentFilter},on:{"get-items":_vm.getItems}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem,"destroy-item":_vm.destroyItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Deze teelt kan niet verwijderd worden! Aan deze teelt zijn nog andere gegevens gekoppeld. "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Teelt verwijderen","size":"sm"},model:{value:(_vm.warningGeduld),callback:function ($$v) {_vm.warningGeduld=$$v},expression:"warningGeduld"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Teelt (incl. belichting) wordt verwijderd. Deze bewerking kan even duren.")])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a99b9c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(466);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a99b9c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(90);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            afdelingen: [],
            teelten: [],
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].getDetailAfdelingteelt(this.$route.params.id).then(function (response) {
            _this.afdelingen = response.data.afdelingen;
            _this.teelten = response.data.teelten;
            _this.model = response.data.model;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].updateAfdelingteelt(model).then(function () {
                _this2.$router.replace('/beheer/afdelingteelt');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"afdelingen":_vm.afdelingen,"teelten":_vm.teelten,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Teelt werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c83a7c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(471);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c83a7c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_glastype__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(91);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },

    methods: {
        addItem: function addItem(model) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_glastype__["a" /* default */].addGlastype(model).then(function () {
                _this.$router.replace('/beheer/glastype');
            }, function (error) {
                _this.errormsg = error.message;
                _this.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'isEditing'],
    methods: {
        saveItem: function saveItem() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.$emit('save-item', _this.model);
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        }
    }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Glastype")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"omschrijving"}},[_vm._v("Omschrijving "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.omschrijving),expression:"model.omschrijving"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('omschrijving') },attrs:{"type":"text","id":"omschrijving","name":"omschrijving"},domProps:{"value":(_vm.model.omschrijving)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "omschrijving", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('omschrijving')),expression:"errors.has('omschrijving')"}],staticClass:"small text-danger"},[_vm._v("Omschrijving is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"coefficient"}},[_vm._v("Coëfficiënt "),_c('sup',[_vm._v("*")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("(percentage)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.coefficient),expression:"model.coefficient"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('coefficient') },attrs:{"type":"number","step":".01","min":"0","max":"999.99","id":"coefficient","name":"coefficient"},domProps:{"value":(_vm.model.coefficient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "coefficient", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('coefficient')),expression:"errors.has('coefficient')"}],staticClass:"small text-danger"},[_vm._v("Coëfficiënt is verplicht")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-form',{attrs:{"model":_vm.model,"isEditing":false},on:{"save-item":_vm.addItem}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8d8eb7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8d8eb7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_glastype__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(474);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            items: []
        };
    },
    created: function created() {
        this.getItems();
    },

    methods: {
        getItems: function getItems() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_glastype__["a" /* default */].getListGlastype().then(function (response) {
                _this.items = response.data;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_glastype__["a" /* default */].deleteGlastype(id).then(function () {
                _this2.getItems();
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-list': __WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */]
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ae3a49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(476);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ae3a49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false
        };
    },

    methods: {
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        }
    }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.omschrijving))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.coefficient)+" %")]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('router-link',{attrs:{"to":'/beheer/glastype/edit/' + item.id,"title":"Glastype wijzigen"}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v("\n                         \n                        "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(item.deleteok),expression:"item.deleteok"}],attrs:{"title":"Glastype verwijderen","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem(item.id, item.omschrijving)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])}))]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/glastype/new"}},[_vm._v("Glastype toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Glastype "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Omschrijving")]),_vm._v(" "),_c('th',[_vm._v("Coëfficiënt")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Glastypes</strong>"}},[_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Dit glastype kan niet verwijderd worden! Dit glastype wordt nog gebruikt in een afdeling. "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f661b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(480);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f661b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_glastype__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(91);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_glastype__["a" /* default */].getDetailGlastype(this.$route.params.id).then(function (response) {
            _this.model = response.data;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_glastype__["a" /* default */].updateGlastype(model).then(function () {
                _this2.$router.replace('/beheer/glastype');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Glastype werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118a3126_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(485);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118a3126_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(92);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },

    methods: {
        addItem: function addItem(model) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__["a" /* default */].addSoortbelichting(model).then(function () {
                _this.$router.replace('/beheer/soortbelichting');
            }, function (error) {
                _this.errormsg = error.message;
                _this.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'isEditing'],
    methods: {
        saveItem: function saveItem() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.$emit('save-item', _this.model);
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        }
    }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Soort belichting")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.naam),expression:"model.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam') },attrs:{"type":"text","id":"naam","name":"naam"},domProps:{"value":(_vm.model.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam')),expression:"errors.has('naam')"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-form',{attrs:{"model":_vm.model,"isEditing":false},on:{"save-item":_vm.addItem}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a1743d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(491);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a1743d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(488);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            items: []
        };
    },
    created: function created() {
        this.getItems();
    },

    methods: {
        getItems: function getItems() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__["a" /* default */].getListSoortbelichting().then(function (response) {
                _this.items = response.data;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__["a" /* default */].deleteSoortbelichting(id).then(function () {
                _this2.getItems();
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-list': __WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */]
    }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2078dd08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(490);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2078dd08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false
        };
    },

    methods: {
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        }
    }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.naam))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('router-link',{attrs:{"to":'/beheer/soortbelichting/edit/' + item.id,"title":"Belichtingssoort wijzigen"}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v("\n                         \n                        "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(item.deleteok),expression:"item.deleteok"}],attrs:{"title":"Belichtingssoort verwijderen","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem(item.id, item.naam)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])}))]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/soortbelichting/new"}},[_vm._v("Belichtingssoort toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Soort belichting "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Naam")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Belichtingssoorten</strong>"}},[_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Deze belichtingssoort kan niet verwijderd worden! Deze belichtingssoort wordt nog gebruikt. "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc10474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(494);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc10474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(92);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__["a" /* default */].getDetailSoortbelichting(this.$route.params.id).then(function (response) {
            _this.model = response.data;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_soortbelichting__["a" /* default */].updateSoortbelichting(model).then(function () {
                _this2.$router.replace('/beheer/soortbelichting');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Belichtingssoort werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7043dd5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(499);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7043dd5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_teelt__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(93);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },

    methods: {
        addItem: function addItem(model) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_teelt__["a" /* default */].addTeelt(model).then(function () {
                _this.$router.replace('/beheer/teelt');
            }, function (error) {
                _this.errormsg = error.message;
                _this.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'isEditing'],
    methods: {
        saveItem: function saveItem() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.$emit('save-item', _this.model);
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        }
    }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Teeltsoort")]),_vm._v(" "),_c('small',[(_vm.isEditing)?_c('span',[_vm._v("wijzigen")]):_c('span',[_vm._v("toevoegen")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"naam"}},[_vm._v("Naam "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.naam),expression:"model.naam"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('naam') },attrs:{"type":"text","id":"naam","name":"naam"},domProps:{"value":(_vm.model.naam)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "naam", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('naam')),expression:"errors.has('naam')"}],staticClass:"small text-danger"},[_vm._v("Naam is verplicht")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"ingesteldeDli"}},[_vm._v("Ingestelde DLI "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ingesteldeDli),expression:"model.ingesteldeDli"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('ingesteldeDli') },attrs:{"type":"number","step":".1","min":"0","max":"99.9","id":"ingesteldeDli","name":"ingesteldeDli"},domProps:{"value":(_vm.model.ingesteldeDli)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ingesteldeDli", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('ingesteldeDli')),expression:"errors.has('ingesteldeDli')"}],staticClass:"small text-danger"},[_vm._v("Ingestelde DLI is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"lengteLichtperiode"}},[_vm._v("Lengte lichtperiode "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lengteLichtperiode),expression:"model.lengteLichtperiode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('lengteLichtperiode') },attrs:{"type":"number","step":".1","min":"0","max":"99.9","id":"lengteLichtperiode","name":"lengteLichtperiode"},domProps:{"value":(_vm.model.lengteLichtperiode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lengteLichtperiode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('lengteLichtperiode')),expression:"errors.has('lengteLichtperiode')"}],staticClass:"small text-danger"},[_vm._v("Lengte lichtperiode is verplicht")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"aantalDagenTotVolgroeid"}},[_vm._v("Aantal dagen tot volgroeid "),_c('sup',[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.aantalDagenTotVolgroeid),expression:"model.aantalDagenTotVolgroeid"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('aantalDagenTotVolgroeid') },attrs:{"type":"number","step":"1","min":"0","max":"999","id":"aantalDagenTotVolgroeid","name":"aantalDagenTotVolgroeid"},domProps:{"value":(_vm.model.aantalDagenTotVolgroeid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "aantalDagenTotVolgroeid", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('aantalDagenTotVolgroeid')),expression:"errors.has('aantalDagenTotVolgroeid')"}],staticClass:"small text-danger"},[_vm._v("Aantal dagen is verplicht")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-form',{attrs:{"model":_vm.model,"isEditing":false},on:{"save-item":_vm.addItem}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd299e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(505);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd299e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_teelt__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(502);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            listready: false,
            errormsg: '',
            items: []
        };
    },
    created: function created() {
        this.getItems();
    },

    methods: {
        getItems: function getItems() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_teelt__["a" /* default */].getListTeelt().then(function (response) {
                _this.items = response.data;
                _this.listready = true;
            });
        },
        deleteItem: function deleteItem(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_teelt__["a" /* default */].deleteTeelt(id).then(function () {
                _this2.getItems();
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-list': __WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */]
    }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce169158_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(504);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce169158_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'List',
    props: ['items'],
    data: function data() {
        return {
            id: -1,
            name: '',
            warningModal: false
        };
    },

    methods: {
        bevestigItem: function bevestigItem(id, name) {
            this.id = id;
            this.name = name;
            this.warningModal = true;
        },
        deleteItem: function deleteItem() {
            this.warningModal = false;
            this.$emit('delete-item', this.id);
        }
    }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.naam))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ingesteldeDli))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('router-link',{attrs:{"to":'/beheer/teelt/edit/' + item.id,"title":"Teeltsoort wijzigen"}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v("\n                         \n                        "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(item.deleteok),expression:"item.deleteok"}],attrs:{"title":"Teeltsoort verwijderen","href":"javascript:void(0)"},on:{"click":function($event){_vm.bevestigItem(item.id, item.naam)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])}))]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('router-link',{staticClass:"page-link",attrs:{"to":"/beheer/teelt/new"}},[_vm._v("Teeltsoort toevoegen")])],1)])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.deleteItem},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        Teeltsoort "),_c('b',[_vm._v(_vm._s(_vm.name))]),_vm._v(" wordt verwijderd. Bent u zeker?\n    ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Naam")]),_vm._v(" "),_c('th',[_vm._v("Ingestelde DLI")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listready)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"header":"<i class='fa fa-align-justify'></i><strong> Teeltsoorten</strong>"}},[_c('item-list',{attrs:{"items":_vm.items},on:{"delete-item":_vm.deleteItem}})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Verwijderen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Deze teeltsoort kan niet verwijderd worden! Deze teeltsoort wordt nog gebruikt. "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af864280_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(508);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af864280_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_teelt__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(93);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            errormsg: '',
            model: {}
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_teelt__["a" /* default */].getDetailTeelt(this.$route.params.id).then(function (response) {
            _this.model = response.data;
        });
    },

    methods: {
        updateItem: function updateItem(model) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_teelt__["a" /* default */].updateTeelt(model).then(function () {
                _this2.$router.replace('/beheer/teelt');
            }, function (error) {
                _this2.errormsg = error.message;
                _this2.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
    }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-item":_vm.updateItem}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Teeltsoort werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDliprofiel_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd2c5500_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDliprofiel_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDliprofiel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd2c5500_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDliprofiel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_FadeLoader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormDliprofiel_vue__ = __webpack_require__(512);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            warningProfiel: false,
            warningGeduld: false,
            warningGeduldImport: false,

            vraagBestand: false,
            errorImport: false,

            foutbestand: false,

            vraagBevestiging: false,
            vraagBewolkingsgraad: false,

            foutbewolkingsgraad: false,
            errormsg: '',
            model: {},

            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },
    created: function created() {
        this.getProfiel(this.$route.params.id);
    },

    methods: {
        getProfiel: function getProfiel(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getDliprofiel(id).then(function (response) {
                _this.model = response.data.model;
            });
        },
        createVastProfiel: function createVastProfiel(model) {
            this.vraagBevestiging = true;
        },
        closeFormVastProfiel: function closeFormVastProfiel(model) {
            this.vraagBevestiging = false;
        },
        maakVastProfiel: function maakVastProfiel(model) {
            var _this2 = this;

            this.warningGeduld = true;
            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].createVastDliprofiel(model).then(function () {
                _this2.warningGeduld = false;
                _this2.getProfiel(model.id);
            }, function (error) {
                _this2.warningGeduld = false;
                _this2.errormsg = error.message;
                _this2.warningProfiel = true;
            });
        },
        kies: function kies(vastofgemiddeld) {
            this.model.vastofgemiddeld = vastofgemiddeld;
        },
        createAdaptiefProfiel: function createAdaptiefProfiel(model) {
            this.model.bewolkingsgraad = "50";
            this.model.vastofgemiddeld = "V";
            this.foutbewolkingsgraad = false;
            this.vraagBewolkingsgraad = true;
        },
        closeFormAdaptiefProfiel: function closeFormAdaptiefProfiel(model) {
            this.vraagBewolkingsgraad = false;
        },
        maakAdaptiefProfiel: function maakAdaptiefProfiel(model, event) {
            var _this3 = this;

            if (this.model.bewolkingsgraad == "" && this.model.vastofgemiddeld == "V") {
                this.foutbewolkingsgraad = true;
            } else {
                this.foutbewolkingsgraad = false;
                this.vraagBewolkingsgraad = false;
                this.warningGeduld = true;
                __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].createAdaptiefDliprofiel(model).then(function () {
                    _this3.warningGeduld = false;
                    _this3.getProfiel(model.id);
                }, function (error) {
                    _this3.warningGeduld = false;
                    _this3.errormsg = error.message;
                    _this3.warningProfiel = true;
                });
            }
        },
        updateItem: function updateItem(model) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].updateDliprofiel(model).then(function () {
                _this4.$router.replace('/beheer/afdelingteelt');
            }, function (error) {
                _this4.errormsg = error.message;
                _this4.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
            this.warningProfiel = false;
        },
        openFormImport: function openFormImport(model) {
            this.$refs['file-input'].reset();
            this.foutbestand = false;
            this.vraagBestand = true;
        },
        closeFormImport: function closeFormImport(model) {
            this.vraagBestand = false;
        },
        doImport: function doImport(model, event) {
            var _this5 = this;

            if (this.model.fileToUpload == undefined) {
                this.foutbestand = true;
            } else {
                this.foutbestand = false;
                this.vraagBestand = false;
                this.warningGeduldImport = true;

                var formData = new FormData();
                formData.append('fileToUpload', this.model.fileToUpload);
                formData.append('id', this.model.id);
                __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].importDLIProfiel(formData).then(function () {
                    _this5.warningGeduldImport = false;
                    _this5.getProfiel(model.id);
                }, function (error) {
                    _this5.warningGeduldImport = false;
                    _this5.errormsg = error.message;
                    _this5.errorImport = true;
                });
            }
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_2__FormDliprofiel_vue__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormDliprofiel_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466926ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormDliprofiel_vue__ = __webpack_require__(563);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormDliprofiel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466926ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormDliprofiel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChartLineVerticalLine__ = __webpack_require__(515);








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'isEditing'],
    data: function data() {
        return {
            nl: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__["a" /* nl */],

            firstrow: -1,
            firstrow2: -1,
            currentview: 'data',
            datacollection: null,
            miny: 0,
            maxy: 25,
            changeyaxis: false,
            begindatum: '',
            einddatum: '',
            disabled: {
                to: new Date(),
                from: new Date()
            }
        };
    },

    methods: {
        changeView: function changeView(view) {
            this.currentview = view;
            if (view === 'grafiek') {
                if (this.begindatum === '') {
                    this.begindatum = new Date(this.model.historiekteelt_n[0].datum);
                    this.einddatum = new Date(this.model.historiekteelt_n[this.model.historiekteelt_n.length - 1].datum);
                    this.disabled.to = this.begindatum;
                    this.disabled.from = this.einddatum;
                }
                this.fillGraphData();
            }
        },
        getMaxValueDatasets: function getMaxValueDatasets(datasets) {
            var maxwaarde = 0;
            datasets.forEach(function (dataset) {
                maxwaarde = Math.max(maxwaarde, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataset.data)));
            });
            return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
        },
        fillGraphData: function fillGraphData() {
            var lines = [];
            var values = [];
            this.getPlantdichtheid(lines, values);
            this.datacollection = {
                labels: this.getGraphLabels(),
                datasets: this.getGraphBarsAndLines(),
                verticallines: lines,
                values: values };
            this.miny = 0;
            this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
            this.changeyaxis = !this.changeyaxis;
        },
        getPlantdichtheid: function getPlantdichtheid(lines, values) {
            var _this = this;

            var vorigedichtheid = 0;
            var indexcount = 0;
            this.model.historiekteelt_n.forEach(function (historiekteelt) {
                if (historiekteelt.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.begindatum) && historiekteelt.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.einddatum)) {
                    if (vorigedichtheid != historiekteelt.plantdichtheid) {
                        lines.push(indexcount);
                        values.push(historiekteelt.plantdichtheid == null ? "" : historiekteelt.plantdichtheid);
                        vorigedichtheid = historiekteelt.plantdichtheid;
                    }
                    indexcount = indexcount + 1;
                }
            });
        },
        getGraphLabels: function getGraphLabels() {
            var _this2 = this;

            var labels = [];
            this.model.historiekteelt_n.forEach(function (historiekteelt) {
                if (historiekteelt.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.begindatum) && historiekteelt.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.einddatum)) {
                    labels.push(_this2.datumDDMMYYYY(historiekteelt.datum));
                }
            });
            return labels;
        },
        getGraphBarsAndLines: function getGraphBarsAndLines() {
            var datasets = [];
            this.getGraphDliGewenst(datasets);
            return datasets;
        },
        getGraphDliGewenst: function getGraphDliGewenst(datasets) {
            var _this3 = this;

            var data = [];
            this.model.historiekteelt_n.forEach(function (historiekteelt) {
                if (historiekteelt.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.begindatum) && historiekteelt.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.einddatum)) {
                    data.push(historiekteelt.gewensteDli);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(23,23,23, 0)',
                borderColor: 'rgba(23,23,23, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                label: ' DLI gewenst',
                data: data
            };
            datasets.push(dataset);
        },
        wis: function wis(historiekteelt) {
            historiekteelt.gewensteDli = '0';
        },
        wis2: function wis2(historiekteelt) {
            historiekteelt.plantdichtheid = '0';
        },
        klikt: function klikt(index) {
            if (this.model.historiekteelt_n[index].selected === 0) {
                if (this.firstrow === -1) {
                    this.model.historiekteelt_n[index].selected = 1;
                    this.firstrow = index;
                } else if (this.firstrow < index) {
                    for (var i = this.firstrow + 1; i <= index; i += 1) {
                        this.model.historiekteelt_n[i].gewensteDli = this.model.historiekteelt_n[this.firstrow].gewensteDli;
                    }
                    this.model.historiekteelt_n[this.firstrow].selected = 0;
                    this.firstrow = -1;
                }
            } else {
                this.model.historiekteelt_n[index].selected = 0;
                this.firstrow = -1;
            }
        },
        selectValue: function selectValue(historiekteelt) {
            if (historiekteelt.selected === 0) {
                return 'fa fa-navicon';
            }
            if (historiekteelt.selected === 1) {
                return 'fa fa-sort-amount-asc';
            }
            return '';
        },
        klikt2: function klikt2(index) {
            if (this.model.historiekteelt_n[index].selected2 === 0) {
                if (this.firstrow2 === -1) {
                    this.model.historiekteelt_n[index].selected2 = 1;
                    this.firstrow2 = index;
                } else if (this.firstrow2 < index) {
                    for (var i = this.firstrow2 + 1; i <= index; i += 1) {
                        this.model.historiekteelt_n[i].plantdichtheid = this.model.historiekteelt_n[this.firstrow2].plantdichtheid;
                    }
                    this.model.historiekteelt_n[this.firstrow2].selected2 = 0;
                    this.firstrow2 = -1;
                }
            } else {
                this.model.historiekteelt_n[index].selected2 = 0;
                this.firstrow2 = -1;
            }
        },
        selectValue2: function selectValue2(historiekteelt) {
            if (historiekteelt.selected2 === 0) {
                return 'fa fa-navicon';
            }
            if (historiekteelt.selected2 === 1) {
                return 'fa fa-sort-amount-asc';
            }
            return '';
        },
        createvastprofiel: function createvastprofiel() {
            this.$emit('create-vast-profiel', this.model);
        },
        createadaptiefprofiel: function createadaptiefprofiel() {
            this.$emit('create-adaptief-profiel', this.model);
        },
        openFormImport: function openFormImport() {
            this.$emit('open-form-import', this.model);
        },
        saveItem: function saveItem() {
            var _this4 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this4.isError) {
                        _this4.$emit('save-item', _this4.model);
                    }
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        }
    },
    computed: {
        profielbestaat: function profielbestaat() {
            return this.model.historiekteelt_n.length !== 0;
        }
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
        chart: __WEBPACK_IMPORTED_MODULE_4__ChartLineVerticalLine__["a" /* default */]
    }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineVerticalLine_vue__ = __webpack_require__(516);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineVerticalLine_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    mixins: [reactiveProp],
    props: ['height', 'miny', 'maxy', 'changeyaxis'],
    data: function data() {
        return {
            options: {
                tooltips: {
                    intersect: false
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.addPlugin({
            id: 'chart-plugin',
            afterDatasetsDraw: function afterDatasetsDraw(chart) {
                var lines = chart.data.verticallines;

                var values = chart.data.values;

                var c = chart.canvas;
                var ctx = c.getContext("2d");

                var xaxis = chart.scales['x-axis-0'];
                var yaxis = chart.scales['y-axis-0'];

                for (var i = 0; i < lines.length; i++) {
                    var index = lines[i];

                    ctx.lineWidth = 1;
                    ctx.strokeStyle = '#0bb6ff';

                    ctx.beginPath();
                    ctx.moveTo(xaxis.getPixelForValue(undefined, index), 0);
                    ctx.lineTo(xaxis.getPixelForValue(undefined, index), yaxis.bottom + 5);
                    ctx.stroke();

                    ctx.beginPath();
                    ctx.font = "10px Verdana";
                    ctx.fillStyle = '#0bb6ff';
                    ctx.fillText(values[i], xaxis.getPixelForValue(undefined, index) + 5, yaxis.bottom - 7);
                }
            }
        });

        this.renderChart(this.chartData, this.options);
    },

    watch: {
        changeyaxis: function changeyaxis() {
            this.$data._chart.destroy();
            this.options.scales.yAxes[0].ticks.min = this.miny;

            this.options.scales.yAxes[0].ticks.max = this.maxy;

            this.renderChart(this.chartData, this.options);
        }
    }
});

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 101,
	"./af.js": 101,
	"./ar": 102,
	"./ar-dz": 103,
	"./ar-dz.js": 103,
	"./ar-kw": 104,
	"./ar-kw.js": 104,
	"./ar-ly": 105,
	"./ar-ly.js": 105,
	"./ar-ma": 106,
	"./ar-ma.js": 106,
	"./ar-sa": 107,
	"./ar-sa.js": 107,
	"./ar-tn": 108,
	"./ar-tn.js": 108,
	"./ar.js": 102,
	"./az": 109,
	"./az.js": 109,
	"./be": 110,
	"./be.js": 110,
	"./bg": 111,
	"./bg.js": 111,
	"./bm": 112,
	"./bm.js": 112,
	"./bn": 113,
	"./bn.js": 113,
	"./bo": 114,
	"./bo.js": 114,
	"./br": 115,
	"./br.js": 115,
	"./bs": 116,
	"./bs.js": 116,
	"./ca": 117,
	"./ca.js": 117,
	"./cs": 118,
	"./cs.js": 118,
	"./cv": 119,
	"./cv.js": 119,
	"./cy": 120,
	"./cy.js": 120,
	"./da": 121,
	"./da.js": 121,
	"./de": 122,
	"./de-at": 123,
	"./de-at.js": 123,
	"./de-ch": 124,
	"./de-ch.js": 124,
	"./de.js": 122,
	"./dv": 125,
	"./dv.js": 125,
	"./el": 126,
	"./el.js": 126,
	"./en-au": 127,
	"./en-au.js": 127,
	"./en-ca": 128,
	"./en-ca.js": 128,
	"./en-gb": 129,
	"./en-gb.js": 129,
	"./en-ie": 130,
	"./en-ie.js": 130,
	"./en-il": 131,
	"./en-il.js": 131,
	"./en-nz": 132,
	"./en-nz.js": 132,
	"./eo": 133,
	"./eo.js": 133,
	"./es": 134,
	"./es-do": 135,
	"./es-do.js": 135,
	"./es-us": 136,
	"./es-us.js": 136,
	"./es.js": 134,
	"./et": 137,
	"./et.js": 137,
	"./eu": 138,
	"./eu.js": 138,
	"./fa": 139,
	"./fa.js": 139,
	"./fi": 140,
	"./fi.js": 140,
	"./fo": 141,
	"./fo.js": 141,
	"./fr": 142,
	"./fr-ca": 143,
	"./fr-ca.js": 143,
	"./fr-ch": 144,
	"./fr-ch.js": 144,
	"./fr.js": 142,
	"./fy": 145,
	"./fy.js": 145,
	"./gd": 146,
	"./gd.js": 146,
	"./gl": 147,
	"./gl.js": 147,
	"./gom-latn": 148,
	"./gom-latn.js": 148,
	"./gu": 149,
	"./gu.js": 149,
	"./he": 150,
	"./he.js": 150,
	"./hi": 151,
	"./hi.js": 151,
	"./hr": 152,
	"./hr.js": 152,
	"./hu": 153,
	"./hu.js": 153,
	"./hy-am": 154,
	"./hy-am.js": 154,
	"./id": 155,
	"./id.js": 155,
	"./is": 156,
	"./is.js": 156,
	"./it": 157,
	"./it.js": 157,
	"./ja": 158,
	"./ja.js": 158,
	"./jv": 159,
	"./jv.js": 159,
	"./ka": 160,
	"./ka.js": 160,
	"./kk": 161,
	"./kk.js": 161,
	"./km": 162,
	"./km.js": 162,
	"./kn": 163,
	"./kn.js": 163,
	"./ko": 164,
	"./ko.js": 164,
	"./ky": 165,
	"./ky.js": 165,
	"./lb": 166,
	"./lb.js": 166,
	"./lo": 167,
	"./lo.js": 167,
	"./lt": 168,
	"./lt.js": 168,
	"./lv": 169,
	"./lv.js": 169,
	"./me": 170,
	"./me.js": 170,
	"./mi": 171,
	"./mi.js": 171,
	"./mk": 172,
	"./mk.js": 172,
	"./ml": 173,
	"./ml.js": 173,
	"./mn": 174,
	"./mn.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 176,
	"./ms-my": 177,
	"./ms-my.js": 177,
	"./ms.js": 176,
	"./mt": 178,
	"./mt.js": 178,
	"./my": 179,
	"./my.js": 179,
	"./nb": 180,
	"./nb.js": 180,
	"./ne": 181,
	"./ne.js": 181,
	"./nl": 182,
	"./nl-be": 183,
	"./nl-be.js": 183,
	"./nl.js": 182,
	"./nn": 184,
	"./nn.js": 184,
	"./pa-in": 185,
	"./pa-in.js": 185,
	"./pl": 186,
	"./pl.js": 186,
	"./pt": 187,
	"./pt-br": 188,
	"./pt-br.js": 188,
	"./pt.js": 187,
	"./ro": 189,
	"./ro.js": 189,
	"./ru": 190,
	"./ru.js": 190,
	"./sd": 191,
	"./sd.js": 191,
	"./se": 192,
	"./se.js": 192,
	"./si": 193,
	"./si.js": 193,
	"./sk": 194,
	"./sk.js": 194,
	"./sl": 195,
	"./sl.js": 195,
	"./sq": 196,
	"./sq.js": 196,
	"./sr": 197,
	"./sr-cyrl": 198,
	"./sr-cyrl.js": 198,
	"./sr.js": 197,
	"./ss": 199,
	"./ss.js": 199,
	"./sv": 200,
	"./sv.js": 200,
	"./sw": 201,
	"./sw.js": 201,
	"./ta": 202,
	"./ta.js": 202,
	"./te": 203,
	"./te.js": 203,
	"./tet": 204,
	"./tet.js": 204,
	"./tg": 205,
	"./tg.js": 205,
	"./th": 206,
	"./th.js": 206,
	"./tl-ph": 207,
	"./tl-ph.js": 207,
	"./tlh": 208,
	"./tlh.js": 208,
	"./tr": 209,
	"./tr.js": 209,
	"./tzl": 210,
	"./tzl.js": 210,
	"./tzm": 211,
	"./tzm-latn": 212,
	"./tzm-latn.js": 212,
	"./tzm.js": 211,
	"./ug-cn": 213,
	"./ug-cn.js": 213,
	"./uk": 214,
	"./uk.js": 214,
	"./ur": 215,
	"./ur.js": 215,
	"./uz": 216,
	"./uz-latn": 217,
	"./uz-latn.js": 217,
	"./uz.js": 216,
	"./vi": 218,
	"./vi.js": 218,
	"./x-pseudo": 219,
	"./x-pseudo.js": 219,
	"./yo": 220,
	"./yo.js": 220,
	"./zh-cn": 221,
	"./zh-cn.js": 221,
	"./zh-hk": 222,
	"./zh-hk.js": 222,
	"./zh-tw": 223,
	"./zh-tw.js": 223
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 544;

/***/ }),
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" DLI profiel")]),_vm._v(" "),_c('small',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.profielbestaat),expression:"profielbestaat"}]},[_vm._v("wijzigen")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.profielbestaat),expression:"!profielbestaat"}]},[_vm._v("creëren")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Afdeling: ")]),_c('td',[_vm._v(_vm._s(_vm.model.afdeling.naam))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewas: ")]),_c('td',[_vm._v(_vm._s(_vm.model.teelt.naam)+" - "+_vm._s(_vm.model.ras))]),_vm._v(" "),_c('th',[_vm._v("Aanplantdatum - einddatum: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.aanplantdatum))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatum)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewenste DLI: ")]),_c('td',[_vm._v(_vm._s(_vm.model.ingesteldeDli))]),_vm._v(" "),_c('th',[_vm._v("Belichtingsseizoen start - einde: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.startdatumBelichting))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatumBelichting)))])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.profielbestaat),expression:"!profielbestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"red"},[_vm._v("Er bestaat nog geen DLI profiel voor deze teelt.")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.profielbestaat),expression:"!profielbestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-button',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.createvastprofiel}},[_vm._v("Vast DLI profiel creëren")]),_vm._v("\n                         \n                        "),_c('b-button',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.createadaptiefprofiel}},[_vm._v("Adaptief DLI profiel creëren")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.profielbestaat),expression:"profielbestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.profielbestaat),expression:"profielbestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('b-button-group',{attrs:{"id":"periode","name":"periode"}},[_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'data'},on:{"click":function($event){_vm.changeView('data')}}},[_vm._v("Data")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'grafiek'},on:{"click":function($event){_vm.changeView('grafiek')}}},[_vm._v("Grafiek")])],1)],1),_vm._v("\n                         "),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'data'),expression:"currentview == 'data'"}],staticClass:"col-sm-8"},[_c('b-button',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.createvastprofiel}},[_vm._v("Nieuw vast DLI profiel creëren")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.createadaptiefprofiel}},[_vm._v("Nieuw adaptief DLI profiel creëren")]),_vm._v(" "),_c('b-button',{staticStyle:{"background-color":"#ffffff"},attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){_vm.openFormImport()}}},[_vm._v("DLI profiel importeren")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'grafiek'),expression:"currentview == 'grafiek'"}],staticClass:"col-sm-6"},[_c('b-input-group',[_c('b-input-group',{attrs:{"left":"Van"}},[_c('datepicker',{ref:"begindatum",staticStyle:{"background-color":"#ffffff"},attrs:{"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"begindatum","id":"begindatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphData()}},model:{value:(_vm.begindatum),callback:function ($$v) {_vm.begindatum=$$v},expression:"begindatum"}})],1),_vm._v("\n                              \n                            "),_c('b-input-group',{attrs:{"left":"Tot"}},[_c('datepicker',{ref:"einddatum",staticStyle:{"background-color":"#ffffff"},attrs:{"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"einddatum","id":"einddatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphData()}},model:{value:(_vm.einddatum),callback:function ($$v) {_vm.einddatum=$$v},expression:"einddatum"}})],1),_vm._v("\n                                  \n                        ")],1)],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.profielbestaat && _vm.currentview == 'data'),expression:"profielbestaat && currentview == 'data'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Datum")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('th'):_vm._e(),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('th',[_vm._v("Plantbehang")]):_vm._e()]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',[_vm._v("29/02/2020")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-navicon"})])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{staticClass:"form-control smallwidth",attrs:{"type":"number","step":".1","min":"0","max":"99.9"}})])]),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-navicon"})])]):_vm._e(),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{staticClass:"form-control smallwidth",attrs:{"type":"number","step":"1","min":"0","max":"99"}})])]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',[_vm._v("Datum")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('th'):_vm._e(),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('th',[_vm._v("Planbehang")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.model.historiekteelt_n),function(historiekteelt,indexi){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(historiekteelt.datum)))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.klikt(indexi)}}},[_c('i',{class:_vm.selectValue(historiekteelt)})])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(historiekteelt.gewensteDli),expression:"historiekteelt.gewensteDli"}],staticClass:"form-control smallwidth",attrs:{"required":"","type":"number","step":".1","min":"0","max":"99.9","id":"gewensteDli","name":"'gewensteDli' + indexi)"},domProps:{"value":(historiekteelt.gewensteDli)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.wis(historiekteelt)},"input":function($event){if($event.target.composing){ return; }_vm.$set(historiekteelt, "gewensteDli", $event.target.value)}}})])]),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.klikt2(indexi)}}},[_c('i',{class:_vm.selectValue2(historiekteelt)})])]):_vm._e(),_vm._v(" "),([1, 7, 8].includes(_vm.model.teelt.id))?_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(historiekteelt.plantdichtheid),expression:"historiekteelt.plantdichtheid"}],staticClass:"form-control smallwidth",attrs:{"required":"","type":"number","pattern":"\\d*","step":"1","min":"0","max":"99","id":"plantdichtheid","name":"'plantdichtheid' + indexi)"},domProps:{"value":(historiekteelt.plantdichtheid)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.wis2(historiekteelt)},"input":function($event){if($event.target.composing){ return; }_vm.$set(historiekteelt, "plantdichtheid", $event.target.value)}}})])]):_vm._e()])})],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.profielbestaat && _vm.currentview == 'grafiek'),expression:"profielbestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("DLI profiel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("mol/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chart',{staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection,"height":"400","miny":_vm.miny,"maxy":_vm.maxy,"changeyaxis":_vm.changeyaxis}})],1)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.profielbestaat),expression:"profielbestaat"}],attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-item":_vm.updateItem,"create-vast-profiel":_vm.createVastProfiel,"create-adaptief-profiel":_vm.createAdaptiefProfiel,"open-form-import":_vm.openFormImport}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: DLI profiel werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"DLI profiel creëren","size":"sm"},model:{value:(_vm.warningGeduld),callback:function ($$v) {_vm.warningGeduld=$$v},expression:"warningGeduld"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("DLI profiel wordt gecreëerd. Deze bewerking kan even duren.")])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Vast DLI profiel creëren","size":"sm","no-close-on-backdrop":true},model:{value:(_vm.vraagBevestiging),callback:function ($$v) {_vm.vraagBevestiging=$$v},expression:"vraagBevestiging"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.closeFormVastProfiel(_vm.model)}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.maakVastProfiel(_vm.model)}}},[_vm._v("OK")])],1)]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Let op! Indien er al een DLI profiel bestaat, dan wordt dit overschreven!")])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Adaptief DLI profiel creëren","size":"sm","no-close-on-backdrop":true},model:{value:(_vm.vraagBewolkingsgraad),callback:function ($$v) {_vm.vraagBewolkingsgraad=$$v},expression:"vraagBewolkingsgraad"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.closeFormAdaptiefProfiel(_vm.model)}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.maakAdaptiefProfiel(_vm.model)}}},[_vm._v("OK")])],1)]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Let op! Indien er al een DLI profiel bestaat, dan wordt dit overschreven!")])]),_vm._v(" "),_c('p'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vastofgemiddeld),expression:"model.vastofgemiddeld"}],attrs:{"type":"radio","name":"optradio","value":"V"},domProps:{"checked":_vm._q(_vm.model.vastofgemiddeld,"V")},on:{"change":[function($event){_vm.$set(_vm.model, "vastofgemiddeld", "V")},function($event){_vm.kies('V')}]}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"radio-inline",staticStyle:{"margin-left":"-20px"}},[_vm._v("Vaste bewolkingsgraad")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"bewolkingsgraad"}},[_vm._v("Percentage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bewolkingsgraad),expression:"model.bewolkingsgraad"},{name:"validate",rawName:"v-validate",value:('min_value:0|max_value:100'),expression:"'min_value:0|max_value:100'"}],class:{'form-control': true, 'is-invalid': _vm.errors.has('bewolkingsgraad') },attrs:{"type":"number","step":"1","min":"0","max":"100","id":"bewolkingsgraad","name":"bewolkingsgraad"},domProps:{"value":(_vm.model.bewolkingsgraad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "bewolkingsgraad", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.foutbewolkingsgraad),expression:"foutbewolkingsgraad"}],staticClass:"small text-danger"},[_vm._v("Bewolkingsgraad is een waarde tussen 0 en 100")])])])]),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vastofgemiddeld),expression:"model.vastofgemiddeld"}],attrs:{"type":"radio","name":"optradio","value":"G"},domProps:{"checked":_vm._q(_vm.model.vastofgemiddeld,"G")},on:{"change":[function($event){_vm.$set(_vm.model, "vastofgemiddeld", "G")},function($event){_vm.kies('G')}]}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"radio-inline",staticStyle:{"margin-left":"-20px"}},[_vm._v("Gemiddelde bewolkingsgraad")])])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"DLI profiel importeren","size":"lg","no-close-on-backdrop":true},model:{value:(_vm.vraagBestand),callback:function ($$v) {_vm.vraagBestand=$$v},expression:"vraagBestand"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.closeFormImport(_vm.model)}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.doImport(_vm.model)}}},[_vm._v("OK")])],1)]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Let op! Bestaand DLI profiel wordt overschreven!")])]),_vm._v(" "),_c('p'),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"fileToUpload"}},[_vm._v("Csv-bestand")]),_vm._v(" "),_c('b-form-file',{ref:"file-input",attrs:{"accept":".csv","id":"fileToUpload","name":"fileToUpload","plain":true},model:{value:(_vm.model.fileToUpload),callback:function ($$v) {_vm.$set(_vm.model, "fileToUpload", $$v)},expression:"model.fileToUpload"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.foutbestand),expression:"foutbestand"}],staticClass:"small text-danger"},[_vm._v("Kies een csv-bestand")])],1),_vm._v(" "),_c('p')]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"DLI profiel importeren","size":"sm"},model:{value:(_vm.warningGeduldImport),callback:function ($$v) {_vm.warningGeduldImport=$$v},expression:"warningGeduldImport"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Het DLI profiel wordt geïmporteerd. Deze bewerking kan even duren.")])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"DLI profiel importeren","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.errorImport),callback:function ($$v) {_vm.errorImport=$$v},expression:"errorImport"}},[_vm._v("\n        FOUT: DLI profiel werd niet geïmporteerd! Controleer de structuur van het csv-bestand. "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"DLI profiel creëren","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningProfiel),callback:function ($$v) {_vm.warningProfiel=$$v},expression:"warningProfiel"}},[_vm._v("\n        FOUT: DLI profiel werd niet gecreëerd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_c('div',{staticClass:"midden"},[_c('div',{staticStyle:{"color":"#20a8d8","font-size":"large"}},[_vm._v("Even geduld a.u.b.")]),_vm._v(" "),_c('fadeloader',{staticClass:"spinner2",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditKlassiek_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533659f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditKlassiek_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditKlassiek_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533659f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditKlassiek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_FadeLoader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormKlassiek__ = __webpack_require__(568);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            warningSchema: false,
            warningGeduld: false,
            warningGeduldImport: false,

            vraagBevestiging: false,
            vraagBestand: false,
            errorImport: false,

            foutbestand: false,
            errormsg: '',
            model: {},

            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },
    created: function created() {
        this.getSchema(this.$route.params.id);
    },

    methods: {
        getSchema: function getSchema(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getKlassiekebelichting(id).then(function (response) {
                _this.model = response.data.model;
            });
        },
        createSchema: function createSchema(model) {
            var _this2 = this;

            this.warningGeduld = true;
            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].createKlassiekebelichting(model).then(function () {
                _this2.warningGeduld = false;
                _this2.getSchema(model.id);
            }, function (error) {
                _this2.warningGeduld = false;
                _this2.errormsg = error.message;
                _this2.warningSchema = true;
            });
        },
        updateItem: function updateItem(model) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].updateKlassiekebelichting(model).then(function () {
                _this3.$router.replace('/beheer/afdelingteelt');
            }, function (error) {
                _this3.errormsg = error.message;
                _this3.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
            this.warningSchema = false;
        },
        openFormImport: function openFormImport(model) {
            this.$refs['file-input'].reset();
            this.foutbestand = false;
            this.vraagBestand = true;
        },
        closeFormImport: function closeFormImport(model) {
            this.vraagBestand = false;
        },
        doImport: function doImport(model, event) {
            var _this4 = this;

            if (this.model.fileToUpload == undefined) {
                this.foutbestand = true;
            } else {
                this.foutbestand = false;
                this.vraagBestand = false;
                this.warningGeduldImport = true;

                var formData = new FormData();
                formData.append('fileToUpload', this.model.fileToUpload);
                formData.append('id', this.model.id);
                __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].importBelichtingsschema(formData).then(function () {
                    _this4.warningGeduldImport = false;
                    _this4.getSchema(model.id);
                }, function (error) {
                    _this4.warningGeduldImport = false;
                    _this4.errormsg = error.message;
                    _this4.errorImport = true;
                });
            }
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_2__FormKlassiek__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormKlassiek_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6cb1b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormKlassiek_vue__ = __webpack_require__(572);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormKlassiek_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6cb1b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormKlassiek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChartMixed__ = __webpack_require__(60);









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'isEditing'],
    data: function data() {
        return {
            nl: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__["a" /* nl */],
            firstrow: -1,
            currentview: 'data',
            datacollection: null,
            miny: 0,
            maxy: 25,
            changeyaxis: false,
            begindatum: '',
            einddatum: '',
            disabled: {
                to: new Date(),
                from: new Date()
            },
            bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(255,221,50,1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)'],
            fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(255,221,50,0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)']
        };
    },

    methods: {
        changeView: function changeView(view) {
            this.currentview = view;
            if (view === 'grafiek') {
                if (this.begindatum === '') {
                    this.begindatum = new Date(this.model.klassiekebelichting_n[0].datum);
                    this.einddatum = new Date(this.model.klassiekebelichting_n[this.model.klassiekebelichting_n.length - 1].datum);
                    this.disabled.to = this.begindatum;
                    this.disabled.from = this.einddatum;
                }
                this.fillGraphData();
            }
        },
        getMaxValueDatasets: function getMaxValueDatasets(datasets) {
            var maxwaarde = 0;
            datasets.forEach(function (dataset) {
                maxwaarde = Math.max(maxwaarde, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataset.data)));
            });
            return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
        },
        fillGraphData: function fillGraphData() {
            this.datacollection = {
                type: 'bar',
                labels: this.getGraphLabels(),
                datasets: this.getGraphBarsAndLines()
            };
            this.miny = 0;
            this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
            this.changeyaxis = !this.changeyaxis;
        },
        getGraphLabels: function getGraphLabels() {
            var _this = this;

            var labels = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.einddatum)) {
                    labels.push(_this.datumDDMMYYYY(klassiek.datum));
                }
            });
            return labels;
        },
        getGraphBarsAndLines: function getGraphBarsAndLines() {
            var datasets = [];
            this.getGraphSystemen(datasets);
            this.getGraphDliZon(datasets);
            this.getGraphDliGewenst(datasets);
            this.getGraphDliTotaal(datasets);
            return datasets;
        },
        getGraphSystemen: function getGraphSystemen(datasets) {
            for (var i = 0; i < this.aantalsystemen; i += 1) {
                var dataset = {
                    backgroundColor: this.fillcolors[i % 10],
                    borderColor: this.bordercolors[i % 10],
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 1,
                    label: this.getSysteemNaam(i),
                    data: this.getGraphData(i),
                    yAxisID: 'bar'
                };
                datasets.push(dataset);
            }
        },
        getSysteemNaam: function getSysteemNaam(gezocht) {
            var naam = '';
            var index = 0;
            for (var i = 0; i < this.model.afdeling.belichting_n.length; i += 1) {
                var nr = 1;
                for (var j = 0; j < this.model.afdeling.belichting_n[i].schakelniveau_n.length; j += 1) {
                    if (index === gezocht) {
                        naam = this.model.afdeling.belichting_n[i].soortbelichting.naam + ' ' + nr;
                    }
                    index += 1;
                    nr += 1;
                }
            }
            return naam;
        },
        getGraphData: function getGraphData(i) {
            var data = [];
            for (var j = 0; j < this.model.klassiekebelichting_n.length; j += 1) {
                if (this.model.klassiekebelichting_n[j].datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.begindatum) && this.model.klassiekebelichting_n[j].datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.einddatum)) {
                    data.push(this.komma2(this.dlibelichting[j].perdag[i].mol));
                }
            }
            return data;
        },
        getGraphDliZon: function getGraphDliZon(datasets) {
            var _this2 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.einddatum)) {
                    data.push(klassiek.dliZon);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(25,25,112, 0)',
                borderColor: 'rgba(25,25,112, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI zon',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliGewenst: function getGraphDliGewenst(datasets) {
            var _this3 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.einddatum)) {
                    data.push(klassiek.gewensteDli);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(23,23,23, 0)',
                borderColor: 'rgba(23,23,23, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI gewenst',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliTotaal: function getGraphDliTotaal(datasets) {
            var data = [];
            for (var j = 0; j < this.model.klassiekebelichting_n.length; j += 1) {
                if (this.model.klassiekebelichting_n[j].datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.begindatum) && this.model.klassiekebelichting_n[j].datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.einddatum)) {
                    data.push(this.komma1(this.dlitotaal[j]));
                }
            }
            var dataset = {
                backgroundColor: 'rgba(178,34,34, 0)',
                borderColor: 'rgba(178,34,34, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI werkelijk ontvangen',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        wis: function wis(perdag) {
            perdag.tijd = '00:00';
        },
        klikt: function klikt(index) {
            if (this.model.klassiekebelichting_n[index].selected === 0) {
                if (this.firstrow === -1) {
                    this.model.klassiekebelichting_n[index].selected = 1;
                    this.firstrow = index;
                } else if (this.firstrow < index) {
                    for (var i = this.firstrow + 1; i <= index; i += 1) {
                        for (var j = 0; j < this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n.length; j += 1) {
                            this.model.klassiekebelichting_n[i].klassiekperdag_n[j].tijd = this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n[j].tijd;
                        }
                    }
                    this.model.klassiekebelichting_n[this.firstrow].selected = 0;
                    this.firstrow = -1;
                }
            } else {
                this.model.klassiekebelichting_n[index].selected = 0;
                this.firstrow = -1;
            }
        },
        selectValue: function selectValue(klassiek) {
            if (klassiek.selected === 0) {
                return 'fa fa-navicon';
            }
            if (klassiek.selected === 1) {
                return 'fa fa-sort-amount-asc';
            }
            return '';
        },
        genoegLicht: function genoegLicht(nodig, hebje) {
            if (hebje >= nodig) {
                return 'green';
            }
            if (hebje >= nodig * 0.75) {
                return 'orange';
            }
            return 'red';
        },
        createschema: function createschema() {
            this.$emit('create-schema', this.model);
        },
        openFormImport: function openFormImport() {
            this.$emit('open-form-import', this.model);
        },
        saveItem: function saveItem() {
            var _this4 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this4.isError) {
                        _this4.$emit('save-item', _this4.model);
                    }
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        },
        timeHHMM: function timeHHMM(time) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].timetoHHMM(time);
        },
        berekenVermogen: function berekenVermogen(schakelniveau, belichting) {
            return belichting.fotonflux * schakelniveau.percentage / 100;
        },
        komma4: function komma4(waarde) {
            if (isNaN(waarde)) {
                return '#.####';
            }
            return waarde.toFixed(4);
        },
        komma2: function komma2(waarde) {
            if (isNaN(waarde)) {
                return '#.##';
            }
            return waarde.toFixed(2);
        },
        komma1: function komma1(waarde) {
            if (isNaN(waarde)) {
                return '#.#';
            }
            return waarde.toFixed(1);
        },
        komma0: function komma0(waarde) {
            if (isNaN(waarde)) {
                return '#';
            }
            return waarde.toFixed(0);
        }
    },
    computed: {
        schemabestaat: function schemabestaat() {
            return this.model.klassiekebelichting_n.length !== 0;
        },
        aantalsystemen: function aantalsystemen() {
            var aantal = 0;
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                aantal += belichting.schakelniveau_n.length;
            });
            return aantal;
        },
        dlibelichting: function dlibelichting() {
            var _this5 = this;

            var resultaat = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                var perdagarray = [];
                klassiek.klassiekperdag_n.forEach(function (perdag, i) {
                    perdagarray.push({ mol: __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].getSeconden(perdag.tijd) * _this5.installatie[i] / 1000000 });
                });
                resultaat.push({ datum: klassiek.datum, perdag: perdagarray });
            });
            return resultaat;
        },
        dlitotaal: function dlitotaal() {
            var _this6 = this;

            var resultaat = [];
            var i = 0;
            this.dlibelichting.forEach(function (dlibelichting) {
                var totaal = 0;
                dlibelichting.perdag.forEach(function (perdag) {
                    totaal += perdag.mol;
                });
                totaal += parseFloat(_this6.model.klassiekebelichting_n[i].dliZon);
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        dlicumulatief: function dlicumulatief() {
            var resultaat = [];
            var vorigtotaal = this.model.cumulatief;
            this.dlitotaal.forEach(function (dlitotaal) {
                resultaat.push(vorigtotaal + dlitotaal);
                vorigtotaal += dlitotaal;
            });
            return resultaat;
        },
        installatie: function installatie() {
            var _this7 = this;

            var resultaat = [];
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                belichting.schakelniveau_n.forEach(function (schakelniveau) {
                    resultaat.push(_this7.berekenVermogen(schakelniveau, belichting));
                });
            });
            return resultaat;
        }
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
        chart: __WEBPACK_IMPORTED_MODULE_4__ChartMixed__["a" /* default */]
    }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    mixins: [reactiveProp],
    props: ['height', 'miny', 'maxy', 'changeyaxis'],
    data: function data() {
        return {
            options: {
                tooltips: {
                    mode: 'index'
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        categorySpacing: 0,
                        categoryPercentage: 0.8,
                        barPercentage: 0.8,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        id: 'bar',
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }, {
                        id: 'line',
                        stacked: false,
                        display: false,
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    },

    watch: {
        changeyaxis: function changeyaxis() {
            this.$data._chart.destroy();
            this.options.scales.yAxes[0].ticks.min = this.miny;
            this.options.scales.yAxes[1].ticks.min = this.miny;
            this.options.scales.yAxes[0].ticks.max = this.maxy;
            this.options.scales.yAxes[1].ticks.max = this.maxy;
            this.renderChart(this.chartData, this.options);
        }
    }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Klassiek belichtingsschema")]),_vm._v(" "),_c('small',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat),expression:"schemabestaat"}]},[_vm._v("wijzigen")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.schemabestaat),expression:"!schemabestaat"}]},[_vm._v("creëren")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Afdeling: ")]),_c('td',[_vm._v(_vm._s(_vm.model.afdeling.naam))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewas: ")]),_c('td',[_vm._v(_vm._s(_vm.model.teelt.naam)+" - "+_vm._s(_vm.model.ras))]),_vm._v(" "),_c('th',[_vm._v("Aanplantdatum - einddatum: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.aanplantdatum))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatum)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewenste DLI: ")]),_c('td',[_vm._v(_vm._s(_vm.model.ingesteldeDli))]),_vm._v(" "),_c('th',[_vm._v("Belichtingsseizoen start - einde: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.startdatumBelichting))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatumBelichting)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Installatie (µmol/m"),_c('sup',[_vm._v("2")]),_vm._v("s)")]),_vm._v(" "),_c('th',[_vm._v("Efficiëntie (µmol/J)")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.afdeling.belichting_n),function(belichting,indexi,i){return [_vm._l((belichting.schakelniveau_n),function(schakelniveau,indexj,i){return [_c('tr',[_c('td',[_vm._v("Systeem "+_vm._s(schakelniveau.nummer + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.soortbelichting.naam)+" "+_vm._s(indexj + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma4(_vm.installatie[schakelniveau.nummer])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.efficientie))])])]})]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.schemabestaat),expression:"!schemabestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"red"},[_vm._v("Er bestaat nog geen klassiek belichtingsschema voor deze teelt.")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat),expression:"schemabestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('b-button-group',{attrs:{"id":"periode","name":"periode"}},[_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'data'},on:{"click":function($event){_vm.changeView('data')}}},[_vm._v("Data")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'grafiek'},on:{"click":function($event){_vm.changeView('grafiek')}}},[_vm._v("Grafiek")])],1)],1),_vm._v("\n                         "),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'data'),expression:"currentview == 'data'"}],staticClass:"col-sm-6",attrs:{"align":"right"}},[_c('b-button',{staticStyle:{"background-color":"#ffffff"},attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){_vm.openFormImport()}}},[_vm._v("Belichtingsschema importeren")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'grafiek'),expression:"currentview == 'grafiek'"}],staticClass:"col-sm-6"},[_c('b-input-group',[_c('b-input-group',{attrs:{"left":"Van"}},[_c('datepicker',{ref:"begindatum",staticStyle:{"background-color":"#ffffff"},attrs:{"language":_vm.nl,"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"monday-first":true,"name":"begindatum","id":"begindatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphData()}},model:{value:(_vm.begindatum),callback:function ($$v) {_vm.begindatum=$$v},expression:"begindatum"}})],1),_vm._v("\n                              \n                            "),_c('b-input-group',{attrs:{"left":"Tot"}},[_c('datepicker',{ref:"einddatum",staticStyle:{"background-color":"#ffffff"},attrs:{"language":_vm.nl,"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"monday-first":true,"name":"einddatum","id":"einddatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphData()}},model:{value:(_vm.einddatum),callback:function ($$v) {_vm.einddatum=$$v},expression:"einddatum"}})],1),_vm._v("\n                                  \n                        ")],1)],1)]),_vm._v(" "),(_vm.schemabestaat && _vm.currentview == 'data')?_c('div',{staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI zon (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI werkelijk"),_c('br'),_vm._v("ontvangen (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.komma1(_vm.model.cumulatief)))])],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',[_vm._v("29/02/2020")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-navicon"})])]),_vm._v(" "),_vm._l((_vm.model.klassiekebelichting_n[0].klassiekperdag_n),function(perdag){return [_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],staticClass:"form-control unstyleduur",attrs:{"type":"text"}})])])]}),_vm._v(" "),_vm._l((_vm.model.klassiekebelichting_n[0].klassiekperdag_n),function(perdag){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                                        0.22\n                                    ")])]}),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma1(_vm.dlicumulatief[_vm.model.klassiekebelichting_n.length - 1])))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI zon (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI werkelijk"),_c('br'),_vm._v("ontvangen (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.komma1(_vm.model.cumulatief)))])],2),_vm._v(" "),_vm._l((_vm.model.klassiekebelichting_n),function(klassiek,indexi){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(klassiek.datum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(klassiek.gewensteDli))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(klassiek.dliZon))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.klikt(indexi)}}},[_c('i',{class:_vm.selectValue(klassiek)})])]),_vm._v(" "),_vm._l((klassiek.klassiekperdag_n),function(perdag,indexj){return [_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(perdag.tijd),expression:"perdag.tijd"}],staticClass:"form-control unstyleduur",attrs:{"type":"text","required":"","id":'tijd' + ((indexi * 50) + indexj),"name":'tijd' + ((indexi * 50) + indexj)},domProps:{"value":(perdag.tijd)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.wis(perdag)},"input":function($event){if($event.target.composing){ return; }_vm.$set(perdag, "tijd", $event.target.value)}}})])])]}),_vm._v(" "),_vm._l((klassiek.klassiekperdag_n),function(perdag,indexj){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.dlibelichting[indexi].perdag[indexj].mol)))])]}),_vm._v(" "),_c('td',{class:_vm.genoegLicht(klassiek.gewensteDli, parseFloat(_vm.dlitotaal[indexi]))},[_vm._v(_vm._s(_vm.komma1(_vm.dlitotaal[indexi])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma1(_vm.dlicumulatief[indexi])))])],2)})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.currentview == 'grafiek'),expression:"schemabestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("Klassiek belichtingsschema")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("mol/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chart',{staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection,"height":"400","miny":_vm.miny,"maxy":_vm.maxy,"changeyaxis":_vm.changeyaxis}})],1)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat),expression:"schemabestaat"}],attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.schemabestaat),expression:"!schemabestaat"}],attrs:{"type":"button","variant":"primary"},on:{"click":_vm.createschema}},[_vm._v("Belichtingsschema creëren")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"isEditing":true},on:{"save-item":_vm.updateItem,"create-schema":_vm.createSchema,"open-form-import":_vm.openFormImport}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Klassiek belichtingsschema werd niet gewijzigd! "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Belichtingsschema creëren","size":"sm"},model:{value:(_vm.warningGeduld),callback:function ($$v) {_vm.warningGeduld=$$v},expression:"warningGeduld"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Klassiek belichtingsschema wordt gecreëerd. Deze bewerking kan even duren.")])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Belichtingsschema importeren","size":"lg","no-close-on-backdrop":true},model:{value:(_vm.vraagBestand),callback:function ($$v) {_vm.vraagBestand=$$v},expression:"vraagBestand"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.closeFormImport(_vm.model)}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.doImport(_vm.model)}}},[_vm._v("OK")])],1)]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Let op! Bestaande data in het belichtingsschema worden overschreven!")])]),_vm._v(" "),_c('p'),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"fileToUpload"}},[_vm._v("Csv-bestand")]),_vm._v(" "),_c('b-form-file',{ref:"file-input",attrs:{"accept":".csv","id":"fileToUpload","name":"fileToUpload","plain":true},model:{value:(_vm.model.fileToUpload),callback:function ($$v) {_vm.$set(_vm.model, "fileToUpload", $$v)},expression:"model.fileToUpload"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.foutbestand),expression:"foutbestand"}],staticClass:"small text-danger"},[_vm._v("Kies een csv-bestand")])],1),_vm._v(" "),_c('p')]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Belichtingsschema importeren","size":"sm"},model:{value:(_vm.warningGeduldImport),callback:function ($$v) {_vm.warningGeduldImport=$$v},expression:"warningGeduldImport"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Het belichtingsschema wordt geïmporteerd. Deze bewerking kan even duren.")])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Belichtingsschema importeren","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.errorImport),callback:function ($$v) {_vm.errorImport=$$v},expression:"errorImport"}},[_vm._v("\n        FOUT: Belichtingsschema werd niet geïmporteerd! Controleer de structuur van het csv-bestand. "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Belichtingsschema creëren","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningSchema),callback:function ($$v) {_vm.warningSchema=$$v},expression:"warningSchema"}},[_vm._v("\n        FOUT: Klassiek belichtingsschema werd niet gecreëerd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_c('div',{staticClass:"midden"},[_c('div',{staticStyle:{"color":"#20a8d8","font-size":"large"}},[_vm._v("Even geduld a.u.b.")]),_vm._v(" "),_c('fadeloader',{staticClass:"spinner2",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowIntegratie_vue__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba713da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowIntegratie_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowIntegratie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba713da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowIntegratie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormIntegratie__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_FadeLoader__ = __webpack_require__(22);






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            errormsg: '',
            model: {},
            invloedspercentages: {},

            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },
    created: function created() {
        this.getData(this.$route.params.id);
    },

    methods: {
        getData: function getData(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].getLichtintegratie(id).then(function (response) {
                _this.model = response.data.model;
                _this.invloedspercentages = response.data.invloedspercentages;
            });
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__FormIntegratie__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIntegratie_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03b12a98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIntegratie_vue__ = __webpack_require__(582);
function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIntegratie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03b12a98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIntegratie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChartMixedOneLabel__ = __webpack_require__(580);









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'invloedspercentages', 'isEditing'],
    data: function data() {
        return {
            nl: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__["a" /* nl */],
            firstrow: -1,
            currentview: 'data',
            datacollection: null,
            miny: 0,
            maxy: 25,
            changeyaxis: false,
            begindatum: '',
            einddatum: '',
            disabled: {
                to: new Date(),
                from: new Date()
            },
            bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)', 'rgba(255,221,50,1)'],
            fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)', 'rgba(255,221,50,0.2)']
        };
    },

    methods: {
        changeView: function changeView(view) {
            this.currentview = view;
            if (view === 'grafiek') {
                if (this.begindatum === '') {
                    this.begindatum = new Date(this.model.klassiekebelichting_n[0].datum);
                    this.einddatum = new Date(this.model.klassiekebelichting_n[this.model.klassiekebelichting_n.length - 1].datum);
                    this.disabled.to = this.begindatum;
                    this.disabled.from = this.einddatum;
                }
                this.fillGraphData();
            }
        },
        getMinValueDatasets: function getMinValueDatasets(datasets) {
            var somMinwaarden = [];
            datasets[0].data.forEach(function (waarde) {
                return somMinwaarden.push(0);
            });
            datasets.forEach(function (dataset) {
                for (var i = 0; i < dataset.data.length; i++) {
                    if (dataset.data[i] < 0) {
                        somMinwaarden[i] = somMinwaarden[i] + parseFloat(dataset.data[i]);
                    }
                }
            });

            var minwaarde = Math.min.apply(Math, somMinwaarden);
            return Math.floor((minwaarde + 0.00000001) / 5) * 5;
        },
        getMaxValueDatasets: function getMaxValueDatasets(datasets) {
            var maxwaarde = 0;
            datasets.forEach(function (dataset) {
                maxwaarde = Math.max(maxwaarde, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataset.data)));
            });
            return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
        },
        fillGraphData: function fillGraphData() {
            this.datacollection = {
                type: 'bar',
                labels: this.getGraphLabels(),
                datasets: this.getGraphBarsAndLines()
            };
            this.miny = this.getMinValueDatasets(this.datacollection.datasets);
            this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
            this.changeyaxis = !this.changeyaxis;
        },
        getGraphLabels: function getGraphLabels() {
            var _this = this;

            var labels = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.einddatum)) {
                    labels.push(_this.datumDDMMYYYY(klassiek.datum));
                }
            });
            return labels;
        },
        getGraphBarsAndLines: function getGraphBarsAndLines() {
            var datasets = [];
            this.getGraphVerleden(datasets);
            this.getGraphToekomst(datasets);
            this.getGraphBelichting(datasets);
            this.getGraphDliZon(datasets);
            this.getGraphDliGewenst(datasets);
            this.getGraphDliLichtintegratie(datasets);
            this.getGraphDliWerkelijk(datasets);
            return datasets;
        },
        getGraphVerleden: function getGraphVerleden(datasets) {
            for (var i = 0; i < this.aantalverleden; i += 1) {
                var dataset = {
                    backgroundColor: this.fillcolors[i % 10],
                    borderColor: this.bordercolors[i % 10],
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 1,
                    label: this.getNaamVerleden(i),
                    data: this.getDataVerleden(i),
                    yAxisID: 'bar'
                };
                datasets.push(dataset);
            }
        },
        getGraphToekomst: function getGraphToekomst(datasets) {
            for (var i = 0; i < this.aantaltoekomst; i += 1) {
                var dataset = {
                    backgroundColor: this.fillcolors[(this.aantalverleden + i) % 10],
                    borderColor: this.bordercolors[(this.aantalverleden + i) % 10],
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 1,
                    label: this.getNaamToekomst(i),
                    data: this.getDataToekomst(i),
                    yAxisID: 'bar'
                };
                datasets.push(dataset);
            }
        },
        getGraphBelichting: function getGraphBelichting(datasets) {
            var dataset = {
                backgroundColor: this.fillcolors[9],
                borderColor: this.bordercolors[9],
                pointHoverBackgroundColor: '#fff',
                borderWidth: 1,
                label: 'DLI Belichting',
                data: this.getDataBelichting(),
                yAxisID: 'bar'
            };
            datasets.push(dataset);
        },
        getNaamVerleden: function getNaamVerleden(index) {
            return this.invloedspercentages.verleden.percentages[index].d;
        },
        getDataVerleden: function getDataVerleden(i) {
            var data = [];
            for (var j = 0; j < this.model.klassiekebelichting_n.length; j += 1) {
                if (this.model.klassiekebelichting_n[j].datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.begindatum) && this.model.klassiekebelichting_n[j].datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.einddatum)) {
                    data.push(this.komma2(this.model.klassiekebelichting_n[j][this.invloedspercentages.verleden.percentages[i].d]));
                }
            }
            return data;
        },
        getNaamToekomst: function getNaamToekomst(i) {
            return this.invloedspercentages.toekomst.percentages[i].d;
        },
        getDataToekomst: function getDataToekomst(i) {
            var data = [];
            for (var j = 0; j < this.model.klassiekebelichting_n.length; j += 1) {
                if (this.model.klassiekebelichting_n[j].datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.begindatum) && this.model.klassiekebelichting_n[j].datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(this.einddatum)) {
                    data.push(this.komma2(this.model.klassiekebelichting_n[j][this.invloedspercentages.toekomst.percentages[i].d]));
                }
            }
            return data;
        },
        getDataBelichting: function getDataBelichting() {
            var _this2 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.einddatum)) {
                    data.push(_this2.komma2(klassiek.dliBelichting));
                }
            });
            return data;
        },
        getGraphDliZon: function getGraphDliZon(datasets) {
            var _this3 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.einddatum)) {
                    data.push(klassiek.dliZon);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(0,153,153, 0)',
                borderColor: 'rgba(0,153,153, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI zon',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliGewenst: function getGraphDliGewenst(datasets) {
            var _this4 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this4.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this4.einddatum)) {
                    data.push(klassiek.gewensteDli);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(23,23,23, 0)',
                borderColor: 'rgba(23,23,23, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI gewenst',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliLichtintegratie: function getGraphDliLichtintegratie(datasets) {
            var _this5 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this5.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this5.einddatum)) {
                    data.push(_this5.komma2(klassiek.totDlimetD));
                }
            });
            var dataset = {
                backgroundColor: 'rgba(0,204,0, 0)',
                borderColor: 'rgba(0,204,0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI lichtintegratie',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliWerkelijk: function getGraphDliWerkelijk(datasets) {
            var _this6 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this6.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this6.einddatum)) {
                    data.push(_this6.komma2(klassiek.totDli));
                }
            });
            var dataset = {
                backgroundColor: 'rgba(204,0,0, 0)',
                borderColor: 'rgba(204,0,0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI werkelijk ontvangen',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        wis: function wis(perdag) {
            perdag.tijd = '00:00';
        },
        klikt: function klikt(index) {
            if (this.model.klassiekebelichting_n[index].selected === 0) {
                if (this.firstrow === -1) {
                    this.model.klassiekebelichting_n[index].selected = 1;
                    this.firstrow = index;
                } else if (this.firstrow < index) {
                    for (var i = this.firstrow + 1; i <= index; i += 1) {
                        for (var j = 0; j < this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n.length; j += 1) {
                            this.model.klassiekebelichting_n[i].klassiekperdag_n[j].tijd = this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n[j].tijd;
                        }
                    }
                    this.model.klassiekebelichting_n[this.firstrow].selected = 0;
                    this.firstrow = -1;
                }
            } else {
                this.model.klassiekebelichting_n[index].selected = 0;
                this.firstrow = -1;
            }
        },
        selectValue: function selectValue(klassiek) {
            if (klassiek.selected === 0) {
                return 'fa fa-navicon';
            }
            if (klassiek.selected === 1) {
                return 'fa fa-sort-amount-asc';
            }
            return '';
        },
        genoegLicht: function genoegLicht(nodig, hebje) {
            if (hebje >= nodig) {
                return 'green';
            }
            if (hebje >= nodig * 0.75) {
                return 'orange';
            }
            return 'red';
        },
        createschema: function createschema() {
            this.$emit('create-schema', this.model);
        },
        saveItem: function saveItem() {
            var _this7 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this7.isError) {
                        _this7.$emit('save-item', _this7.model);
                    }
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        },
        timeHHMM: function timeHHMM(time) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].timetoHHMM(time);
        },
        berekenVermogen: function berekenVermogen(schakelniveau, belichting) {
            return belichting.fotonflux * schakelniveau.percentage / 100;
        },
        komma4: function komma4(waarde) {
            if (isNaN(waarde)) {
                return '#.####';
            }
            return waarde.toFixed(4);
        },
        komma2: function komma2(waarde) {
            if (isNaN(waarde)) {
                return '#.##';
            }
            return waarde.toFixed(2);
        },
        komma1: function komma1(waarde) {
            if (isNaN(waarde)) {
                return '#.#';
            }
            return waarde.toFixed(1);
        },
        komma0: function komma0(waarde) {
            if (isNaN(waarde)) {
                return '#';
            }
            return waarde.toFixed(0);
        }
    },
    computed: {
        schemabestaat: function schemabestaat() {
            return this.model.klassiekebelichting_n.length !== 0;
        },
        aantalverleden: function aantalverleden() {
            return this.invloedspercentages.verleden.aantaldagen;
        },
        aantaltoekomst: function aantaltoekomst() {
            return this.invloedspercentages.toekomst.aantaldagen;
        },
        dlicumulatief: function dlicumulatief() {
            var resultaat = [];
            var vorigtotaal = this.model.cumulatief;
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                resultaat.push(vorigtotaal + klassiek.totDli);
                vorigtotaal += klassiek.totDli;
            });
            return resultaat;
        },
        installatie: function installatie() {
            var _this8 = this;

            var resultaat = [];
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                belichting.schakelniveau_n.forEach(function (schakelniveau) {
                    resultaat.push(_this8.berekenVermogen(schakelniveau, belichting));
                });
            });
            return resultaat;
        }
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
        chart: __WEBPACK_IMPORTED_MODULE_4__ChartMixedOneLabel__["a" /* default */]
    }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartMixedOneLabel_vue__ = __webpack_require__(581);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartMixedOneLabel_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    mixins: [reactiveProp],
    props: ['height', 'miny', 'maxy', 'changeyaxis'],
    data: function data() {
        return {
            options: {
                tooltips: {
                    mode: 'index'
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        categorySpacing: 0,
                        categoryPercentage: 0.8,
                        barPercentage: 0.8,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        id: 'bar',
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }, {
                        id: 'line',
                        stacked: false,
                        display: false,
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    },

    watch: {
        changeyaxis: function changeyaxis() {
            this.$data._chart.destroy();
            this.options.scales.yAxes[0].ticks.min = this.miny;
            this.options.scales.yAxes[1].ticks.min = this.miny;
            this.options.scales.yAxes[0].ticks.max = this.maxy;
            this.options.scales.yAxes[1].ticks.max = this.maxy;
            this.renderChart(this.chartData, this.options);
        }
    }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Lichtintegratie")]),_vm._v(" "),_c('small',[_vm._v("\n                        bekijken\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Afdeling: ")]),_c('td',[_vm._v(_vm._s(_vm.model.afdeling.naam))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewas: ")]),_c('td',[_vm._v(_vm._s(_vm.model.teelt.naam)+" - "+_vm._s(_vm.model.ras))]),_vm._v(" "),_c('th',[_vm._v("Aanplantdatum - einddatum: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.aanplantdatum))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatum)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewenste DLI: ")]),_c('td',[_vm._v(_vm._s(_vm.model.ingesteldeDli))]),_vm._v(" "),_c('th',[_vm._v("Belichtingsseizoen start - einde: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.startdatumBelichting))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatumBelichting)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Installatie (µmol/m"),_c('sup',[_vm._v("2")]),_vm._v("s)")]),_vm._v(" "),_c('th',[_vm._v("Efficiëntie (µmol/J)")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.afdeling.belichting_n),function(belichting,indexi,i){return [_vm._l((belichting.schakelniveau_n),function(schakelniveau,indexj,i){return [_c('tr',[_c('td',[_vm._v("Systeem "+_vm._s(schakelniveau.nummer + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.soortbelichting.naam)+" "+_vm._s(indexj + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma4(_vm.installatie[schakelniveau.nummer])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.efficientie))])])]})]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.schemabestaat),expression:"!schemabestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"red"},[_vm._v("Er bestaat nog geen klassiek belichtingsschema voor deze teelt. Gelieve dit eerst te creëren.")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat),expression:"schemabestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('b-button-group',{attrs:{"id":"periode","name":"periode"}},[_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'data'},on:{"click":function($event){_vm.changeView('data')}}},[_vm._v("Data")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'grafiek'},on:{"click":function($event){_vm.changeView('grafiek')}}},[_vm._v("Grafiek")])],1)],1),_vm._v("\n                         "),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'grafiek'),expression:"currentview == 'grafiek'"}],staticClass:"col-sm-6"},[_c('b-input-group',[_c('b-input-group',{attrs:{"left":"Van"}},[_c('datepicker',{ref:"begindatum",staticStyle:{"background-color":"#ffffff"},attrs:{"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"begindatum","id":"begindatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphData()}},model:{value:(_vm.begindatum),callback:function ($$v) {_vm.begindatum=$$v},expression:"begindatum"}})],1),_vm._v("\n                              \n                            "),_c('b-input-group',{attrs:{"left":"Tot"}},[_c('datepicker',{ref:"einddatum",staticStyle:{"background-color":"#ffffff"},attrs:{"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"einddatum","id":"einddatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphData()}},model:{value:(_vm.einddatum),callback:function ($$v) {_vm.einddatum=$$v},expression:"einddatum"}})],1),_vm._v("\n                                  \n                        ")],1)],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.currentview == 'data'),expression:"schemabestaat && currentview == 'data'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI zon (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalverleden}},[_vm._v("Verleden ("+_vm._s(_vm.invloedspercentages.verleden.percentage)+"%)")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantaltoekomst}},[_vm._v("Toekomst ("+_vm._s(_vm.invloedspercentages.toekomst.percentage)+"%)")]),_vm._v(" "),_c('th',[_vm._v("DLI lichtintegratie (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_vm._l((_vm.invloedspercentages.verleden.percentages),function(percentage){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(percentage.d)+" ("+_vm._s(percentage.waarde)+"%)")])]}),_vm._v(" "),(_vm.aantalverleden == 0)?[_c('th')]:_vm._e(),_vm._v(" "),_vm._l((_vm.invloedspercentages.toekomst.percentages),function(percentage){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(percentage.d)+" ("+_vm._s(percentage.waarde)+"%)")])]}),_vm._v(" "),(_vm.aantaltoekomst == 0)?[_c('th')]:_vm._e(),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.komma1(_vm.model.cumulatief)))])],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',[_vm._v("29/02/2020")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.00")]),_vm._v(" "),_vm._l((_vm.invloedspercentages.verleden.percentages),function(percentage){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                                        0.22\n                                    ")])]}),_vm._v(" "),_vm._l((_vm.invloedspercentages.toekomst.percentages),function(percentage){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                                        0.22\n                                    ")])]}),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma1(_vm.dlicumulatief[_vm.model.klassiekebelichting_n.length - 1])))])],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI zon (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalverleden}},[_vm._v("Verleden ("+_vm._s(_vm.invloedspercentages.verleden.percentage)+"%)")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantaltoekomst}},[_vm._v("Toekomst ("+_vm._s(_vm.invloedspercentages.toekomst.percentage)+"%)")]),_vm._v(" "),_c('th',[_vm._v("DLI lichtintegratie (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_vm._l((_vm.invloedspercentages.verleden.percentages),function(percentage){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(percentage.d)+" ("+_vm._s(percentage.waarde)+"%)")])]}),_vm._v(" "),(_vm.aantalverleden == 0)?[_c('th')]:_vm._e(),_vm._v(" "),_vm._l((_vm.invloedspercentages.toekomst.percentages),function(percentage){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(percentage.d)+" ("+_vm._s(percentage.waarde)+"%)")])]}),_vm._v(" "),(_vm.aantaltoekomst == 0)?[_c('th')]:_vm._e(),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.komma1(_vm.model.cumulatief)))])],2),_vm._v(" "),_vm._l((_vm.model.klassiekebelichting_n),function(klassiek,indexi){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(klassiek.datum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(klassiek.gewensteDli))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(klassiek.dliZon))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(klassiek.dliBelichting)))]),_vm._v(" "),_vm._l((_vm.invloedspercentages.verleden.percentages),function(percentage){return [_c('td',[_vm._v(_vm._s(_vm.komma2(klassiek[percentage.d])))])]}),_vm._v(" "),(_vm.aantalverleden == 0)?[_c('td',[_vm._v("0.00")])]:_vm._e(),_vm._v(" "),_vm._l((_vm.invloedspercentages.toekomst.percentages),function(percentage){return [_c('td',[_vm._v(_vm._s(_vm.komma2(klassiek[percentage.d])))])]}),_vm._v(" "),(_vm.aantaltoekomst == 0)?[_c('td',[_vm._v("0.00")])]:_vm._e(),_vm._v(" "),_c('td',{class:_vm.genoegLicht(klassiek.gewensteDli, klassiek.totDlimetD)},[_vm._v(_vm._s(_vm.komma1(klassiek.totDlimetD)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma1(_vm.dlicumulatief[indexi])))])],2)})],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.currentview == 'grafiek'),expression:"schemabestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("Lichtintegratie")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("mol/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chart',{ref:"grafiek",staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection,"height":"400","miny":_vm.miny,"maxy":_vm.maxy,"changeyaxis":_vm.changeyaxis}})],1)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Terug")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"invloedspercentages":_vm.invloedspercentages,"isEditing":true}})],1):_c('div',{staticClass:"midden"},[_c('div',{staticStyle:{"color":"#20a8d8","font-size":"large"}},[_vm._v("Even geduld a.u.b.")]),_vm._v(" "),_c('fadeloader',{staticClass:"spinner2",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowSamenvatting_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e8866c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowSamenvatting_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowSamenvatting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e8866c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowSamenvatting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormSamenvatting__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_FadeLoader__ = __webpack_require__(22);






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            errormsg: '',
            model: {},
            klassiekmodel: {},
            invloedspercentages: {},

            modellichtintegratie: {},
            modelklassiekeuren: {},

            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },
    created: function created() {
        this.getData(this.$route.params.id);
    },

    methods: {
        getData: function getData(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].getSamenvatting(id).then(function (response) {
                _this.model = response.data.lichtintegratie.model;
                _this.klassiekmodel = response.data.klassiek.model;
                _this.invloedspercentages = response.data.lichtintegratie.invloedspercentages;
            });
            __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].getKlassiekebelichting(id).then(function (response) {
                _this.modelklassiekeuren = response.data.model;
            });
            __WEBPACK_IMPORTED_MODULE_0__api_afdelingteelt__["a" /* default */].getWerkelijkebelichting(id).then(function (response) {
                _this.modellichtintegratie = response.data.lichtintegratie.model;
            });
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_1__FormSamenvatting__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSamenvatting_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646c4a33_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSamenvatting_vue__ = __webpack_require__(592);
function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSamenvatting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646c4a33_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSamenvatting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChartNotStacked__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChartMixed__ = __webpack_require__(60);











/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'klassiekmodel', 'modellichtintegratie', 'invloedspercentages', 'modelklassiekeuren', 'isEditing'],
    data: function data() {
        return {
            nl: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["a" /* nl */],
            firstrow: -1,
            currentview: 'data',
            datacollection: null,
            datacollection2: null,
            datacollection3: null,
            miny: 0,
            maxy: 25,
            changeyaxis: false,
            miny2: 0,
            maxy2: 25,
            changeyaxis2: false,
            miny3: 0,
            maxy3: 25,
            changeyaxis3: false,
            begindatum: '',
            einddatum: '',
            disabled: {
                to: new Date(),
                from: new Date()
            },
            bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)', 'rgba(255,221,50,1)'],
            fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)', 'rgba(255,221,50,0.2)']
        };
    },

    methods: {
        changeView: function changeView(view) {
            this.currentview = view;
            if (view === 'grafiek') {
                if (this.begindatum === '') {
                    this.begindatum = new Date(this.model.klassiekebelichting_n[0].datum);
                    this.einddatum = new Date(this.model.klassiekebelichting_n[this.model.klassiekebelichting_n.length - 1].datum);
                    this.disabled.to = this.begindatum;
                    this.disabled.from = this.einddatum;
                }
                this.fillGraphData();
                this.fillGraph2Data();
                this.fillGraph3Data();
            }
        },
        getMinValueDatasets: function getMinValueDatasets(datasets) {
            var somMinwaarden = [];
            datasets[0].data.forEach(function (waarde) {
                return somMinwaarden.push(0);
            });
            datasets.forEach(function (dataset) {
                for (var i = 0; i < dataset.data.length; i++) {
                    if (dataset.data[i] < 0) {
                        somMinwaarden[i] = somMinwaarden[i] + parseFloat(dataset.data[i]);
                    }
                }
            });

            var minwaarde = Math.min.apply(Math, somMinwaarden);
            return Math.floor((minwaarde + 0.00000001) / 5) * 5;
        },
        getMaxValueDatasets: function getMaxValueDatasets(datasets) {
            var maxwaarde = 0;
            datasets.forEach(function (dataset) {
                maxwaarde = Math.max(maxwaarde, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(dataset.data)));
            });
            return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
        },
        fillGraphs: function fillGraphs() {
            this.fillGraphData();
            this.fillGraph2Data();
            this.fillGraph3Data();
        },
        fillGraphData: function fillGraphData() {
            this.datacollection = {
                type: 'bar',
                labels: this.getGraphLabels(),
                datasets: this.getGraphBarsAndLines()
            };
            this.miny = this.getMinValueDatasets(this.datacollection.datasets);
            this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
            this.changeyaxis = !this.changeyaxis;
        },
        fillGraph2Data: function fillGraph2Data() {
            this.datacollection2 = {
                type: 'bar',
                labels: this.getGraphLabels(),
                datasets: this.getGraphLines()
            };
            this.miny2 = 0;
            this.maxy2 = this.getMaxValueDatasets(this.datacollection2.datasets);
            this.changeyaxis2 = !this.changeyaxis2;
        },
        fillGraph3Data: function fillGraph3Data() {
            this.datacollection3 = {
                type: 'bar',
                labels: this.getGraphLabels(),
                datasets: this.getGraphBarsAndLinesEnergie()
            };
            this.miny3 = 0;
            this.maxy3 = this.getMaxValueDatasets(this.datacollection3.datasets);
            this.changeyaxis3 = !this.changeyaxis3;
        },
        getGraphLabels: function getGraphLabels() {
            var _this = this;

            var labels = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.einddatum)) {
                    labels.push(_this.datumDDMMYYYY(klassiek.datum));
                }
            });
            return labels;
        },
        getGraphBarsAndLinesEnergie: function getGraphBarsAndLinesEnergie() {
            var datasets = [];
            this.getGraphEnergieKlassiek(datasets);
            this.getGraphEnergieIdeaal(datasets);
            return datasets;
        },
        getGraphEnergieIdeaal: function getGraphEnergieIdeaal(datasets) {
            var _this2 = this;

            var data = [];
            var indexi = 0;
            this.modellichtintegratie.klassiekebelichting_n.forEach(function (werkelijk) {
                if (werkelijk.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.begindatum) && werkelijk.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.einddatum)) {
                    data.push(_this2.komma2(_this2.energieideaalcumulatief[indexi]));
                }
                indexi++;
            });
            var dataset = {
                backgroundColor: 'rgba(204,0,0, 0)',
                borderColor: 'rgba(204,0,0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' Lichtintegratie',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphEnergieKlassiek: function getGraphEnergieKlassiek(datasets) {
            var _this3 = this;

            var data = [];
            var indexi = 0;
            this.modelklassiekeuren.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.einddatum)) {
                    data.push(_this3.komma2(_this3.energieklassiekcumulatief[indexi]));
                }
                indexi++;
            });
            var dataset = {
                backgroundColor: 'rgba(0, 204, 0, 0)',
                borderColor: 'rgba(0, 204, 0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' Klassiek belichting',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphBarsAndLines: function getGraphBarsAndLines() {
            var datasets = [];
            this.getGraphDLIKlassiekeBelichting(datasets);
            this.getGraphDLILichtintegratie(datasets);

            this.getGraphDliZon(datasets);
            this.getGraphDliGewenst(datasets);
            this.getGraphDliWerkelijkKlassiekeBelichting(datasets);
            this.getGraphDliWerkelijkLichtintegratie(datasets);
            return datasets;
        },
        getGraphLines: function getGraphLines() {
            var datasets = [];
            this.getGraphDliCumulatiefKlassiekeBelichting(datasets);
            this.getGraphDliCumulatiefLichtintegratie(datasets);
            return datasets;
        },
        getGraphDLIKlassiekeBelichting: function getGraphDLIKlassiekeBelichting(datasets) {
            var dataset = {
                backgroundColor: this.fillcolors[1],
                borderColor: this.bordercolors[1],
                pointHoverBackgroundColor: '#fff',
                borderWidth: 1,
                label: 'DLI Belichting (Klassieke belichting)',
                data: this.getDataKlassiekeBelichting(),
                yAxisID: 'bar'
            };
            datasets.push(dataset);
        },
        getGraphDLILichtintegratie: function getGraphDLILichtintegratie(datasets) {
            var dataset = {
                backgroundColor: this.fillcolors[2],
                borderColor: this.bordercolors[2],
                pointHoverBackgroundColor: '#fff',
                borderWidth: 1,
                label: 'DLI Belichting (Lichtintegratie)',
                data: this.getDataLichtintegratie(),
                yAxisID: 'bar'
            };
            datasets.push(dataset);
        },
        getDataKlassiekeBelichting: function getDataKlassiekeBelichting() {
            var _this4 = this;

            var data = [];
            this.klassiekmodel.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this4.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this4.einddatum)) {
                    data.push(_this4.komma2(klassiek.dliBelichting));
                }
            });
            return data;
        },
        getDataLichtintegratie: function getDataLichtintegratie() {
            var _this5 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this5.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this5.einddatum)) {
                    data.push(_this5.komma2(klassiek.dliBelichting));
                }
            });
            return data;
        },
        getGraphDliZon: function getGraphDliZon(datasets) {
            var _this6 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this6.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this6.einddatum)) {
                    data.push(klassiek.dliZon);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(0,153,153, 0)',
                borderColor: 'rgba(0,153,153, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI zon',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliGewenst: function getGraphDliGewenst(datasets) {
            var _this7 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this7.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this7.einddatum)) {
                    data.push(klassiek.gewensteDli);
                }
            });
            var dataset = {
                backgroundColor: 'rgba(23,23,23, 0)',
                borderColor: 'rgba(23,23,23, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' DLI gewenst',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliWerkelijkKlassiekeBelichting: function getGraphDliWerkelijkKlassiekeBelichting(datasets) {
            var _this8 = this;

            var data = [];
            this.klassiekmodel.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this8.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this8.einddatum)) {
                    data.push(_this8.komma2(klassiek.dliTot));
                }
            });
            var dataset = {
                backgroundColor: 'rgba(0, 204, 0, 0)',
                borderColor: 'rgba(0, 204, 0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: 'DLI Werkelijk ontvangen (Klassieke belichting)',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliWerkelijkLichtintegratie: function getGraphDliWerkelijkLichtintegratie(datasets) {
            var _this9 = this;

            var data = [];
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this9.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this9.einddatum)) {
                    data.push(_this9.komma2(klassiek.totDli));
                }
            });
            var dataset = {
                backgroundColor: 'rgba(204,0,0, 0)',
                borderColor: 'rgba(204,0,0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: 'DLI Werkelijk ontvangen (Lichtintegratie)',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliCumulatiefKlassiekeBelichting: function getGraphDliCumulatiefKlassiekeBelichting(datasets) {
            var _this10 = this;

            var data = [];
            this.klassiekmodel.klassiekebelichting_n.forEach(function (klassiek, index) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this10.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this10.einddatum)) {
                    data.push(_this10.komma2(_this10.dliklassiekcumulatief[index]));
                }
            });
            var dataset = {
                backgroundColor: 'rgba(0, 204, 0, 0)',
                borderColor: 'rgba(0, 204, 0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: 'DLI Cumulatief (Klassieke belichting)',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphDliCumulatiefLichtintegratie: function getGraphDliCumulatiefLichtintegratie(datasets) {
            var _this11 = this;

            var data = [];
            this.klassiekmodel.klassiekebelichting_n.forEach(function (klassiek, index) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this11.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this11.einddatum)) {
                    data.push(_this11.komma2(_this11.dlicumulatief[index]));
                }
            });
            var dataset = {
                backgroundColor: 'rgba(204,0,0, 0)',
                borderColor: 'rgba(204,0,0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: 'DLI Cumulatief (Lichtintegratie)',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        wis: function wis(perdag) {
            perdag.tijd = '00:00';
        },
        klikt: function klikt(index) {
            if (this.model.klassiekebelichting_n[index].selected === 0) {
                if (this.firstrow === -1) {
                    this.model.klassiekebelichting_n[index].selected = 1;
                    this.firstrow = index;
                } else if (this.firstrow < index) {
                    for (var i = this.firstrow + 1; i <= index; i += 1) {
                        for (var j = 0; j < this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n.length; j += 1) {
                            this.model.klassiekebelichting_n[i].klassiekperdag_n[j].tijd = this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n[j].tijd;
                        }
                    }
                    this.model.klassiekebelichting_n[this.firstrow].selected = 0;
                    this.firstrow = -1;
                }
            } else {
                this.model.klassiekebelichting_n[index].selected = 0;
                this.firstrow = -1;
            }
        },
        selectValue: function selectValue(klassiek) {
            if (klassiek.selected === 0) {
                return 'fa fa-navicon';
            }
            if (klassiek.selected === 1) {
                return 'fa fa-sort-amount-asc';
            }
            return '';
        },
        genoegLicht: function genoegLicht(nodig, hebje) {
            if (hebje >= nodig) {
                return 'green';
            }
            if (hebje >= nodig * 0.75) {
                return 'orange';
            }
            return 'red';
        },
        createschema: function createschema() {
            this.$emit('create-schema', this.model);
        },
        saveItem: function saveItem() {
            var _this12 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this12.isError) {
                        _this12.$emit('save-item', _this12.model);
                    }
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        },
        timeHHMM: function timeHHMM(time) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].timetoHHMM(time);
        },
        berekenVermogen: function berekenVermogen(schakelniveau, belichting) {
            return belichting.fotonflux * schakelniveau.percentage / 100;
        },
        komma4: function komma4(waarde) {
            if (isNaN(waarde)) {
                return '#.####';
            }
            return waarde.toFixed(4);
        },
        komma2: function komma2(waarde) {
            if (isNaN(waarde)) {
                return '#.##';
            }
            return waarde.toFixed(2);
        },
        komma1: function komma1(waarde) {
            if (isNaN(waarde)) {
                return '#.#';
            }
            return waarde.toFixed(1);
        },
        komma0: function komma0(waarde) {
            if (isNaN(waarde)) {
                return '#';
            }
            return waarde.toFixed(0);
        }
    },
    computed: {
        aantalsystemen: function aantalsystemen() {
            var aantal = 0;
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                aantal += belichting.schakelniveau_n.length;
            });
            return aantal;
        },
        klassiekeurenbestaat: function klassiekeurenbestaat() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modelklassiekeuren).length !== 0 && this.modelklassiekeuren.klassiekebelichting_n.length !== 0;
        },
        lichtintegratiebestaat: function lichtintegratiebestaat() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modellichtintegratie).length !== 0 && this.modellichtintegratie.klassiekebelichting_n.length !== 0;
        },
        schemabestaat: function schemabestaat() {
            return this.model.klassiekebelichting_n.length !== 0;
        },
        aantalverleden: function aantalverleden() {
            return this.invloedspercentages.verleden.aantaldagen;
        },
        aantaltoekomst: function aantaltoekomst() {
            return this.invloedspercentages.toekomst.aantaldagen;
        },
        dlicumulatief: function dlicumulatief() {
            var resultaat = [];
            var vorigtotaal = this.model.cumulatief;
            this.model.klassiekebelichting_n.forEach(function (klassiek) {
                resultaat.push(vorigtotaal + klassiek.totDli);
                vorigtotaal += klassiek.totDli;
            });
            return resultaat;
        },
        dliklassiekcumulatief: function dliklassiekcumulatief() {
            var resultaat = [];
            var vorigtotaal = this.model.cumulatief;
            this.klassiekmodel.klassiekebelichting_n.forEach(function (klassiek) {
                resultaat.push(vorigtotaal + klassiek.dliTot);
                vorigtotaal += klassiek.dliTot;
            });
            return resultaat;
        },
        installatie: function installatie() {
            var _this13 = this;

            var resultaat = [];
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                belichting.schakelniveau_n.forEach(function (schakelniveau) {
                    resultaat.push(_this13.berekenVermogen(schakelniveau, belichting));
                });
            });
            return resultaat;
        },
        efficientie: function efficientie() {
            var resultaat = [];
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                belichting.schakelniveau_n.forEach(function (schakelniveau) {
                    resultaat.push(belichting.efficientie);
                });
            });
            return resultaat;
        },
        energieideaal: function energieideaal() {
            var _this14 = this;

            var resultaat = [];
            this.modellichtintegratie.klassiekebelichting_n.forEach(function (klassiekebelichting) {
                var systeemarray = [];
                klassiekebelichting.systemen.forEach(function (systeem, i) {
                    systeemarray.push({ kwh: __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].getSeconden(systeem.belichtingsuren) * _this14.installatie[i] / systeem.efficientie / 3600000 });
                });
                resultaat.push({ datum: klassiekebelichting.datum, systeem: systeemarray });
            });
            return resultaat;
        },
        energieideaaltotaal: function energieideaaltotaal() {
            var resultaat = [];
            var i = 0;
            this.energieideaal.forEach(function (energieideaal) {
                var totaal = 0;
                energieideaal.systeem.forEach(function (systeem) {
                    if (!isNaN(systeem.kwh)) {
                        totaal += systeem.kwh;
                    }
                });
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        energieideaalcumulatief: function energieideaalcumulatief() {
            var resultaat = [];
            var vorigtotaal = 0;
            this.energieideaaltotaal.forEach(function (energieideaaltotaal) {
                resultaat.push(vorigtotaal + energieideaaltotaal);
                vorigtotaal += energieideaaltotaal;
            });
            return resultaat;
        },
        energieklassiek: function energieklassiek() {
            var _this15 = this;

            var resultaat = [];
            this.modelklassiekeuren.klassiekebelichting_n.forEach(function (klassiekebelichting) {
                var klassiekperdagarray = [];
                klassiekebelichting.klassiekperdag_n.forEach(function (klassiekperdag, i) {
                    klassiekperdagarray.push({ kwh: __WEBPACK_IMPORTED_MODULE_4__helpers_datefunctions__["a" /* default */].getSeconden(klassiekperdag.tijd) * _this15.installatie[i] / _this15.efficientie[i] / 3600000 });
                });
                resultaat.push({ datum: klassiekebelichting.datum, klassiekperdag: klassiekperdagarray });
            });
            return resultaat;
        },
        energieklassiektotaal: function energieklassiektotaal() {
            var resultaat = [];
            var i = 0;
            this.energieklassiek.forEach(function (energieklassiek) {
                var totaal = 0;
                energieklassiek.klassiekperdag.forEach(function (klassiekperdag) {
                    if (!isNaN(klassiekperdag.kwh)) {
                        totaal += klassiekperdag.kwh;
                    }
                });
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        energieklassiekcumulatief: function energieklassiekcumulatief() {
            var resultaat = [];
            var vorigtotaal = 0;
            this.energieklassiektotaal.forEach(function (energieklassiektotaal) {
                resultaat.push(vorigtotaal + energieklassiektotaal);
                vorigtotaal += energieklassiektotaal;
            });
            return resultaat;
        }
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */],
        chart: __WEBPACK_IMPORTED_MODULE_5__ChartNotStacked__["a" /* default */],
        chartm: __WEBPACK_IMPORTED_MODULE_6__ChartMixed__["a" /* default */]
    }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartNotStacked_vue__ = __webpack_require__(591);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartNotStacked_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    mixins: [reactiveProp],
    props: ['height', 'miny', 'maxy', 'changeyaxis'],
    data: function data() {
        return {
            options: {
                tooltips: {
                    mode: 'index'
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: false,
                        categorySpacing: 0,
                        categoryPercentage: 0.8,
                        barPercentage: 0.8,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        id: 'bar',
                        stacked: false,
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }, {
                        id: 'line',
                        stacked: false,
                        display: false,
                        ticks: {
                            beginAtZero: true,
                            min: this.miny,
                            max: this.maxy,
                            maxTicksLimit: 5
                        },
                        gridLines: {
                            display: true
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    },

    watch: {
        changeyaxis: function changeyaxis() {
            this.$data._chart.destroy();
            this.options.scales.yAxes[0].ticks.min = this.miny;
            this.options.scales.yAxes[1].ticks.min = this.miny;
            this.options.scales.yAxes[0].ticks.max = this.maxy;
            this.options.scales.yAxes[1].ticks.max = this.maxy;
            this.renderChart(this.chartData, this.options);
        }
    }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Lichtintegratie vs. klassiek belichtingsschema")]),_vm._v(" "),_c('small',[_vm._v("\n                        samenvatting\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Afdeling: ")]),_c('td',[_vm._v(_vm._s(_vm.model.afdeling.naam))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewas: ")]),_c('td',[_vm._v(_vm._s(_vm.model.teelt.naam)+" - "+_vm._s(_vm.model.ras))]),_vm._v(" "),_c('th',[_vm._v("Aanplantdatum - einddatum: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.aanplantdatum))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatum)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewenste DLI: ")]),_c('td',[_vm._v(_vm._s(_vm.model.ingesteldeDli))]),_vm._v(" "),_c('th',[_vm._v("Belichtingsseizoen start - einde: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.startdatumBelichting))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatumBelichting)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Installatie (µmol/m"),_c('sup',[_vm._v("2")]),_vm._v("s)")]),_vm._v(" "),_c('th',[_vm._v("Efficiëntie (µmol/J)")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.afdeling.belichting_n),function(belichting,indexi,i){return [_vm._l((belichting.schakelniveau_n),function(schakelniveau,indexj,i){return [_c('tr',[_c('td',[_vm._v("Systeem "+_vm._s(schakelniveau.nummer + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.soortbelichting.naam)+" "+_vm._s(indexj + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma4(_vm.installatie[schakelniveau.nummer])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.efficientie))])])]})]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.schemabestaat),expression:"!schemabestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"red"},[_vm._v("Er bestaat nog geen klassiek belichtingsschema voor deze teelt. Gelieve dit eerst te creëren.")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat),expression:"schemabestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('b-button-group',{attrs:{"id":"periode","name":"periode"}},[_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'data'},on:{"click":function($event){_vm.changeView('data')}}},[_vm._v("Data")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'energie'},on:{"click":function($event){_vm.changeView('energie')}}},[_vm._v("Energie")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'grafiek'},on:{"click":function($event){_vm.changeView('grafiek')}}},[_vm._v("Grafieken")])],1)],1),_vm._v("\n                         "),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'grafiek'),expression:"currentview == 'grafiek'"}],staticClass:"col-sm-6"},[_c('b-input-group',[_c('b-input-group',{attrs:{"left":"Van"}},[_c('datepicker',{ref:"begindatum",staticStyle:{"background-color":"#ffffff"},attrs:{"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"begindatum","id":"begindatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphs()}},model:{value:(_vm.begindatum),callback:function ($$v) {_vm.begindatum=$$v},expression:"begindatum"}})],1),_vm._v("\n                              \n                            "),_c('b-input-group',{attrs:{"left":"Tot"}},[_c('datepicker',{ref:"einddatum",staticStyle:{"background-color":"#ffffff"},attrs:{"required":true,"bootstrapStyling":true,"disabled-dates":_vm.disabled,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"einddatum","id":"einddatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.fillGraphs()}},model:{value:(_vm.einddatum),callback:function ($$v) {_vm.einddatum=$$v},expression:"einddatum"}})],1),_vm._v("\n                                  \n                        ")],1)],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.currentview == 'data'),expression:"schemabestaat && currentview == 'data'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":3}},[_vm._v("Klassieke belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":3}},[_vm._v("Lichtintegratie")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("DLI zon (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI werkelijk"),_c('br'),_vm._v("ontvangen (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI werkelijk"),_c('br'),_vm._v("ontvangen (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',{staticClass:"rborder"},[_vm._v("25/04/2019")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',[_vm._v("22.0")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":3}},[_vm._v("Klassieke belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":3}},[_vm._v("Lichtintegratie")])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("DLI gewenst (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("DLI zon (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI werkelijk"),_c('br'),_vm._v("ontvangen (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI belichting (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI werkelijk"),_c('br'),_vm._v("ontvangen (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',[_vm._v("DLI cumulatief (mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]),_vm._v(" "),_vm._l((_vm.model.klassiekebelichting_n),function(klassiek,indexi){return _c('tr',[_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.datumDDMMYYYY(klassiek.datum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(klassiek.gewensteDli))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(klassiek.dliZon))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.klassiekmodel.klassiekebelichting_n[indexi].dliBelichting)))]),_vm._v(" "),_c('td',{class:_vm.genoegLicht(klassiek.gewensteDli, _vm.klassiekmodel.klassiekebelichting_n[indexi].dliTot)},[_vm._v(_vm._s(_vm.komma1(_vm.klassiekmodel.klassiekebelichting_n[indexi].dliTot)))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma1(_vm.dliklassiekcumulatief[indexi])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(klassiek.dliBelichting)))]),_vm._v(" "),_c('td',{class:_vm.genoegLicht(klassiek.gewensteDli, klassiek.totDli)},[_vm._v(_vm._s(_vm.komma1(klassiek.totDli)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma1(_vm.dlicumulatief[indexi])))])])})],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.klassiekeurenbestaat && _vm.lichtintegratiebestaat && _vm.currentview == 'energie'),expression:"schemabestaat && klassiekeurenbestaat && lichtintegratiebestaat && currentview == 'energie'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 3)}},[_vm._v("Klassieke belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 3)}},[_vm._v("Lichtintegratie")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])],_vm._v(" "),[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])],_vm._v(" "),[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',[_vm._v("C")])]],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',{staticClass:"rborder"},[_vm._v("23/02/2020")]),_vm._v(" "),_c('td',[_vm._v("2.00")]),_vm._v(" "),(_vm.klassiekeurenbestaat)?[(_vm.klassiekeurenbestaat)?[_vm._l((_vm.modelklassiekeuren.klassiekebelichting_n[0].klassiekperdag_n),function(klassiekperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.22")])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiektotaal[_vm.model.klassiekebelichting_n.length - 1])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiekcumulatief[_vm.model.klassiekebelichting_n.length - 1])))])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.lichtintegratiebestaat)?[_c('td',[_vm._v("22.00")]),_vm._v(" "),_vm._l((_vm.modellichtintegratie.klassiekebelichting_n[0].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.22")])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieideaaltotaal[_vm.model.klassiekebelichting_n.length - 1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieideaalcumulatief[_vm.model.klassiekebelichting_n.length - 1])))])]:_vm._e()],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 3)}},[_vm._v("Klassieke belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 3)}},[_vm._v("Lichtintegratie")])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])],_vm._v(" "),[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])],_vm._v(" "),[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',[_vm._v("C")])]],2),_vm._v(" "),_vm._l((_vm.model.klassiekebelichting_n),function(klassiek,indexi){return _c('tr',[_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.datumDDMMYYYY(klassiek.datum)))]),_vm._v(" "),(_vm.klassiekeurenbestaat)?[(_vm.klassiekeurenbestaat)?_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modelklassiekeuren.klassiekebelichting_n[indexi].dliBelichting)))]):_vm._e(),_vm._v(" "),(_vm.klassiekeurenbestaat)?[_vm._l((_vm.modelklassiekeuren.klassiekebelichting_n[indexi].klassiekperdag_n),function(klassiekperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiek[indexi].klassiekperdag[indexk].kwh)))])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiektotaal[indexi])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiekcumulatief[indexi])))])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.lichtintegratiebestaat)?[(_vm.lichtintegratiebestaat)?_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modellichtintegratie.klassiekebelichting_n[indexi].dliBelichting)))]):_vm._e(),_vm._v(" "),_vm._l((_vm.modellichtintegratie.klassiekebelichting_n[indexi].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.energieideaal[indexi].systeem[indexk].kwh)))])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieideaaltotaal[indexi])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieideaalcumulatief[indexi])))])]:_vm._e()],2)})],2)]),_c('span',{staticStyle:{"float":"right","width":"40px"}},[_vm._v(" ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.currentview == 'grafiek'),expression:"schemabestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("Lichtintegratie vs. klassiek belichtingsschema")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("mol/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chart',{ref:"grafiek",staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection,"height":"400","miny":_vm.miny,"maxy":_vm.maxy,"changeyaxis":_vm.changeyaxis}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.schemabestaat && _vm.currentview == 'grafiek'),expression:"schemabestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("Lichtintegratie vs. klassiek belichtingsschema (cumulatief)")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("mol/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chartm',{ref:"grafiek",staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection2,"height":"400","miny":_vm.miny2,"maxy":_vm.maxy2,"changeyaxis":_vm.changeyaxis2}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.klassiekeurenbestaat && _vm.lichtintegratiebestaat && _vm.currentview == 'grafiek'),expression:"klassiekeurenbestaat && lichtintegratiebestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("Cumulatief elektriciteitsverbruik")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("kWh/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chart',{staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection3,"height":"400","miny":_vm.miny3,"maxy":_vm.maxy3,"changeyaxis":_vm.changeyaxis3}})],1)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Terug")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"klassiekmodel":_vm.klassiekmodel,"modellichtintegratie":_vm.modellichtintegratie,"invloedspercentages":_vm.invloedspercentages,"modelklassiekeuren":_vm.modelklassiekeuren,"isEditing":true}})],1):_c('div',{staticClass:"midden"},[_c('div',{staticStyle:{"color":"#20a8d8","font-size":"large"}},[_vm._v("Even geduld a.u.b.")]),_vm._v(" "),_c('fadeloader',{staticClass:"spinner2",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditWerkelijk_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc67182_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditWerkelijk_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditWerkelijk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc67182_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditWerkelijk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_FadeLoader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormWerkelijk__ = __webpack_require__(597);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            warningModal: false,
            warningSchema: false,
            warningGeduld: false,

            errormsg: '',
            model: {},
            modellichtintegratie: {},
            modelvoorstel: {},
            modelklassiekeuren: {},
            invloedspercentages: {},

            loading: true,
            size: '20px',
            color: '#20a8d8'
        };
    },
    created: function created() {
        this.getSchema(this.$route.params.id);
        this.getVoorstel(this.$route.params.id);
        this.getKlassiekeUren(this.$route.params.id);
    },

    methods: {
        getSchema: function getSchema(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getWerkelijkebelichting(id).then(function (response) {
                _this.model = response.data.werkelijk.model;
                _this.modellichtintegratie = response.data.lichtintegratie.model;
                _this.invloedspercentages = response.data.lichtintegratie.invloedspercentages;
            });
        },
        getVoorstel: function getVoorstel(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getVoorstelBelichting(id).then(function (response) {
                _this2.modelvoorstel = response.data.model;
            });
        },
        getKlassiekeUren: function getKlassiekeUren(id) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getKlassiekebelichting(id).then(function (response) {
                _this3.modelklassiekeuren = response.data.model;
            });
        },
        saveRefresh: function saveRefresh(id, model) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].updateWerkelijkebelichting(model).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].getVoorstelBelichting(id).then(function (response) {
                    _this4.modelvoorstel = response.data.model;
                });
            }, function (error) {
                _this4.errormsg = error.message;
                _this4.warningModal = true;
            });
        },
        createSchema: function createSchema(model) {
            var _this5 = this;

            this.warningGeduld = true;
            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].createWerkelijkebelichting(model).then(function () {
                _this5.warningGeduld = false;
                _this5.getSchema(model.id);
                _this5.getVoorstel(model.id);
                _this5.getKlassiekeUren(model.id);
            }, function (error) {
                _this5.warningGeduld = false;
                _this5.errormsg = error.message;
                _this5.warningSchema = true;
            });
        },
        updateItem: function updateItem(model) {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_1__api_afdelingteelt__["a" /* default */].updateWerkelijkebelichting(model).then(function () {
                _this6.$router.replace('/beheer/afdelingteelt');
            }, function (error) {
                _this6.errormsg = error.message;
                _this6.warningModal = true;
            });
        },
        closedialog: function closedialog() {
            this.warningModal = false;
            this.warningSchema = false;
        }
    },
    components: {
        'item-form': __WEBPACK_IMPORTED_MODULE_2__FormWerkelijk__["a" /* default */],
        fadeloader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_FadeLoader__["a" /* default */]
    }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormWerkelijk_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5b1108_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormWerkelijk_vue__ = __webpack_require__(600);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormWerkelijk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5b1108_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormWerkelijk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartMixed__ = __webpack_require__(60);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Form',
    props: ['model', 'modellichtintegratie', 'invloedspercentages', 'modelvoorstel', 'modelklassiekeuren', 'isEditing'],
    data: function data() {
        return {
            ideaalzichtbaar: true,
            voorstelzichtbaar: true,
            werkelijkzichtbaar: true,
            urenzichtbaar: true,
            firstrow: -1,
            currentview: 'data',
            datacollection: null,
            miny: 0,
            maxy: 25,
            changeyaxis: false,
            begindatum: '',
            einddatum: '',
            disabled: {
                to: new Date(),
                from: new Date()
            },
            bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(255,221,50,1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)'],
            fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(255,221,50,0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)']
        };
    },

    methods: {
        toggleideaalzichtbaar: function toggleideaalzichtbaar() {
            this.ideaalzichtbaar = !this.ideaalzichtbaar;
        },
        togglevoorstelzichtbaar: function togglevoorstelzichtbaar() {
            this.voorstelzichtbaar = !this.voorstelzichtbaar;
        },
        togglewerkelijkzichtbaar: function togglewerkelijkzichtbaar() {
            this.werkelijkzichtbaar = !this.werkelijkzichtbaar;
        },
        toggleurenzichtbaar: function toggleurenzichtbaar() {
            this.urenzichtbaar = !this.urenzichtbaar;
        },
        changeView: function changeView(view) {
            this.currentview = view;
            if (view === 'grafiek') {
                if (this.begindatum === '') {
                    this.begindatum = new Date(this.model.werkelijkebelichting_n[0].datum);
                    this.einddatum = new Date(this.model.werkelijkebelichting_n[this.model.werkelijkebelichting_n.length - 1].datum);
                    this.disabled.to = this.begindatum;
                    this.disabled.from = this.einddatum;
                }
                this.fillGraphData();
            }
        },
        getMaxValueDatasets: function getMaxValueDatasets(datasets) {
            var maxwaarde = 0;
            datasets.forEach(function (dataset) {
                maxwaarde = Math.max(maxwaarde, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(dataset.data)));
            });
            return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
        },
        fillGraphData: function fillGraphData() {
            this.datacollection = {
                type: 'bar',
                labels: this.getGraphLabels(),
                datasets: this.getGraphBarsAndLines()
            };
            this.miny = 0;
            this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
            this.changeyaxis = !this.changeyaxis;
        },
        getGraphLabels: function getGraphLabels() {
            var _this = this;

            var labels = [];
            this.model.werkelijkebelichting_n.forEach(function (werkelijk) {
                if (werkelijk.datum >= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.begindatum) && werkelijk.datum <= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this.einddatum)) {
                    labels.push(_this.datumDDMMYYYY(werkelijk.datum));
                }
            });
            return labels;
        },
        getGraphBarsAndLines: function getGraphBarsAndLines() {
            var datasets = [];
            this.getGraphIdeaal(datasets);
            this.getGraphVoorstel(datasets);
            this.getGraphWerkelijk(datasets);
            this.getGraphKlassiek(datasets);
            return datasets;
        },
        getGraphIdeaal: function getGraphIdeaal(datasets) {
            var _this2 = this;

            var data = [];
            var indexi = 0;
            this.model.werkelijkebelichting_n.forEach(function (werkelijk) {
                if (werkelijk.datum >= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.begindatum) && werkelijk.datum <= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this2.einddatum)) {
                    data.push(_this2.komma2(_this2.energieideaalcumulatief[indexi]));
                }
                indexi++;
            });
            var dataset = {
                backgroundColor: 'rgba(0,204,0, 0)',
                borderColor: 'rgba(0,204,0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' Ideaal',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphVoorstel: function getGraphVoorstel(datasets) {
            var _this3 = this;

            var data = [];
            var indexi = 0;
            this.model.werkelijkebelichting_n.forEach(function (werkelijk) {
                if (werkelijk.datum >= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.begindatum) && werkelijk.datum <= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this3.einddatum)) {
                    data.push(_this3.komma2(_this3.energievoorstelcumulatief[indexi]));
                }
                indexi++;
            });
            var dataset = {
                backgroundColor: 'rgba(0,153,153, 0)',
                borderColor: 'rgba(0,153,153, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' Voorstel',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphWerkelijk: function getGraphWerkelijk(datasets) {
            var _this4 = this;

            var data = [];
            var indexi = 0;
            this.model.werkelijkebelichting_n.forEach(function (werkelijk) {
                if (werkelijk.datum >= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this4.begindatum) && werkelijk.datum <= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this4.einddatum)) {
                    data.push(_this4.komma2(_this4.energiewerkelijkcumulatief[indexi]));
                }
                indexi++;
            });
            var dataset = {
                backgroundColor: 'rgba(193,46,12, 0)',
                borderColor: 'rgba(193,46,12, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' Werkelijk',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        getGraphKlassiek: function getGraphKlassiek(datasets) {
            var _this5 = this;

            var data = [];
            var indexi = 0;
            this.modelklassiekeuren.klassiekebelichting_n.forEach(function (klassiek) {
                if (klassiek.datum >= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this5.begindatum) && klassiek.datum <= __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoYYYYMMDDZero(_this5.einddatum)) {
                    data.push(_this5.komma2(_this5.energieklassiekcumulatief[indexi]));
                }
                indexi++;
            });
            var dataset = {
                backgroundColor: 'rgba(139,0,139, 0)',
                borderColor: 'rgba(0139,0,139, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                type: 'line',
                label: ' Klassiek',
                data: data,
                yAxisID: 'line'
            };
            datasets.push(dataset);
        },
        wis: function wis(perdag) {
            perdag.tijd = '';
        },
        klikt: function klikt(index) {
            if (this.model.werkelijkebelichting_n[index].selected === 0) {
                if (this.firstrow === -1) {
                    this.model.werkelijkebelichting_n[index].selected = 1;
                    this.firstrow = index;
                } else if (this.firstrow < index) {
                    for (var i = this.firstrow + 1; i <= index; i += 1) {
                        for (var j = 0; j < this.model.werkelijkebelichting_n[this.firstrow].werkelijkperdag_n.length; j += 1) {
                            this.model.werkelijkebelichting_n[i].werkelijkperdag_n[j].tijd = this.model.werkelijkebelichting_n[this.firstrow].werkelijkperdag_n[j].tijd;
                            this.modelvoorstel.werkelijkebelichting_n[i].selected = 2;
                        }
                    }
                    this.model.werkelijkebelichting_n[this.firstrow].selected = 0;
                    this.firstrow = -1;
                }
            } else {
                this.model.werkelijkebelichting_n[index].selected = 0;
                this.firstrow = -1;
            }
        },
        gewijzigd: function gewijzigd(index) {
            this.modelvoorstel.werkelijkebelichting_n[index].selected = 2;
        },
        selectValue: function selectValue(werkelijk) {
            if (werkelijk.selected === 0) {
                return 'fa fa-navicon';
            }
            if (werkelijk.selected === 1) {
                return 'fa fa-sort-amount-asc';
            }
            return '';
        },
        refreshValue: function refreshValue(voorstelwerkelijk) {
            if (voorstelwerkelijk.selected === 0) {
                return 'fa fa-refresh licht';
            }
            if (voorstelwerkelijk.selected === 1) {
                return 'fa fa-hourglass-half';
            }
            if (voorstelwerkelijk.selected === 2) {
                return 'fa fa-refresh';
            }
            return '';
        },
        genoegLicht: function genoegLicht(nodig, hebje) {
            if (hebje >= nodig) {
                return 'green';
            }
            if (hebje >= nodig * 0.75) {
                return 'orange';
            }
            return 'red';
        },
        saveRefresh: function saveRefresh(indexi) {
            var _this6 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this6.isError) {
                        _this6.modelvoorstel.werkelijkebelichting_n[indexi].selected = 1;
                        _this6.$emit('save-refresh', _this6.model.id, _this6.model);
                    }
                }
            });
        },
        createschema: function createschema() {
            this.$emit('create-schema', this.model);
        },
        saveItem: function saveItem() {
            var _this7 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this7.isError) {
                        _this7.$emit('save-item', _this7.model);
                    }
                }
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        datumDDMMYYYY: function datumDDMMYYYY(datum) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(datum);
        },
        timeHHMM: function timeHHMM(time) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].timetoHHMM(time);
        },
        berekenVermogen: function berekenVermogen(schakelniveau, belichting) {
            return belichting.fotonflux * schakelniveau.percentage / 100;
        },
        komma4: function komma4(waarde) {
            if (isNaN(waarde)) {
                return '#.####';
            }
            return waarde.toFixed(4);
        },
        komma2: function komma2(waarde) {
            if (isNaN(waarde)) {
                return '#.##';
            }
            return waarde.toFixed(2);
        },
        komma1: function komma1(waarde) {
            if (isNaN(waarde)) {
                return '#.#';
            }
            return waarde.toFixed(1);
        },
        komma0: function komma0(waarde) {
            if (isNaN(waarde)) {
                return '#';
            }
            return waarde.toFixed(0);
        }
    },
    computed: {
        werkelijkbestaat: function werkelijkbestaat() {
            return this.model.werkelijkebelichting_n.length !== 0;
        },
        voorstelbestaat: function voorstelbestaat() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modelvoorstel).length !== 0 && this.modelvoorstel.werkelijkebelichting_n.length !== 0;
        },
        urenbestaat: function urenbestaat() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modelklassiekeuren).length !== 0 && this.modelklassiekeuren.klassiekebelichting_n.length !== 0;
        },
        urenopgehaaldenbestaatniet: function urenopgehaaldenbestaatniet() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modelklassiekeuren).length !== 0 && this.modelklassiekeuren.klassiekebelichting_n.length == 0;
        },
        aantalsystemen: function aantalsystemen() {
            var aantal = 0;
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                aantal += belichting.schakelniveau_n.length;
            });
            return aantal;
        },
        dlibelichting: function dlibelichting() {
            var _this8 = this;

            var resultaat = [];
            this.model.werkelijkebelichting_n.forEach(function (werkelijk) {
                var perdagarray = [];
                werkelijk.werkelijkperdag_n.forEach(function (perdag, i) {
                    perdagarray.push({ mol: __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].getSeconden(perdag.tijd) * _this8.installatie[i] / 1000000 });
                });
                resultaat.push({ datum: werkelijk.datum, perdag: perdagarray });
            });
            return resultaat;
        },
        dlitotaal: function dlitotaal() {
            var resultaat = [];
            var i = 0;
            this.dlibelichting.forEach(function (dlibelichting) {
                var totaal = 0;
                dlibelichting.perdag.forEach(function (perdag) {
                    if (!isNaN(perdag.mol)) {
                        totaal += perdag.mol;
                    }
                });

                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        dlicumulatief: function dlicumulatief() {
            var resultaat = [];
            var vorigtotaal = this.model.cumulatief;
            this.dlitotaal.forEach(function (dlitotaal) {
                resultaat.push(vorigtotaal + dlitotaal);
                vorigtotaal += dlitotaal;
            });
            return resultaat;
        },
        energieideaal: function energieideaal() {
            var _this9 = this;

            var resultaat = [];
            this.modellichtintegratie.klassiekebelichting_n.forEach(function (klassiekebelichting) {
                var systeemarray = [];
                klassiekebelichting.systemen.forEach(function (systeem, i) {
                    systeemarray.push({ kwh: __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].getSeconden(systeem.belichtingsuren) * _this9.installatie[i] / systeem.efficientie / 3600000 });
                });
                resultaat.push({ datum: klassiekebelichting.datum, systeem: systeemarray });
            });
            return resultaat;
        },
        energieideaaltotaal: function energieideaaltotaal() {
            var resultaat = [];
            var i = 0;
            this.energieideaal.forEach(function (energieideaal) {
                var totaal = 0;
                energieideaal.systeem.forEach(function (systeem) {
                    if (!isNaN(systeem.kwh)) {
                        totaal += systeem.kwh;
                    }
                });
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        energieideaalcumulatief: function energieideaalcumulatief() {
            var resultaat = [];
            var vorigtotaal = 0;
            this.energieideaaltotaal.forEach(function (energieideaaltotaal) {
                resultaat.push(vorigtotaal + energieideaaltotaal);
                vorigtotaal += energieideaaltotaal;
            });
            return resultaat;
        },
        energievoorstel: function energievoorstel() {
            var _this10 = this;

            var resultaat = [];
            this.modelvoorstel.werkelijkebelichting_n.forEach(function (werkelijkebelichting) {
                var systeemarray = [];
                werkelijkebelichting.systemen.forEach(function (systeem, i) {
                    systeemarray.push({ kwh: __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].getSeconden(systeem.belichtingsuren) * _this10.installatie[i] / systeem.efficientie / 3600000 });
                });
                resultaat.push({ datum: werkelijkebelichting.datum, systeem: systeemarray });
            });
            return resultaat;
        },
        energievoorsteltotaal: function energievoorsteltotaal() {
            var resultaat = [];
            var i = 0;
            this.energievoorstel.forEach(function (energievoorstel) {
                var totaal = 0;
                energievoorstel.systeem.forEach(function (systeem) {
                    if (!isNaN(systeem.kwh)) {
                        totaal += systeem.kwh;
                    }
                });
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        energievoorstelcumulatief: function energievoorstelcumulatief() {
            var resultaat = [];
            var vorigtotaal = 0;
            this.energievoorsteltotaal.forEach(function (energievoorsteltotaal) {
                resultaat.push(vorigtotaal + energievoorsteltotaal);
                vorigtotaal += energievoorsteltotaal;
            });
            return resultaat;
        },
        energiewerkelijk: function energiewerkelijk() {
            var _this11 = this;

            var resultaat = [];
            this.model.werkelijkebelichting_n.forEach(function (werkelijkebelichting) {
                var werkelijkperdagarray = [];
                werkelijkebelichting.werkelijkperdag_n.forEach(function (werkelijkperdag, i) {
                    werkelijkperdagarray.push({ kwh: __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].getSeconden(werkelijkperdag.tijd) * _this11.installatie[i] / _this11.efficientie[i] / 3600000 });
                });
                resultaat.push({ datum: werkelijkebelichting.datum, werkelijkperdag: werkelijkperdagarray });
            });
            return resultaat;
        },
        energiewerkelijktotaal: function energiewerkelijktotaal() {
            var resultaat = [];
            var i = 0;
            this.energiewerkelijk.forEach(function (energiewerkelijk) {
                var totaal = 0;
                energiewerkelijk.werkelijkperdag.forEach(function (werkelijkperdag) {
                    if (!isNaN(werkelijkperdag.kwh)) {
                        totaal += werkelijkperdag.kwh;
                    }
                });
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        energiewerkelijkcumulatief: function energiewerkelijkcumulatief() {
            var resultaat = [];
            var vorigtotaal = 0;
            this.energiewerkelijktotaal.forEach(function (energiewerkelijktotaal) {
                resultaat.push(vorigtotaal + energiewerkelijktotaal);
                vorigtotaal += energiewerkelijktotaal;
            });
            return resultaat;
        },
        energieklassiek: function energieklassiek() {
            var _this12 = this;

            var resultaat = [];
            this.modelklassiekeuren.klassiekebelichting_n.forEach(function (klassiekebelichting) {
                var klassiekperdagarray = [];
                klassiekebelichting.klassiekperdag_n.forEach(function (klassiekperdag, i) {
                    klassiekperdagarray.push({ kwh: __WEBPACK_IMPORTED_MODULE_2__helpers_datefunctions__["a" /* default */].getSeconden(klassiekperdag.tijd) * _this12.installatie[i] / _this12.efficientie[i] / 3600000 });
                });
                resultaat.push({ datum: klassiekebelichting.datum, klassiekperdag: klassiekperdagarray });
            });
            return resultaat;
        },
        energieklassiektotaal: function energieklassiektotaal() {
            var resultaat = [];
            var i = 0;
            this.energieklassiek.forEach(function (energieklassiek) {
                var totaal = 0;
                energieklassiek.klassiekperdag.forEach(function (klassiekperdag) {
                    if (!isNaN(klassiekperdag.kwh)) {
                        totaal += klassiekperdag.kwh;
                    }
                });
                resultaat.push(totaal);
                i += 1;
            });
            return resultaat;
        },
        energieklassiekcumulatief: function energieklassiekcumulatief() {
            var resultaat = [];
            var vorigtotaal = 0;
            this.energieklassiektotaal.forEach(function (energieklassiektotaal) {
                resultaat.push(vorigtotaal + energieklassiektotaal);
                vorigtotaal += energieklassiektotaal;
            });
            return resultaat;
        },
        installatie: function installatie() {
            var _this13 = this;

            var resultaat = [];
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                belichting.schakelniveau_n.forEach(function (schakelniveau) {
                    resultaat.push(_this13.berekenVermogen(schakelniveau, belichting));
                });
            });
            return resultaat;
        },
        efficientie: function efficientie() {
            var resultaat = [];
            this.model.afdeling.belichting_n.forEach(function (belichting) {
                belichting.schakelniveau_n.forEach(function (schakelniveau) {
                    resultaat.push(belichting.efficientie);
                });
            });
            return resultaat;
        }
    },
    components: {
        chart: __WEBPACK_IMPORTED_MODULE_3__ChartMixed__["a" /* default */]
    }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:[_vm.isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']}),_c('strong',[_vm._v(" Werkelijke belichting")]),_vm._v(" "),_c('small',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.werkelijkbestaat),expression:"werkelijkbestaat"}]},[_vm._v("wijzigen")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.werkelijkbestaat),expression:"!werkelijkbestaat"}]},[_vm._v("creëren")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Afdeling: ")]),_c('td',[_vm._v(_vm._s(_vm.model.afdeling.naam))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewas: ")]),_c('td',[_vm._v(_vm._s(_vm.model.teelt.naam)+" - "+_vm._s(_vm.model.ras))]),_vm._v(" "),_c('th',[_vm._v("Aanplantdatum - einddatum: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.aanplantdatum))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatum)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gewenste DLI: ")]),_c('td',[_vm._v(_vm._s(_vm.model.ingesteldeDli))]),_vm._v(" "),_c('th',[_vm._v("Belichtingsseizoen start - einde: ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.datumDDMMYYYY(_vm.model.startdatumBelichting))+" - "+_vm._s(_vm.datumDDMMYYYY(_vm.model.einddatumBelichting)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Installatie (µmol/m"),_c('sup',[_vm._v("2")]),_vm._v("s)")]),_vm._v(" "),_c('th',[_vm._v("Efficiëntie (µmol/J)")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.afdeling.belichting_n),function(belichting,indexi,i){return [_vm._l((belichting.schakelniveau_n),function(schakelniveau,indexj,i){return [_c('tr',[_c('td',[_vm._v("Systeem "+_vm._s(schakelniveau.nummer + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.soortbelichting.naam)+" "+_vm._s(indexj + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma4(_vm.installatie[schakelniveau.nummer])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(belichting.efficientie))])])]})]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n                         "),_c('br')])]),_vm._v(" "),(_vm.urenbestaat || _vm.werkelijkbestaat)?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.werkelijkbestaat),expression:"!werkelijkbestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"red"},[_vm._v("Er bestaat voor deze teelt nog geen formulier om de werkelijke belichtingsuren in te vullen.")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._v("\n                             "),_c('br')])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.werkelijkbestaat),expression:"werkelijkbestaat"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('b-button-group',{attrs:{"id":"periode","name":"periode"}},[_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'data'},on:{"click":function($event){_vm.changeView('data')}}},[_vm._v("DLI")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentview == 'grafiek'},on:{"click":function($event){_vm.changeView('grafiek')}}},[_vm._v("Energie")])],1)],1),_vm._v("\n                             "),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentview == 'grafiek'),expression:"currentview == 'grafiek'"}],staticClass:"col-sm-6"})]),_vm._v(" "),(_vm.werkelijkbestaat && _vm.currentview == 'data')?_c('div',{staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',{staticClass:"rborder",attrs:{"colspan":"2"}}),_vm._v(" "),(_vm.ideaalzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Ideaal")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleideaalzichtbaar()}}},[_c('i',{class:[_vm.ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.voorstelzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 1)}},[_vm._v("Voorstel")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglevoorstelzichtbaar()}}},[_c('i',{class:[_vm.voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.werkelijkzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 1)}},[_vm._v("Werkelijk")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglewerkelijkzichtbaar()}}},[_c('i',{class:[_vm.werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.urenzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Klassiek")]):_vm._e(),_vm._v(" "),_c('th',[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleurenzichtbaar()}}},[_c('i',{class:[_vm.urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',[_vm._v("DLI gewenst")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("DLI zon")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th'),_vm._v(" "),_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th'),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen)}},[_vm._v("Belichtingsuren")])]:[_c('th')]],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{class:{ rborder: (_vm.aantalsystemen == i) },staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th'),_vm._v(" "),_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{class:{ rborder: (_vm.aantalsystemen == i) },staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th'),_vm._v(" "),_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{class:{ rborder: (_vm.aantalsystemen == i) },staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th')]],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',{staticClass:"rborder"},[_vm._v("23/02/2020")]),_vm._v(" "),_c('td',[_vm._v("22.0")]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v("22.0")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('td',[_vm._v("22.0")]),_vm._v(" "),_vm._l((_vm.modellichtintegratie.klassiekebelichting_n[0].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                                                00:00\n                                            ")])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar && _vm.voorstelbestaat)?[(_vm.voorstelbestaat)?_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-refresh licht"})])]):_vm._e(),_vm._v(" "),(_vm.voorstelbestaat)?_c('td',[_vm._v("22.00")]):_vm._e(),_vm._v(" "),(_vm.voorstelbestaat)?[_vm._l((_vm.modelvoorstel.werkelijkebelichting_n[0].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                                                    00:01\n                                                ")])]})]:_vm._e()]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-navicon"})])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("22.00")]),_vm._v(" "),_vm._l((_vm.model.werkelijkebelichting_n[0].werkelijkperdag_n),function(perdag,indexj){return [_c('td',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"centered"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],staticClass:"form-control unstyleduur",attrs:{"type":"text"}})])])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar && _vm.urenbestaat)?[_c('td',[_vm._v("1.00")]),_vm._v(" "),_vm._l((_vm.modelklassiekeuren.klassiekebelichting_n[0].klassiekperdag_n),function(klassiekperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("00:02")])]})]:[_c('th')]],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',{staticClass:"rborder",attrs:{"colspan":"2"}}),_vm._v(" "),(_vm.ideaalzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Ideaal")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleideaalzichtbaar()}}},[_c('i',{class:[_vm.ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.voorstelzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 1)}},[_vm._v("Voorstel")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglevoorstelzichtbaar()}}},[_c('i',{class:[_vm.voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.werkelijkzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 1)}},[_vm._v("Werkelijk")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglewerkelijkzichtbaar()}}},[_c('i',{class:[_vm.werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.urenzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Klassiek")]):_vm._e(),_vm._v(" "),_c('th',[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleurenzichtbaar()}}},[_c('i',{class:[_vm.urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),_c('th',[_vm._v("DLI gewenst")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("DLI zon")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th'),_vm._v(" "),_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th'),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.aantalsystemen}},[_vm._v("Belichtingsuren")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen)}},[_vm._v("Belichtingsuren")])]:[_c('th')]],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{class:{ rborder: (_vm.aantalsystemen == i) },staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th'),_vm._v(" "),_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{class:{ rborder: (_vm.aantalsystemen == i) },staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th'),_vm._v(" "),_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{class:{ rborder: (_vm.aantalsystemen == i) },staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]})]:[_c('th')]],2),_vm._v(" "),_vm._l((_vm.model.werkelijkebelichting_n),function(werkelijk,indexi){return _c('tr',[_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.datumDDMMYYYY(werkelijk.datum)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(werkelijk.gewensteDli))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(werkelijk.dliZon))]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modellichtintegratie.klassiekebelichting_n[indexi].dliBelichting)))]),_vm._v(" "),_vm._l((_vm.modellichtintegratie.klassiekebelichting_n[indexi].systemen),function(systeem,indexk){return [_c('td',{class:{ rborder: (_vm.aantalsystemen == (indexk + 1)) },staticStyle:{"text-align":"center"}},[_vm._v("\n                                                "+_vm._s(systeem.belichtingsuren)+"\n                                            ")])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar && _vm.voorstelbestaat)?[(_vm.voorstelbestaat)?_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.saveRefresh(indexi)}}},[_c('i',{class:_vm.refreshValue(_vm.modelvoorstel.werkelijkebelichting_n[indexi])})])]):_vm._e(),_vm._v(" "),(_vm.voorstelbestaat)?_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modelvoorstel.werkelijkebelichting_n[indexi].dliBelichting)))]):_vm._e(),_vm._v(" "),(_vm.voorstelbestaat)?[_vm._l((_vm.modelvoorstel.werkelijkebelichting_n[indexi].systemen),function(systeem,indexk){return [_c('td',{class:{ rborder: (_vm.aantalsystemen == (indexk + 1)) },staticStyle:{"text-align":"center"}},[_vm._v("\n                                                    "+_vm._s(systeem.belichtingsuren)+"\n                                                ")])]})]:_vm._e()]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar & _vm.voorstelbestaat)?[_c('td',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.klikt(indexi)}}},[_c('i',{class:_vm.selectValue(werkelijk)})])]),_vm._v(" "),_c('td',{class:_vm.genoegLicht(werkelijk.gewensteDli, _vm.modelvoorstel.werkelijkebelichting_n[indexi].totDlimetD - _vm.modelvoorstel.werkelijkebelichting_n[indexi].dliBelichting + _vm.dlitotaal[indexi]),staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.dlitotaal[indexi])))]),_vm._v(" "),_vm._l((werkelijk.werkelijkperdag_n),function(perdag,indexj){return [_c('td',{class:{ rborder: (_vm.aantalsystemen == (indexj + 1)) },staticStyle:{"text-align":"center"}},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(perdag.tijd),expression:"perdag.tijd"}],staticClass:"form-control unstyleduur",attrs:{"type":"text","autocomplete":"off","id":'tijd' + ((indexi * 50) + indexj),"name":'tijd' + ((indexi * 50) + indexj)},domProps:{"value":(perdag.tijd)},on:{"change":function($event){_vm.gewijzigd(indexi)},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.wis(perdag)},"input":function($event){if($event.target.composing){ return; }_vm.$set(perdag, "tijd", $event.target.value)}}})])]})]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar && _vm.urenbestaat)?[_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modelklassiekeuren.klassiekebelichting_n[indexi].dliBelichting)))]),_vm._v(" "),_vm._l((_vm.modelklassiekeuren.klassiekebelichting_n[indexi].klassiekperdag_n),function(klassiekperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(klassiekperdag.tijd))])]})]:[_c('th')]],2)})],2)])])]):_vm._e(),_vm._v(" "),(_vm.werkelijkbestaat && _vm.currentview == 'grafiek')?_c('div',{staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-striped table-sm text-center table-fixed"},[_c('thead',[_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),(_vm.ideaalzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Ideaal")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleideaalzichtbaar()}}},[_c('i',{class:[_vm.ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.voorstelzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Voorstel")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglevoorstelzichtbaar()}}},[_c('i',{class:[_vm.voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.werkelijkzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Werkelijk")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglewerkelijkzichtbaar()}}},[_c('i',{class:[_vm.werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.urenzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Klassiek")]):_vm._e(),_vm._v(" "),_c('th',[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleurenzichtbaar()}}},[_c('i',{class:[_vm.urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"}),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th')]],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',[_vm._v("C")])]:[_c('th')]],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('td',{staticClass:"rborder"},[_vm._v("22/02/2020")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('td',[_vm._v("0.22")]),_vm._v(" "),_vm._l((_vm.modellichtintegratie.klassiekebelichting_n[0].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.23")])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieideaaltotaal[_vm.model.werkelijkebelichting_n.length - 1])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energieideaalcumulatief[_vm.model.werkelijkebelichting_n.length - 1])))])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar && _vm.voorstelbestaat)?[(_vm.voorstelbestaat)?_c('td',[_vm._v("0.24")]):_vm._e(),_vm._v(" "),(_vm.voorstelbestaat)?[_vm._l((_vm.modelvoorstel.werkelijkebelichting_n[0].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.25")])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energievoorsteltotaal[_vm.model.werkelijkebelichting_n.length - 1])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energievoorstelcumulatief[_vm.model.werkelijkebelichting_n.length - 1])))])]:_vm._e()]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.26")]),_vm._v(" "),_vm._l((_vm.model.werkelijkebelichting_n[0].werkelijkperdag_n),function(werkelijkperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.27")])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energiewerkelijktotaal[_vm.model.werkelijkebelichting_n.length - 1])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energiewerkelijkcumulatief[_vm.model.werkelijkebelichting_n.length - 1])))])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar && _vm.urenbestaat)?[(_vm.urenbestaat)?_c('td',[_vm._v("0.28")]):_vm._e(),_vm._v(" "),(_vm.urenbestaat)?[_vm._l((_vm.modelklassiekeuren.klassiekebelichting_n[0].klassiekperdag_n),function(klassiekperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("0.29")])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiektotaal[_vm.model.werkelijkebelichting_n.length - 1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiekcumulatief[_vm.model.werkelijkebelichting_n.length - 1])))])]:_vm._e()]:[_c('th')]],2)]),_vm._v(" "),_c('tbody',[_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),(_vm.ideaalzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Ideaal")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleideaalzichtbaar()}}},[_c('i',{class:[_vm.ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.voorstelzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Voorstel")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglevoorstelzichtbaar()}}},[_c('i',{class:[_vm.voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.werkelijkzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Werkelijk")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"rborder"},[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.togglewerkelijkzichtbaar()}}},[_c('i',{class:[_vm.werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])]),_vm._v(" "),(_vm.urenzichtbaar)?_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Klassiek")]):_vm._e(),_vm._v(" "),_c('th',[_c('a',{attrs:{"href":"javascript:void(0)","title":"toon/verberg"},on:{"click":function($event){_vm.toggleurenzichtbaar()}}},[_c('i',{class:[_vm.urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']})])])]),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"}),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th',[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticClass:"rborder",staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DLI belichting")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":(_vm.aantalsystemen + 2)}},[_vm._v("Energie (kWh/m"),_c('sup',[_vm._v("2")]),_vm._v(")")])]:[_c('th')]],2),_vm._v(" "),_c('tr',{staticStyle:{"visibility":"collapse"}},[_c('th',{staticClass:"rborder"},[_vm._v("Datum")]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',{staticClass:"rborder"},[_vm._v("C")])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar)?[_c('th',[_vm._v("(mol/m"),_c('sup',[_vm._v("2")]),_vm._v(")")]),_vm._v(" "),_vm._l((_vm.aantalsystemen),function(i){return [_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i))])]}),_vm._v(" "),_c('th',[_vm._v("T")]),_vm._v(" "),_c('th',[_vm._v("C")])]:[_c('th')]],2),_vm._v(" "),_vm._l((_vm.model.werkelijkebelichting_n),function(werkelijk,indexi){return _c('tr',[_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.datumDDMMYYYY(werkelijk.datum)))]),_vm._v(" "),(_vm.ideaalzichtbaar)?[_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modellichtintegratie.klassiekebelichting_n[indexi].dliBelichting)))]),_vm._v(" "),_vm._l((_vm.modellichtintegratie.klassiekebelichting_n[indexi].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.energieideaal[indexi].systeem[indexk].kwh)))])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieideaaltotaal[indexi])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energieideaalcumulatief[indexi])))])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.voorstelzichtbaar && _vm.voorstelbestaat)?[(_vm.voorstelbestaat)?_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modelvoorstel.werkelijkebelichting_n[indexi].dliBelichting)))]):_vm._e(),_vm._v(" "),(_vm.voorstelbestaat)?[_vm._l((_vm.modelvoorstel.werkelijkebelichting_n[indexi].systemen),function(systeem,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.energievoorstel[indexi].systeem[indexk].kwh)))])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energievoorsteltotaal[indexi])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energievoorstelcumulatief[indexi])))])]:_vm._e()]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.werkelijkzichtbaar)?[_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.dlitotaal[indexi])))]),_vm._v(" "),_vm._l((_vm.model.werkelijkebelichting_n[indexi].werkelijkperdag_n),function(werkelijkperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.energiewerkelijk[indexi].werkelijkperdag[indexk].kwh)))])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energiewerkelijktotaal[indexi])))]),_vm._v(" "),_c('td',{staticClass:"rborder"},[_vm._v(_vm._s(_vm.komma2(_vm.energiewerkelijkcumulatief[indexi])))])]:[_c('th',{staticClass:"rborder"})],_vm._v(" "),(_vm.urenzichtbaar && _vm.urenbestaat)?[(_vm.urenbestaat)?_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.modelklassiekeuren.klassiekebelichting_n[indexi].dliBelichting)))]):_vm._e(),_vm._v(" "),(_vm.urenbestaat)?[_vm._l((_vm.modelklassiekeuren.klassiekebelichting_n[indexi].klassiekperdag_n),function(klassiekperdag,indexk){return [_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiek[indexi].klassiekperdag[indexk].kwh)))])]}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiektotaal[indexi])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.komma2(_vm.energieklassiekcumulatief[indexi])))])]:_vm._e()]:[_c('th')]],2)})],2)]),_c('span',{staticStyle:{"float":"right","width":"40px"}},[_vm._v(" ")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.werkelijkbestaat && _vm.currentview == 'grafiek'),expression:"werkelijkbestaat && currentview == 'grafiek'"}],staticClass:"row animated fadeIn"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"card-title mb-0"},[_vm._v("Cumulatief elektriciteitsverbruik")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("kWh/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),_c('chart',{staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"10px","margin-bottom":"40px"},attrs:{"chart-data":_vm.datacollection,"height":"400","miny":_vm.miny,"maxy":_vm.maxy,"changeyaxis":_vm.changeyaxis}})],1)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveItem($event)}}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.werkelijkbestaat),expression:"werkelijkbestaat"}],attrs:{"type":"submit","variant":"primary"}},[_c('span',[_vm._v("Opslaan")])]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.werkelijkbestaat),expression:"!werkelijkbestaat"}],attrs:{"type":"button","variant":"primary"},on:{"click":_vm.createschema}},[_vm._v("Formulier creëren")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Annuleren")])],1)])]):_vm._e(),_vm._v(" "),(_vm.urenopgehaaldenbestaatniet)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"red"},[_vm._v("Er bestaat nog geen klassiek belichtingsschema voor deze teelt. Gelieve dit eerst te creëren.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.back}},[_vm._v("Terug")])],1)]):_vm._e()])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"modellichtintegratie":_vm.modellichtintegratie,"invloedspercentages":_vm.invloedspercentages,"modelvoorstel":_vm.modelvoorstel,"modelklassiekeuren":_vm.modelklassiekeuren,"isEditing":true},on:{"save-item":_vm.updateItem,"create-schema":_vm.createSchema,"save-refresh":_vm.saveRefresh}}),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Wijzigen","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_vm._v("\n        FOUT: Data werden niet aangepast! "+_vm._s(_vm.errormsg)+"\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Formulier creëren","size":"sm"},model:{value:(_vm.warningGeduld),callback:function ($$v) {_vm.warningGeduld=$$v},expression:"warningGeduld"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Even geduld a.u.b.")])]),_vm._v(" "),_c('p',[_c('fadeloader',{staticClass:"spinner",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1),_vm._v(" "),_c('p',[_vm._v(" "),_c('br'),_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Formulier wordt gecreëerd. Deze bewerking kan even duren.")])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Formulier creëren","size":"sm"},on:{"ok":_vm.closedialog},model:{value:(_vm.warningSchema),callback:function ($$v) {_vm.warningSchema=$$v},expression:"warningSchema"}},[_vm._v("\n        FOUT: Formulier werd niet gecreëerd! "+_vm._s(_vm.errormsg)+"\n    ")])],1):_c('div',{staticClass:"midden"},[_c('div',{staticStyle:{"color":"#20a8d8","font-size":"large"}},[_vm._v("Even geduld a.u.b.")]),_vm._v(" "),_c('fadeloader',{staticClass:"spinner2",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Voorspelling_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76e14a17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Voorspelling_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Voorspelling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76e14a17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Voorspelling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_voorspellingsplaats__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_voorspelling__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilterFormVoorspelling__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LineChartR0__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BarChart__ = __webpack_require__(612);









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showgrafiek: false,
            voorspellingsplaatsen: [],
            vandaag: '2018-01-01',
            currentFilter: {
                voorspellingsplaats: 1,
                periode: 0
            },
            chartFilter: {
                voorspellingsplaats: '',
                periode: -1
            },
            transitionFilter: {
                periode: -1
            },
            datacollection: {
                labels: [''],
                datasets: [{
                    label: '',
                    data: [10]
                }]
            }
        };
    },

    computed: {
        intervaltekst: function intervaltekst() {
            switch (this.chartFilter.periode) {
                case 0:
                    return 'vandaag (' + __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(this.vandaag) + ')';
                case 1:
                    return 'morgen (' + __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(this.vandaag) + ')';
                case 2:
                    return '+5 dagen';
                default:
                    return '';
            }
        },
        voorspellingsplaatstekst: function voorspellingsplaatstekst() {
            var _this = this;

            return this.voorspellingsplaatsen.find(function (v) {
                return v.id === _this.chartFilter.voorspellingsplaats;
            }).plaats;
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1__api_voorspellingsplaats__["a" /* default */].getAllVoorspellingsplaats().then(function (response) {
            _this2.voorspellingsplaatsen = response.data;
            _this2.currentFilter.voorspellingsplaats = _this2.voorspellingsplaatsen[0].id;
        });
    },

    methods: {
        getForecastData: function getForecastData() {
            var _this3 = this;

            if (this.chartFilter.periode !== this.currentFilter.periode) {
                this.transitionFilter.periode = -1;
            }
            this.chartFilter.voorspellingsplaats = this.currentFilter.voorspellingsplaats;
            this.chartFilter.periode = this.currentFilter.periode;

            switch (this.chartFilter.periode) {
                case 0:
                case 1:
                    __WEBPACK_IMPORTED_MODULE_2__api_voorspelling__["a" /* default */].getDetailvoorspelling(this.chartFilter.voorspellingsplaats, this.chartFilter.periode).then(function (response) {
                        if (response.data.length !== 0) {
                            _this3.vandaag = response.data[0].datum;
                        }
                        _this3.showgrafiek = true;
                        var labels = [];
                        var data = [];
                        _this3.formatdetailresults(response.data, labels, data);
                        _this3.fillData(_this3.voorspellingsplaatstekst, labels, data);
                        _this3.transitionFilter.periode = _this3.chartFilter.periode;
                    });
                    break;
                case 2:
                    __WEBPACK_IMPORTED_MODULE_2__api_voorspelling__["a" /* default */].getDagvoorspelling(this.chartFilter.voorspellingsplaats).then(function (response) {
                        _this3.showgrafiek = true;
                        var labels = [];
                        var data = [];
                        _this3.formatdayresults(response.data, labels, data);
                        _this3.fillData(_this3.voorspellingsplaatstekst, labels, data);
                        _this3.transitionFilter.periode = _this3.chartFilter.periode;
                    });
                    break;
                default:
                    break;
            }
        },
        fillData: function fillData(label, labels, data) {
            this.datacollection = {
                labels: labels,
                datasets: [{
                    label: 'Zonlicht',
                    backgroundColor: 'rgba(0, 204, 204, 0.2)',
                    borderColor: 'rgba(0, 204, 204, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    data: data
                }]
            };
        },
        formatdetailresults: function formatdetailresults(reponsedata, labels, data) {
            reponsedata.forEach(function (rdata) {
                labels.push(rdata.label.substring(0, 5));
                data.push(rdata.waarde);
            });
        },
        formatdayresults: function formatdayresults(reponsedata, labels, data) {
            reponsedata.forEach(function (rdata) {
                labels.push([__WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__["a" /* default */].stringdagVoluit(rdata.label), __WEBPACK_IMPORTED_MODULE_0__helpers_datefunctions__["a" /* default */].datetoDDMMYYYY(rdata.label)]);
                data.push(rdata.waarde);
            });
        }
    },
    components: {
        'filter-form': __WEBPACK_IMPORTED_MODULE_3__FilterFormVoorspelling__["a" /* default */],
        linechart: __WEBPACK_IMPORTED_MODULE_4__LineChartR0__["a" /* default */],
        barchart: __WEBPACK_IMPORTED_MODULE_5__BarChart__["a" /* default */]
    }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getAllVoorspellingsplaats',
        value: function getAllVoorspellingsplaats() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/voorspellingsplaats/allbyplaats');
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(11);




var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getDetailvoorspelling',
        value: function getDetailvoorspelling(voorspellingsplaatsId, dagverschil) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/detailvoorspelling/fromplaats?voorspellingsplaats_id=' + voorspellingsplaatsId + '&dagverschil=' + dagverschil);
        }
    }, {
        key: 'getDagvoorspelling',
        value: function getDagvoorspelling(voorspellingsplaatsId) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/dagvoorspelling/fromplaats?voorspellingsplaats_id=' + voorspellingsplaatsId);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterFormVoorspelling_vue__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790a115a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterFormVoorspelling_vue__ = __webpack_require__(609);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterFormVoorspelling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790a115a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterFormVoorspelling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FilterForm',
    props: ['voorspellingsplaatsen', 'currentFilter', 'get-forecast-data'],
    methods: {
        retrieveData: function retrieveData() {
            this.$emit('get-forecast-data');
        },
        changePeriode: function changePeriode(i) {
            this.currentFilter.periode = i;
        }
    }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-graph icons font-1xl"}),_c('strong',[_vm._v(" Weer")]),_vm._v(" "),_c('small',[_vm._v("\n                    voorspelling\n                ")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.retrieveData($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"voorspellingsplaats"}},[_vm._v("Plaats")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.voorspellingsplaats),expression:"currentFilter.voorspellingsplaats"}],staticClass:"form-control",attrs:{"type":"text","name":"voorspellingsplaats","id":"voorspellingsplaats"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "voorspellingsplaats", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._v(">\n                                "),_vm._l((_vm.voorspellingsplaatsen),function(voorspellingsplaats){return [_c('option',{domProps:{"value":voorspellingsplaats.id,"selected":voorspellingsplaats.id == _vm.currentFilter.voorspellingsplaats}},[_vm._v(_vm._s(voorspellingsplaats.plaats))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label"},[_vm._v("Periode")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button-group',{attrs:{"id":"periode","name":"periode"}},[_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentFilter.periode == 0},on:{"click":function($event){_vm.changePeriode(0)}}},[_vm._v("vandaag")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentFilter.periode == 1},on:{"click":function($event){_vm.changePeriode(1)}}},[_vm._v("morgen")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-secondary","pressed":_vm.currentFilter.periode == 2},on:{"click":function($event){_vm.changePeriode(2)}}},[_vm._v("+5 dagen")])],1),_vm._v("\n                             \n                        ")],1)])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"outline-primary"}},[_vm._v("Tonen")])],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR0_vue__ = __webpack_require__(611);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR0_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    mixins: [reactiveProp],
    data: function data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__ = __webpack_require__(613);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    mixins: [reactiveProp],
    data: function data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        barThickness: 50,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('filter-form',{attrs:{"voorspellingsplaatsen":_vm.voorspellingsplaatsen,"currentFilter":_vm.currentFilter},on:{"get-forecast-data":_vm.getForecastData}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showgrafiek)?_c('b-card',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v(_vm._s(_vm.voorspellingsplaatstekst))]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.intervaltekst))])])]),_vm._v(" "),((_vm.transitionFilter.periode == -1))?_c('div',{staticStyle:{"height":"300px","margin-top":"40px"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"small text-muted"},[_vm._v("mol/m"),_c('sup',[_vm._v("2")])]),_vm._v(" "),((_vm.transitionFilter.periode == 0 || _vm.transitionFilter.periode == 1))?_c('linechart',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chart-data":_vm.datacollection}}):_vm._e(),_vm._v(" "),((_vm.transitionFilter.periode == 2))?_c('barchart',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chart-data":_vm.datacollection}}):_vm._e()],1):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9ad372_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9ad372_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_weerstation_weerstation__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LineChartR0__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LineChartR1__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LineChartR2__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BarChartR2__ = __webpack_require__(626);












/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            nl: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__["a" /* nl */],
            showeerstetabel: true,
            showgrafiek: false,
            dataaanvraagok: false,
            grafiektype: 0,
            parametertekst: '',
            eenheid: '',
            waardetekst: '',
            intervaltekst: '',
            aantaldagen: 0,
            parameters: [{ 'id': 0,
                'field': 'Temperatuur',
                'name': 'Temperatuur' }, { 'id': 2,
                'field': 'Zon',
                'name': 'Zonlicht' }, { 'id': 1,
                'field': 'PAR',
                'name': 'PAR' }, { 'id': 3,
                'field': 'RV',
                'name': 'Relatieve vochtigheid' }, { 'id': 4,
                'field': 'Neerslag',
                'name': 'Neerslag' }],
            samenvatting: {},
            currentFilter: {
                parameter: 0,
                datumVan: new Date(),
                datumTot: new Date()
            },
            downloadFilter: {
                naam: '',
                voornaam: '',
                email: '',
                datum_van: new Date(),
                datum_tot: new Date()
            },
            disabledDates: {
                to: new Date(),
                from: new Date()
            },
            highlighted: {
                dates: [new Date()]
            },
            datacollection: {
                labels: [''],
                datasets: [{
                    label: '',
                    data: [10]
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api_weerstation_weerstation__["a" /* default */].getHomepageTable().then(function (response) {
            _this.samenvatting = response.data;
            _this.disabledDates.to = new Date(_this.samenvatting.interval.datumVan);
            _this.disabledDates.to.setDate(_this.disabledDates.to.getDate() - 1);
            _this.disabledDates.from = new Date(_this.samenvatting.interval.datumTot);
            _this.disabledDates.from.setDate(_this.disabledDates.from.getDate() + 1);
            _this.fillGraphData();
        });
    },

    methods: {
        datetimetoHHMM: function datetimetoHHMM(datetime) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetimetoHHMM(datetime);
        },
        datetimetoDDMMYYYY: function datetimetoDDMMYYYY(datetime) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetimetoDDMMYYYY(datetime);
        },
        changeFromDate: function changeFromDate() {
            if (this.currentFilter.datumVan > this.currentFilter.datumTot) {
                var nieuweTot = this.addDays(this.currentFilter.datumVan, this.aantaldagen);
                if (nieuweTot > this.disabledDates.from) {
                    this.currentFilter.datumTot = this.addDays(this.disabledDates.from, -1);
                } else {
                    this.currentFilter.datumTot = nieuweTot;
                }
            }
            this.aantaldagen = this.daysdiff(this.currentFilter.datumVan, this.currentFilter.datumTot);
            this.fillGraphData();
        },
        changeToDate: function changeToDate() {
            if (this.currentFilter.datumTot < this.currentFilter.datumVan) {
                var nieuweVan = this.addDays(this.currentFilter.datumTot, -this.aantaldagen);
                if (nieuweVan < this.disabledDates.to) {
                    this.currentFilter.datumVan = new Date(this.disabledDates.to);
                } else {
                    this.currentFilter.datumVan = nieuweVan;
                }
            }
            this.aantaldagen = this.daysdiff(this.currentFilter.datumVan, this.currentFilter.datumTot);
            this.fillGraphData();
        },
        addDays: function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        daysdiff: function daysdiff(date1, date2) {
            var timeDiff = Math.abs(date2 - date1);
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDays;
        },
        addDownload: function addDownload() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    __WEBPACK_IMPORTED_MODULE_0__api_weerstation_weerstation__["a" /* default */].addDownload(_this2.downloadFilter).then(function () {
                        _this2.dataaanvraagok = true;
                        var self = _this2;
                        setTimeout(function () {
                            self.dataaanvraagok = false;
                        }, 10000);
                    }, function (error) {
                        console.log(error.message);
                    });
                }
            });
        },
        fillGraphData: function fillGraphData() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0__api_weerstation_weerstation__["a" /* default */].getValues(this.currentFilter.parameter, this.currentFilter.datumVan, this.currentFilter.datumTot).then(function (response) {
                _this3.showgrafiek = true;
                _this3.grafiektype = response.data.grafiektype;
                _this3.intervaltekst = response.data.intervaltekst;
                _this3.parametertekst = response.data.parameter;
                _this3.waardetekst = response.data.waarde;
                _this3.eenheid = response.data.eenheid;
                var labels = [];
                var data = [];

                _this3.formatresults(response.data.waarden, labels, data);
                _this3.fillData(_this3.waardetekst, labels, data);

                if (_this3.grafiektype == 2 && _this3.currentFilter.parameter == 0) {
                    var dataMin = [];
                    var dataMax = [];
                    _this3.formatMinMaxresults(response.data.waarden, dataMin, dataMax);
                    _this3.AddMinMaxData(dataMin, dataMax);
                }

                if (_this3.grafiektype == 2 && _this3.currentFilter.parameter == 4) {
                    _this3.datacollection.datasets[0].backgroundColor = 'rgba(0, 204, 204, 0.2)';
                }
            });
        },
        formatMinMaxresults: function formatMinMaxresults(reponsedata, dataMin, dataMax) {
            reponsedata.forEach(function (rdata) {
                dataMin.push(rdata.minwaarde);
                dataMax.push(rdata.maxwaarde);
            });
        },
        formatresults: function formatresults(reponsedata, labels, data) {
            reponsedata.forEach(function (rdata) {
                labels.push(rdata.label);
                data.push(rdata.waarde);
            });
        },
        fillData: function fillData(label, labels, data) {
            this.datacollection = {
                labels: labels,
                datasets: [{
                    label: label,
                    backgroundColor: 'rgba(0, 204, 204, 0)',
                    borderColor: 'rgba(0, 204, 204, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    data: data
                }]
            };
        },
        AddMinMaxData: function AddMinMaxData(dataMin, dataMax) {
            this.datacollection.datasets.push({
                label: 'minimum',
                backgroundColor: 'rgba(255, 128, 0, 0)',
                borderColor: 'rgba(255, 128, 0, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: dataMin
            });
            this.datacollection.datasets.unshift({
                label: 'maximum',
                backgroundColor: 'rgba(255,20,147, 0)',
                borderColor: 'rgba(255,20,147, 1)',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: dataMax
            });
        },
        komma2: function komma2(waarde) {
            if (waarde == null) {
                return '#.##';
            }
            return waarde.toFixed(2);
        },
        komma1: function komma1(waarde) {
            if (waarde == null) {
                return '#.#';
            }
            return waarde.toFixed(1);
        },
        komma0: function komma0(waarde) {
            if (waarde == null) {
                return '#';
            }
            return waarde.toFixed(0);
        }
    },
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
        chart0: __WEBPACK_IMPORTED_MODULE_4__LineChartR0__["a" /* default */],
        chart1: __WEBPACK_IMPORTED_MODULE_5__LineChartR1__["a" /* default */],
        chart2: __WEBPACK_IMPORTED_MODULE_6__LineChartR2__["a" /* default */],
        chart2b: __WEBPACK_IMPORTED_MODULE_7__BarChartR2__["a" /* default */]
    }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__ = __webpack_require__(10);





var Api = function () {
    function Api() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, null, [{
        key: 'getHomepageValues',
        value: function getHomepageValues() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/weerstation1/homepagevalues');
        }
    }, {
        key: 'getHomepageTable',
        value: function getHomepageTable() {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/weerstation1/homepagetable');
        }
    }, {
        key: 'getValues',
        value: function getValues(parameter, datumVan, datumTot) {
            var vdatum = __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDD(datumVan);
            var tdatum = __WEBPACK_IMPORTED_MODULE_3__helpers_datefunctions__["a" /* default */].datetoYYYYMMDD(datumTot);
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/weerstation1/values?parameter=' + parameter + '&datumVan=' + vdatum + '&datumTot=' + tdatum);
        }
    }, {
        key: 'addDownload',
        value: function addDownload(payload) {
            return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/download', payload);
        }
    }]);

    return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "https://weerstation.energieberekeningen.com"
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR0_vue__ = __webpack_require__(621);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR0_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    mixins: [reactiveProp],
    data: function data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {},
                        ticks: {
                            autoSkip: false,
                            callback: function callback(dataLabel, index) {
                                if (dataLabel.substring(11, 16) == "00:00" || dataLabel.substring(11, 16) == "06:00" || dataLabel.substring(11, 16) == "12:00" || dataLabel.substring(11, 16) == "18:00") {
                                    return dataLabel;
                                } else {
                                    return undefined;
                                }
                            }
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR1_vue__ = __webpack_require__(623);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR1_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    mixins: [reactiveProp],
    data: function data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {},
                        ticks: {
                            autoSkip: false,
                            callback: function callback(dataLabel, index) {
                                if (dataLabel.substring(11, 16) == "00:00") {
                                    return dataLabel.substring(0, 10);
                                } else {
                                    return undefined;
                                }
                            }
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR2_vue__ = __webpack_require__(625);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartR2_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    mixins: [reactiveProp],
    data: function data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {}
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChartR2_vue__ = __webpack_require__(627);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChartR2_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(12);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    mixins: [reactiveProp],
    data: function data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {}
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.renderChart(this.chartData, this.options);
    }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.samenvatting).length !== 0)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-cloud-download icons font-1xl"}),_c('strong',[_vm._v(" Weerstation")]),_vm._v(" "),_c('small',[_vm._v("\n                        laatst gemeten waarden om "+_vm._s(_vm.datetimetoHHMM(_vm.samenvatting.weekterug.metingen[0].datetime_real))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.metingen),function(dag){return [_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.datetimetoDDMMYYYY(dag.datetime_real)))])]})],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Temperatuur (°C)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.metingen),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma1(dag.Temperatuur_gem)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Zonlicht (W/m²)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.metingen),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma0(dag.Zon_gem)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("PAR (µmol/m²s)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.metingen),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma0(dag.PAR_gem)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Relatieve vochtigheid (%)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.metingen),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma0(dag.RV_gem)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Neerslag (mm/dag)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma1(dag.somneerslag)))])]})],2)])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-cloud-download icons font-1xl"}),_c('strong',[_vm._v(" Weerstation")]),_vm._v(" "),_c('small',[_vm._v("\n                        dagwaarden\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-sm"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(dag.label))])]})],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Minimum temperatuur (°C)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma1(dag.mintemp)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Maximum temperatuur (°C)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma1(dag.maxtemp)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Zonlicht (MJ/m²)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma2(dag.somzonlicht)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("DLI (mol/m²)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma2(dag.somdli)))])]})],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Neerslag (mm/dag)")]),_vm._v(" "),_vm._l((_vm.samenvatting.weekterug.dagwaarden),function(dag){return [_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.komma1(dag.somneerslag)))])]})],2)])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-card',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"parameter"}},[_vm._v("Parameter")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentFilter.parameter),expression:"currentFilter.parameter"}],staticClass:"form-control",attrs:{"type":"text","name":"parameter","id":"parameter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentFilter, "parameter", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.fillGraphData]}},[_vm._l((_vm.parameters),function(parameter){return [_c('option',{domProps:{"value":parameter.id,"selected":parameter.id == _vm.currentFilter.parameter}},[_vm._v(_vm._s(parameter.name))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"begindatum"}},[_vm._v("Van")]),_vm._v(" "),_c('datepicker',{ref:"begindatum",attrs:{"highlighted":_vm.highlighted,"disabled-dates":_vm.disabledDates,"required":true,"bootstrapStyling":true,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"begindatum","id":"begindatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.changeFromDate()}},model:{value:(_vm.currentFilter.datumVan),callback:function ($$v) {_vm.$set(_vm.currentFilter, "datumVan", $$v)},expression:"currentFilter.datumVan"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"einddatum"}},[_vm._v("Tot")]),_vm._v(" "),_c('datepicker',{ref:"einddatum",staticStyle:{"background-color":"#ffffff"},attrs:{"highlighted":_vm.highlighted,"disabled-dates":_vm.disabledDates,"required":true,"bootstrapStyling":true,"full-month-name":true,"language":_vm.nl,"monday-first":true,"name":"einddatum","id":"einddatum","format":"d MMMM yyyy","minimumView":"day","maximumView":"year","initialView":"day"},on:{"input":function($event){_vm.changeToDate()}},model:{value:(_vm.currentFilter.datumTot),callback:function ($$v) {_vm.$set(_vm.currentFilter, "datumTot", $$v)},expression:"currentFilter.datumTot"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.showgrafiek)?_c('div',[_c('br'),_vm._v(" "),_c('span',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.eenheid))]),_vm._v(" "),(_vm.grafiektype == 0)?_c('div',[_c('chart0',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chart-data":_vm.datacollection}})],1):_vm._e(),_vm._v(" "),(_vm.grafiektype == 1)?_c('div',[_c('chart1',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chart-data":_vm.datacollection}})],1):_vm._e(),_vm._v(" "),(_vm.grafiektype == 2 && _vm.currentFilter.parameter == 4)?_c('div',[_c('chart2b',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chart-data":_vm.datacollection}})],1):_vm._e(),_vm._v(" "),(_vm.grafiektype == 2 && _vm.currentFilter.parameter != 4)?_c('div',[_c('chart2',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"chart-data":_vm.datacollection}})],1):_vm._e()]):_vm._e()])])])],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[224]);


// WEBPACK FOOTER //
// static/js/app.e5689fe1eed85b0332e3.js